const messagesIT = {
    code: "it",
    messages: {
        zoho: {
            SETTING_GROUP: "Impostazioni",
            usermapping: "Mappatura utenti",
        },
        chatWindow: {
            thereIsNoChatContent: "Nessun contenuto della chat disponibile.",
            thereIsNoChatContentDsc: "Qui puoi visualizzare il contenuto della chat e inviare messaggi.",
            interactions: "Interazioni:",
            departments: "Dipartimenti",
            channels: "Canali",
            date: "Data",
            lastChatStatus: "Ultimo stato della chat",
            all: "Tutti",
            queued: "In coda",
            open: "Aperto",
            closed: "Chiuso",
            private: "Privato",
            chatbot: "Chatbot",
            lostMissed: "Perso / Mancato",
            interaction: "Interazione",
            myActiveInbox: "La mia posta in arrivo attiva",
            activeQueueInbox: "Posta in arrivo attiva + in coda",
            chatbotActiveInbox: "Posta in arrivo attiva del chatbot",
            myDepartmentsActiveInbox: "Posta in arrivo attiva dei miei dipartimenti",
            notInteractedYesterday: "Nessuna interazione ieri",
            queueInbox: "Posta in arrivo in coda",
            whatsappActiveInbox: "Posta in arrivo attiva di WhatsApp",
            socialMediaActiveInbox: "Posta in arrivo attiva dei social media",
            missedThisMonth: "Chat perse questo mese",
            chooseAFileOrDragItHere: "Scegli un file o trascinalo qui!",
            watching: "Osservando",
            selectFilter: "Seleziona filtro",
            clearAll: "Cancella tutto",
            me: "Io",
            today: "Oggi",
            yesterday: "Ieri",
            thisWeek: "Questa settimana",
            lastWeek: "La scorsa settimana",
            last7Days: "Ultimi 7 giorni",
            last30Days: "Ultimi 30 giorni",
            thisMonth: "Questo mese",
            lastMonth: "Il mese scorso",
            last24h: "Ultime 24 ore",
            custom: "Personalizzato",
            startMessage: "Avvia messaggio",
            goToAgentReport: "Vai al rapporto dell'agente",
            agentDetail: "Dettagli agente",
            agentList: "Elenco agenti",
            selectedFilter: "Filtro selezionato",
            groupBy: "Raggruppa",
            none: "Nessun gruppo",
            agent: "Rappresentante",
            department: "Dipartimento",
            tag: "Etichetta",
            website: "Sito web",
            channel: "Canale",
            platform: "Piattaforma",
            answerStatus: "Yanıt Durumu",
            sortBy: "Ordina",
            lastPostAbove: "Ultimo post in alto",
            newChatsAbove: "Nuove chat in alto",
            oldChatsAbove: "Vecchie chat in alto",
            live: "Vivere",
            systemStatus: "Stato del sistema",
            refresh: "Aggiorna",
            close: "Chiudi",
            totalCustomers: "Totale clienti",
            totalAnswered: "Totale risposte",
            waitingAnswer: "In attesa di risposta",
            totalAgentInChat: "Numero totale di agenti in chat",
            onlineAgentCount: "Numero di agenti online",
            totalCustomer: "Totale cliente",
            answered: "Risposto",
            unanswered: "Senza risposta",
            noContactWasFoundMatchingTheCurrentFilters:
                "Nessun contatto corrispondente ai filtri attuali è stato trovato.",
            you: "Tu",
            others: "Altri",
            queue: "Coda",
            chatbotContact: "Chatbot",
            closedContact: "Chiuso",
            myInteractions: "Le mie interazioni",
            special: "Speciale",
            allInteractions: "Tutti i contatti",
            waiting: "In attesa",
            departmentToWhichItIsAffiliated: "Dipartimento a cui è affiliato",
        },
        form: {
            title: {
                titleSettings: "Impostazioni del titolo",
                fullNameSettings: "Impostazioni del nome completo",
                emailSettings: "Impostazioni e-mail",
                addressSettings: "Impostazioni dell'indirizzo",
                phoneSettings: "Impostazioni del telefono",
                datePickerSettings: "Impostazioni del selettore di data",
                shortTextSettings: "Impostazioni testo breve",
                longTextSettings: "Impostazioni testo lungo",
                dropDownListSettings: "Impostazioni elenco a discesa",
                singleChoiceSettings: "Impostazioni scelta singola",
                multipleSelectionSettings: "Impostazioni selezione multipla",
                numberSettings: "Impostazioni dei numeri",
                hourSettings: "Impostazioni dell'ora",
                spinnerSettings: "Impostazioni dello spinner",
                sendSettings: "Impostazioni di invio",
                starRatingSettings: "Impostazioni della valutazione a stelle",
                ratingScaleSettings: "Impostazioni della scala di valutazione",
                separationElementSettings: "Impostazioni elemento di separazione",
                fileUploadSettings: "Impostazioni caricamento file",
                imageSettings: "Impostazioni immagine"
            },
            lineColor: "Colore della linea",
            separatorColorInfo: "Seleziona o inserisci il colore del separatore (ad esempio, #RRGGBB)",
            separatorHeight: "Altezza del separatore",
            separatorHeightInfo: "Inserisci l'altezza del separatore",
            bottomSpace: "Spazio inferiore",
            bottomSpaceInfo: "Aggiungi spazio sotto il separatore",
            topSpace: "Spazio superiore",
            topSpaceInfo: "Aggiungi spazio sopra il separatore",
            sideSpace: "Spazio laterale",
            sideSpaceInfo: "Aggiungi spazio a sinistra e a destra del separatore",
            onlyImageUpload: "Puoi caricare solo un'immagine!",
            imageSizeLimit: "La dimensione della tua immagine non deve superare i 5 MB!",
            image: "Immagine",
            size: "Dimensione",
            width: "Larghezza",
            height: "Altezza",
            imageAlignment: "Allineamento dell'immagine",
            wide: "Largo",
            small: "Piccolo",
            textAlignment: "Allineamento del testo",
            chooseHorizontalAlignment: "Scegli come allineare orizzontalmente questo titolo.",
            headerSize: "Dimensione dell'intestazione",
            addSmallTextBelowHeader: "Aggiungi un testo più piccolo sotto l'intestazione",
            subHeaderText: "Testo del sottotitolo",
            subLabel1: "Sottolabel(1)",
            subLabel2: "Sottolabel(2)",
            validPhoneNumber: "Per favore inserisci un numero di telefono valido",
            masked: "Mascherato",
            copyField: "Copia campo",
            copyFieldDescription: "Crea una copia di questo campo mantenendo tutte le sue impostazioni salvate",
            enterQuestion: "Inserisci una domanda",
            notRequired: "Non richiesto",
            addDescriptionBelowField: "Aggiungi una breve descrizione sotto il campo",
            setDefault: "Imposta come predefinito",
            pleaseSelect: "Per favore seleziona",
            placeholder: "Segnaposto",
            required: "Obbligatorio",
            fieldEmptyError: "Non consentire l'invio del modulo se questo campo è vuoto",
            subLabels: "Sotto etichette",
            addressLine1: "Riga indirizzo 1",
            addressLine2: "Riga indirizzo 2",
            postalCode: "Codice postale",
            stateProvince: "Stato / Provincia",
            chooseLabelAlignment: "Scegli come allineare il testo dell'etichetta orizzontalmente",
            right: "DESTRA",
            left: "SINISTRA",
            top: "SOPRA",
            labelAlignment: "Allineamento etichetta",
            fieldLabel: "Etichetta campo",
            read: "Letto",
            itemsPerPage: "elementi/pagina",
            downloadAllDataAsPDF: "Scarica tutti i dati in formato PDF",
            downloadAllDataAsExcel: "Scarica tutti i dati in formato Excel",
            downloadSelectedDataAsPDF: "Scarica i dati selezionati in formato PDF",
            downloadSelectedDataAsExcel: "Scarica i dati selezionati in formato Excel",
            selectItemToViewDetails: "Seleziona un elemento per visualizzare i dettagli.",
            deleteFormConfirm:
                "Se elimini questo modulo, tutti i dati associati verranno eliminati definitivamente. Sei sicuro di voler continuare?",
            redicetFormAnswer: "FORWARD FORM ANSWERS",
            redicetFormAnswerDesc:
                "Quando si reindirizzano le risposte del modulo al sistema dei ticket, assicurarsi di richiedere all'utente un numero di telefono o un indirizzo e-mail nel modulo. Queste informazioni sono importanti per una comunicazione più rapida ed efficace con l'utente.",
            redicetFormAnswerDesc2: "Le risposte del modulo vengono indirizzate al sistema come ticket.",
            rediectAnswersToTicket: "Reindirizza le risposte in arrivo a un biglietto.",
            errorTicketMode: "Errore nell'aggiornamento della modalità ticket:",
            formView: "Visualizza modulo",
            formEdit: "Modulo di aggiornamento",
            totalResponse: "Risposta totale",
            totalUnreadResponse: "Totale risposte non lette",
            totalReadResponse: "Risposta di lettura totale",
            totalArchivedResponse: "Totale risposta archiviata",
            singleChoice: "Scelta singola",
            _delete: "Cancellare",
            inbox: "Posta in arrivo",
            edit: "Modifica",
            forms: "Moduli",
            formsDesc: "Potete gestire i vostri moduli qui.",
            createaForm: "creare un modulo",
            allForms: "tutte le forme",
            formPublish: {
                shareFast: "CONDIVIDERE VELOCEMENTE",
                shareFastDesc: "Collegamento diretto al modulo e condivisione sui social",
                add: "ADD",
                addDesc: "Varie opzioni di incorporazione di pagine web",
                assignForm: "MODULO DI ASSEGNAZIONE",
                assignFormDesc: "Assegnate i vostri moduli ad altri",
                emails: "E-MAIL",
                emailsDesc: "Promemoria e condivisione immediata",
                prefill: "PREFILL",
                prefillDesc: "Prepagare i moduli",
                pdf: "PDF",
                pdfDesc: "Scarica il PDF compilabile",
                platforms: "PIATTAFORME",
                platformsDesc: "Opzioni di pubblicazione di terze parti",
                linkToYour: "INDIRIZZO DEL LINK DEL VOSTRO MODULO",
                linkToYourDesc:
                    "Il vostro modulo è stato pubblicato in modo sicuro ed è pronto per essere utilizzato a questo indirizzo.",
                shareWithLink: "CONDIVIDERE CON IL LINK",
                publicForm: "Modulo pubblico",
                copyLink: "COPIA LINK",
                openInNewTab: "APRIRE IN UNA NUOVA SCHEDA",
                linkCopied: "Link copiato",
                codeCopied: "Codice copiato",
                iframe: "IFRAME",
                iframeDesc: "Aggiungere il modulo alla pagina con iFrame",
                openWindow: "FINESTRA APERTA",
                openWindowDesc: "Collegamento a un modulo pop-up",
                formAddDesc: "Copiate e incollate questo snippet nel codice e inserite il modulo nel vostro sito web.",
            },
            formSettings: {
                enterNameForm: "Inserire un nome per questo modulo",
                selectStatusForm: "Selezionare lo stato del modulo",
                disabled: "Disabili",
                disableSpecifiedTime: "Disattivare in un momento specifico",
                disableFormResponse: "Disattivare quando viene raggiunto il limite di risposta del modulo",
                pageShownAfterForm: "La pagina visualizzata dopo l'invio del modulo",
                formNotFound: "Modulo non trovato.",
                errorLoadingform: "Si è verificato un errore durante il caricamento del modulo.",
                formUpdated: "Il titolo del modulo è stato aggiornato con successo.",
                formErrorUpdated: "Si è verificato un errore durante l'aggiornamento del titolo del modulo",
                formSettings: "IMPOSTAZIONI DEL MODULO",
                changeFormStateAndProperties: "Modificare lo stato e le proprietà del modulo",
                title: "Titolo",
                newFormSettings: "Impostazioni del nuovo modulo",
                formStatus: "Stato del modulo",
                activateOrDeactivate: "Attivare, disattivare o attivare in modo condizionato il vostro modulo",
                effective: "EFFICACE",
                yourFromIsVisible: "Il modulo è ora visibile e può ricevere le risposte del modulo.",
                emails: "E-MAIL",
                emailsDesc: "Inviare e-mail di autoresponder e di notifica",
                conditions: "CONDIZIONI",
                conditionsDesc: "Sezione di logica condizionale che attiva azioni in base agli input del modulo",
                thankYouPage: "PAGINA DEI RINGRAZIAMENTI",
                thankYouPageDesc: "La pagina visualizzata dopo l'invio del modulo",
                integretions: "INTEGRAZIONI",
                integretionsDesc: "Collegare il modulo ad altre applicazioni",
            },
            clickToDeleteYourLogo: "Fare clic per eliminare il logo",
            create: "Creare",
            settings: "Impostazioni",
            load: "Carico",
            insertFormField: "Inserisci campo modulo",
            addYourLogo: "Aggiungi il tuo logo",
            surveyElements: {
                surveyElements: "Elementi del sondaggio",
                dataTable: "Tabella dati",
                starRating: "Valutazione a stelle",
                evaluationScale: "Scala di valutazione",
            },
            pageElements: {
                pageElements: "Elementi della pagina",
                separationElement: "Elemento di separazione",
                partitionCollapse: "Crollo della partizione",
                pageBreak: "Fine della pagina",
            },
            basicElements: {
                basicElements: "Elementi di base",
                shortText: "Testo breve",
                longText: "Testo lungo",
                paragraph: "Paragrafo",
                dropDownList: "Elenco a discesa",
                singleChoice: "Elección única",
                multipleSelection: "Selección múltiple",
                number: "Número",
                image: "İmage",
                fileUpload: "Carga de archivos",
                hour: "Hora",
                spinner: "Spinner",
                send: "Inviare",
            },
            formElements: {
                formElements: "Elementi di forma",
                title: "Titolo",
                fullName: "Nome completo",
                email: "Email",
                address: "Indirizzo",
                phone: "Telefono",
                datePicker: "Selezionatore di date",
                appointment: "Appuntamento",
                signature: "Firma",
                productList: "Elenco dei prodotti",
            },
            startWithaBlankForm: "Iniziare con un modulo vuoto",
            startFromScratch: "Iniziare da zero",
            createOrTransferaForm: "Creare o trasferire un modulo per avviare la raccolta dei dati",
            createForm: "Creare un modulo",
        },
        automation: {
            calendarEventCreated: "Evento creato nel calendario",
            calendarEventUpdated: "Evento aggiornato nel calendario",
            calendarEventDeleted: "Evento eliminato dal calendario",
            reservationCreated: "Prenotazione creata",
            reservationDateChanged: "Data di prenotazione modificata",
            reservationDeleted: "Prenotazione eliminata",
            chatLost: "Quando la chat è persa",
            webchatCompleted: "Quando la chat web è completata",
            instagramCompleted: "Quando la chat dal canale Instagram è completata",
            messengerCompleted: "Quando la chat dal canale Messenger è completata",
            whatsappCompleted: "Quando la chat dal canale WhatsApp è completata",
            telegramCompleted: "Quando la chat dal canale Telegram è completata",
            chatAssignedToAgent: "Quando la chat è assegnata a un agente",
            profileButtonClicked: "Quando il pulsante di automazione viene cliccato dal profilo",
            operatedTask: "Attività in esecuzione",
            tableSelection: "Selezione tabella",
            selectTable: "Seleziona tabella",
            whichTableAutomationAddRecords:
                "Quale tabella si desidera eseguire l'automazione quando viene aggiunto un record? Selezionare",
            whichTableAutomationUpdateRecords:
                "Si desidera eseguire l'automazione quando viene aggiornato un record in quale tabella? Selezionare",
            whichTableAutomationDeletedRecords:
                "Da quale tabella si desidera eseguire l'automazione quando un record viene cancellato? Selezionare",
            whichTableAutomationClickRecords:
                "In quale tabella si desidera eseguire l'automazione quando si fa clic sul pulsante di automazione di un record? Selezionare",
            planStatus: "Stato del piano",
            scheduled: "Pianificato",
            completed: "Completato",
            cancelled: "Annullato",
            startTest: "Avvia test",
            unpublish: "Annulla pubblicazione",
            whenMessagePicked: "Quando viene selezionato un messaggio tramite l'interfaccia di chat",
            whenTaskCompleted: "Quando un'attività viene completata",
            whenTaskDeleted: "Quando un'attività viene eliminata",
            whenTaskAssigneeChanged: "Quando viene cambiato l'assegnatario di un compito",
            whenTaskPriorityChanged: "Quando la priorità di un'attività viene modificata",
            whenTaskDueDateChanged: "Quando la data di scadenza di un'attività viene modificata",
            whenTaskStatusChanged: "Quando lo stato di un'attività viene modificato",
            whenTaskArchived: "Quando un'attività viene archiviata",
            whenTagAdded: "Quando viene aggiunto un tag all'attività",
            whenTagRemovedTask: "Quando un tag viene rimosso da un'attività",
            whenTagChecklist: "Quando viene completata una lista di controllo dell'attività",
            whenReminderActivated: "Quando viene attivato un promemoria",
            whenTicketCreated: "Quando viene creato un biglietto",
            whenTicketStageChanged: "Quando viene modificata la fase di un ticket",
            whenTicketAssigneeChanged: "Quando viene cambiato l'assegnatario di un biglietto",
            whenTicketClosed: "Quando un ticket viene chiuso",
            whenTicketUpdated: "Quando un ticket viene aggiornato",
            autoPlanAndTaskHistory: "Piano di automazione e cronologia attività",
            automation: "Automazione",
            botScenario: "Scenario bot",
            nameSurname: "NomeCognome",
            phone164: "*Inserire nel formato E164. Ad esempio: 905396667744",
            whichWpChannels: "Quali canali Whatsapp aggiungere?",
            findContact: "Trova un contatto",
            findContacts: "Trova contatti",
            offsetDesc:
                "Salta i primi N contatti. Il valore predefinito è '0'. Utilizzare questo valore per scorrere i contatti",
            limitDesc:
                "Numero massimo di contatti da restituire dopo l'offset. Il valore predefinito è '10'. Usare questo valore per impaginare",
            contact: "Contatto",
            selectAction: "Seleziona azione",
            addMethod: "Metodo di aggiunta",
            selectField: "Seleziona campo",
            schedulerRunningPlanEx: "Esempio di piano di esecuzione dello scheduler",
            schedulerPlanner: "Pianificatore di pianificazione",
            taskCreated: "Attività creata?",
            taskStatus: "Stato dell'attività",
            terminateReason: "Motivo di terminazione",
            taskDuration: "Durata dell'attività",
            taskWakeUpCount: "Conteggio risvegli dell'attività",
            completedAt: "Completato",
            cancelledAt: "Annullato",
            nextRunAt: "Prossima esecuzione",
            configSchedulerAuto: "Configura il timer per l'automazione",
            saveChanges: "Salva le modifiche",
            catchAllWebhooks: "Cattura tutti i webhook da questo URL",
            webhookDataExPreview:
                "Anteprima del campione di dati del webhook (verrà mostrato dopo l'invio della richiesta)",
            webhookUrlCopied: "URL del webhook copiato negli appunti",
            selectAnBlock: "Seleziona un blocco",
            dataFormats: "Formati dei dati",
            whenRecordCreated: "Quando viene creato un record",
            whenRecordUpdated: "Quando un record viene aggiornato",
            whenRecordDelete: "Quando un record viene eliminato",
            whenRecordAutomation: "Quando viene fatto clic sul pulsante di automazione di un record",
            whenWebhookTriggered: "Quando viene attivato un webhook",
            whenChatCreated: "Quando viene creata una chat",
            whenChatClosed: "Quando una chat viene chiusa",
            whenChatRated: "Quando una chat viene valutata",
            whenNewContactCreated: "Quando viene creato un nuovo contatto",
            whenContactUpdate: "Quando viene aggiornato un contatto",
            whenContactPropUpdate: "Quando viene aggiornata una proprietà del contatto",
            whenNewTagAdded: "Quando viene aggiunto un nuovo tag",
            whenTagRemoved: "Quando un tag viene rimosso",
            whenNewEmailReceived: "Quando viene ricevuta una nuova e-mail",
            whenNewTaskCreated: "Quando viene creata una nuova attività",
            whenNewMetaleadCreated: "Quando viene creato un nuovo meta-lead",
            whenNewAgentCreated: "Quando viene creato un nuovo agente",
            whenNewInvoiceCreated: "Quando viene creata una nuova fattura",
            whenNewWpReceived: "Quando viene ricevuto un nuovo messaggio whatsapp",
            whenNewReservationCreated: "Quando viene creata una nuova prenotazione",
            whenNewChatbotReceived: "Quando viene ricevuto un nuovo messaggio chatbot",
            chatWebhookAutomation: "Catturare un webhook ed eseguire un'automazione",
            automationName: "Nome automazione",
            supsisObject: "Oggetto Supsis",
            selectModule: "Modello di selezione",
            bodyType: "Tipo di corpo",
            selectBodyType: "Seleziona il tipo di corpo",
            selectMethod: "Seleziona metodo",
            trigger: "Trigger",
            published: "Pubblicato",
            createdAt: "Creato a",
            action: "Azione",
            type: "Tipo",
            view: "Vista",
            createTimerAutomation: "Creare automazione basata su eventi",
            createEventBasedAutomation: "Creare l'automazione Webhook",
            createWebhookAutomation: "Creare l'automazione Webhook",
            automationsDeletedSuccessfully: "Automazioni eliminate con successo",
            automationsCouldNotBeDeleted: "Non è stato possibile eliminare le automazioni",
            timerAutomationCreatedSuccessfully: "Automazione timer creata con successo",
            eventAutomationCreatedSuccessfully: "Automazione evento creata con successo",
            webhookAutomationCreatedSuccessfully: "Automazione webhook creata con successo",
            automationsCouldNotBeFetched: "Non è stato possibile rilevare le automazioni",
            automationPublishedStateUpdatedSuccessfully: "Automazione Stato pubblicato aggiornato con successo",
            automazioni: "Automazioni",
            allAutomations: "Tutte le automazioni",
            scheduledAutomations: "Automazioni pianificate",
            eventBasedAutomations: "Automazioni basate su eventi",
            buttonAutomations: "Automazioni su pulsanti",
            webhookAutomations: "Automazioni webhook",
            blocks: {
                START_POINT: "PUNTO DI PARTENZA",
                AI_ASSISTANT: "ASSISTENTE AI",
                BOT_RESPONSE: "RISPOSTA DEL BOT",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "CLASSIFICAZIONE AI",
                AI_MENU_FLOW: "MENU AI",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "COMMENTO AI INSTAGRAM",
                PLATFORM_FLOW: "PIATTAFORMA",
                DEFAULT_FALLBACK: "FALLBACK PREDEFINITO",
                DEFAULT_TIMEOUT: "TIMEOUT PREDEFINITO",
                AI_FUNCTIONS: "FUNZIONI AI",
                FILTER: "FILTRO",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "INPUT DELL'ALLEGATO",
                USER_INPUT: "INPUT DELL'UTENTE",
                GO_TO_STEP: "VAI AL PASSO",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "IMPOSTA ATTRIBUTO",
                QUESTION: "DOMANDA",
                CLOSE_CHAT: "CHIUDERE LA CHAT",
                CREATE_TICKET: "CREA TICKET",
                TRANSFER_CHAT: "TRASFERISCI CHAT",
                TRANSFER_TO_CHATBOT: "INOLTRA AL CHATBOT",
                TAG_CHAT: "AGGIUNGI TAG",
                REMOVE_TAG: "RIMUOVI TAG",
                SET_DEPARTMENT: "IMPOSTA REPARTO",
                SEND_TRANSCRIPT: "INVIA TRASCRIZIONE",
                SEND_SMS: "INVIA SMS",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "CREA EVENTO",
                CREATE_RESERVATION: "CREA PRENOTAZIONE",
                RESERVATION_OPEN_URL: "Url di apertura della prenotazione",
                RESERVATION_SELECT_DAY: "Seleziona il giorno della prenotazione",
                RESERVATION_EVENT_LIST: "Visitatore dell'elenco prenotazioni",
                RESERVATION_SELECT_TIME: "Selezionare l'ora della prenotazione",
                CREATE_TASK: "CREA ATTIVITÀ",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "DISPONIBILITÀ DEI PRODOTTI SHOPIFY",
                SHOPIFY_ORDER_STATUS: "STATO DELL'ORDINE DI SHOPIFY",
                AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
                AKINON_FIND_PRODUCT: "AKINON TROVA PRODOTTO",
                AKINON_ORDER_STATUS: "STATO DELL'ORDINE DI AKINON",
                AKINON_SELECT_ORDER: "AKINON SELEZIONA ORDINE",
                AKINON_SELECT_SIZE: "AKINON SELEZIONA LA TAGLIA",
                AKINON_FIND_NEAREST_STOCK: "MOSTRA LO STOCK DEL NEGOZIO",
                AKINON_FIND_NEAREST_STORES: "MOSTRA I NEGOZI PIÙ VICINI",
                AKINON_SHOW_DISCOUNT_CODES: "MOSTRA I CODICI SCONTO",
                SUPPRESSION_ADD: "BLOCCA IL CONTATTO",
                SUPPRESSION_REMOVE: "SBLOCCA CONTATTO",
                IDEASOFT_SELECT_ORDER: "SELEZIONA ORDINE",
                IDEASOFT_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
                IDEASOFT_GET_MEMBER_INFO: "RIEMPIRE INFORMAZIONI SUI MEMBRI",
                TICKET_UPDATE: "AGGIORNAMENTO DEI BIGLIETTI",

                GET_LOCATION: "OTTENERE LA POSIZIONE",
                FALLBACK: "CASO D'EMERGENZA",
                TIMEOUT: "TIMEOUT",
                SUCCESSO: "SUCCESSO",
                FALLIMENTO: "FAIL",

                PROBEL_SELECT_BRANCH: "Seleziona filiale",
                PROBEL_SELECT_CLINIC: "Selezionare il policlinico",
                PROBEL_SELECT_DAY: "Selezionare il giorno dell'appuntamento",
                PROBEL_SELECT_HOUR: "Selezionare l'ora dell'appuntamento",
                PROBEL_MAKE_APPOINTMENT: "Fissa un appuntamento",
                PROBEL_CANCEL_APPOINTMENT: "Cancellazione appuntamento",
                PROBEL_GET_PATIENT_TOKEN: "Ottieni il token del paziente",
                PROBEL_FILL_INFO: "Ottenere informazioni MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Seleziona appuntamento",

                SEND_WP_BUSINESS_MESSAGE: "INVIA MESSAGGIO WHATSAPP",
                INSTAGRAM_COMMENT_REPLY: "RISPOSTA AL COMMENTO",
                INSTAGRAM_COMMENT_DELETE: "CANCELLA COMMENTO",
                INSTAGRAM_COMMENT_SHOW: "MOSTRA COMMENTO",
                INSTAGRAM_COMMENT_HIDE: "NASCONDI COMMENTO",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RISPONDI COME PRIVATO",
                LOOP: "Loop",
                LOOP_NEXT: "Loop Next Item",
                LOOP_BREAK: "Interruzione del ciclo",
                LOOP_CONTINUE: "Continua il ciclo successivo",
                LOOP_FINISH: "Termina il ciclo",
                SLEEP: "Dormi",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Cattura Webhook",
                TERMINATE_AUTOMATION: "Termina automazione",
                CREATE_CONTACT: "Crea contatto",
                UPDATE_CONTACT: "Aggiorna contatto",
                FIND_CONTACTS: "Trova contatti",
                FIND_CONTACT: "Trova contatto",
                FIND_CHATS: "Trova chat",
                FIND_CHAT: "Trova chat",
                WAIT_FOR: "Attendere",
                STRING_FORMAT: "Formato stringa",
                NUMBER_FORMAT: "Formato numero",
                DATE_FORMAT: "Formato data",
                RECORDS_FROM_CSV: "Record da CSV",
                MESSAGE_RECEIVED: "Messaggio ricevuto",

                ASK_AI: "Intelligenza Artificiale",

                TABLE_CREATE_RECORD: "Crea record",
                TABLE_DELETE_RECORD: "Elimina record",
                TABLE_UPDATE_RECORD: "Aggiorna record",
                TABLE_FIND_RECORD: "Trova record",
                TABLE_FIND_RECORDS: "Elenco record",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Trova record (per telefono)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Aggiungi file al record",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Carica immagine nel campo personalizzato",
                ZOHO_CREATE_RECORD: "Zoho Crea record",

                GET_SUPSIS_RECORD_BY_ID: "Supsis Trova record (per ID)",
            },
        },
        modules: {
            createFailed: "Creazione del modulo fallita",
            createSuccess: "Modulo creato con successo",
            moduleDeletedSuccessfully: "Modulo eliminato con successo",
            deleteModuleTitle: "Elimina Modulo",
            deleteModuleContent: "Sei sicuro di voler eliminare questo modulo?",
            modules: "Moduli",
            modulesSettings: "Impostazioni dei Moduli",
            displayName: "Nome Visualizzato",
            description: "Descrizione",
            table: "Tabella",
            menuApiSettings: "Impostazioni Menu e API",
            icon: "Icona",
            save: "Salva",
            exampleIcon: "Esempio: extension, home",
            newModule: "Nuovo Modulo",
            moduleName: "Nome Modulo",
            apiName: "Nome API",
            type: "Tipo",
            apiAccess: "Accesso API",
            actions: "Azioni",
            module: "Modulo",
            relation: "Relazione",
            moduleRelationName: "Modulo/Relazione",
            moduleRelationTable: "Tabella Modulo/Relazione",
            showInMainMenu: "Mostra nel Menu Principale",
            apiEnabled: "API Abilitata",
            settings: "Impostazioni",
            createModule: "Crea Modulo",
            relationType: "Tipo di Relazione",
            standartModule: "Modulo Standard",
            customTable: "Tabella Personalizzata",
            localField: "Campo Locale",
            showingRemoteFieldInList: "Mostra Campo Remoto in Lista",
            relationSettings: "Impostazioni Relazione",
            remoteField: "Campo Remoto",
            localFieldType: "Tipo di Campo Locale",
            standart: "Standard",
            custom: "Personalizzato",
            contact: "Contatto",
            viewRecord: "Visualizza Record",
            recordDetail: "Dettagli del record",
            recordNotFound: "Record o informazioni della tabella non trovate",
            relatedLists: "Liste correlate",
            recordViewer: "Visualizzatore di record",
        },
        tables: {
            today: "Oggi",
            month: "Mese",
            week: "Settimana",
            day: "Giorno",
            table: "Tabella",
            kanban: "Kanban",
            calendar: "Calendario",
            colorBy: "Colore Per",
            startDateField: "Campo Data Inizio",
            endDateField: "Campo Data Fine (Opzionale)",
            eventCardFields: "Campi Scheda Evento",
            selectColorField: "Seleziona Campo Colore",
            selectStartDateField: "Seleziona Campo Data Inizio",
            selectEndDateField: "Seleziona Campo Data Fine",
            cancel: "Annulla",
            save: "Salva",
            kanbanNotAvailable: "Vista Kanban Non Disponibile",
            needDropdownField:
                "Per utilizzare la vista Kanban, è necessario almeno un campo a discesa statico nella tabella. È possibile aggiungere un nuovo campo o modificarne uno esistente dalle impostazioni della tabella.",
            notAvailable: "Vista Calendario Non Disponibile",
            needDateField:
                "È necessario almeno un campo data nella tabella per utilizzare la vista calendario. È possibile aggiungere un nuovo campo o modificarne uno esistente dalle impostazioni della tabella.",
            switchToTable: "Passa alla Vista Tabella",
            calendarSettings: "Impostazioni Calendario",
            operator: "Operatore",
            conditionalColor: "Colore condizionale",
            groupField: "Campo di gruppo",
            selectDirection: "Seleziona direzione",
            showEmptyGroups: "Mostra gruppi vuoti",
            clearGrouping: "Cancella raggruppamento",
            sortDirection: "Direzione di ordinamento",
            applyGrouping: "Applica raggruppamento",
            downloadSelectedRecords: "Scarica record selezionati",
            viewName: "Nome della vista",
            enterViewName: "Inserire il nome della vista",
            enterDesc: "Inserire la descrizione",
            viewNameRequired: "Nome vista richiesto",
            runWebhookAutomation: "Esegui automazione Webhook",
            downloadAllRecords: "Scarica tutti i record",
            deleteRecords: "Elimina i record",
            editRecords: "Aggiorna i record",
            duplicateRecords: "Record duplicati",
            selected: "Selezionato",
            sureDeleteRecords: "Sei sicuro di voler cancellare i record?",
            selectedRecordSucs: "I record selezionati sono stati cancellati con successo",
            errorDeletingRecords: "Si è verificato un errore durante l'eliminazione dei record",
            sureCopyRecords: "Sei sicuro di voler copiare i record?",
            copyRecords: "Copia dei record",
            recordsCopiedSucs: "I record selezionati sono stati copiati con successo",
            recordsCopiedError: "Si è verificato un errore durante la copia dei record selezionati",
            viewSucsCreated: "La vista è stata creata con successo",
            editMultipleRecords: "Modifica di più record",
            importRecords: "Importazione di record",
            importHasStarted:
                "L'importazione è iniziata. Potrebbe richiedere alcuni minuti, a seconda delle dimensioni dei dati. Attendere...",
            anErrorImport: "Si è verificato un errore durante l'importazione",
            recordCreated: "Crea record",
            recordUpdated: "Aggiorna record",
            recordDeleted: "Elimina record",
            noAutomationDefined: "Nessuna automazione ancora definita",
            nameTheAutomationAdd:
                "Nome dell'automazione che verrà eseguita quando un record viene aggiunto a questa tabella:",
            nameTheAutomationUpdate:
                "Nome dell'automazione che verrà eseguita quando un record di questa tabella viene aggiornato:",
            nameTheAutomationDelete:
                "Nome dell'automazione che verrà eseguita quando un record viene cancellato da questa tabella:",
            editField: "Campo di modifica",
            sort: "Ordinamento",
            ascendente: "Ascendente",
            discendente: "Discendente",
            createField: "Crea campo",
            insertBefore: "Inserisci prima",
            insertAfter: "Inserisci dopo",
            goToRelatedAuto: "Vai all'automazione correlata",
            permission: "Autorizzazione",
            lockField: "Blocca campo",
            hideField: "Nascondi campo",
            deleteField: "Elimina campo",
            watchVideo: "Guarda video",
            uploadError: "Errore di caricamento",
            updateError: "Errore di aggiornamento",
            invalidValue: "Valore non valido. Utilizzare il formato corretto",
            errorUpdatingRecord: "Si è verificato un errore durante l'aggiornamento del record",
            errorCreatingView: "Si è verificato un errore durante la creazione della vista",
            datetimeOptions: "Opzioni di data e ora",
            numberOptions: "Opzioni numero",
            currencyOptions: "Opzioni di valuta",
            dropdownOptions: "Opzioni a discesa",
            automationButtonOptions: "Opzioni del pulsante di automazione",
            defaultLabel: "Etichetta predefinita",
            disableWhenClicked: "Disabilita quando si fa clic",
            fieldSucsCreate: "Campo creato con successo",
            fieldCreatingFailed: "Si è verificato un errore durante la creazione del campo",
            fieldSucsUpdate: "Campo aggiornato con successo",
            fieldUpdatingFailed: "Si è verificato un errore durante l'aggiornamento del campo",
            showAll: "Mostra tutto",
            hideAll: "Nascondi tutto",
            searchFields: "Campi di ricerca",
            firstRowHeader: "La prima riga contiene l'intestazione",
            seperatorCharacter: "Carattere separatore",
            comma: "Virgola",
            semicolan: "Punto e virgola",
            tableFieldOrFileColumns: "Mappatura campi tabella / colonne file",
            exampleResultPreview: "Anteprima del risultato",
            newView: "Nuova vista",
            createViewaFiltering:
                "Creare viste per continuare a filtrare, ordinare e nascondere i campi senza modificare la tabella master",
            pleaseUpdateSelected: "Selezionare il campo che si desidera aggiornare per i record selezionati",
            pleaseSelectedNewValue: "Inserire il nuovo valore per il campo selezionato",
            selectedMenuItem: "Voce di menu selezionata:",
            deleteTable: "Elimina tabella",
            sureDeleteTable: "Sei sicuro di voler cancellare questa tabella?",
            deleteTableSucs: "La tabella è stata eliminata con successo",
            deleteTableError: "Errore nell'eliminazione della tabella:",
            editTable: "Modifica tabella",
            createNewField: "Creare un nuovo campo",
            tabelle: "Tabelle",
            tableName: "Nome tabella",
            description: "Descrizione",
            createTable: "Crea tabella",
            createNewTable: "Crea nuova tabella",
            allTables: "Tutte le tabelle",
            myTables: "Le mie tabelle",
            myFavorites: "I miei preferiti",
            errorCreatingTable: "Errore nella creazione della tabella:",
            customerTable: "Tabella clienti",
            customerTableDesc: "Tabella clienti predefinita",
            leadTracking: "Lead Tracking",
            leadTrackingDesc: "Tabella di tracciamento dei lead",
            todoList: "Elenco di cose da fare",
            todoListDesc: "Elenco per il monitoraggio dei compiti",
            approvalReq: "Richiesta di approvazione",
            approvalReqDesc: "Gestione delle richieste di approvazione",
            eventSchedule: "Calendario eventi",
            eventScheduleDesc: "Pianificazione dei prossimi eventi",
            inventoryList: "Elenco di inventari",
            inventoryListDesc: "Tiene traccia delle scorte di prodotti",
            bookingForm: "Modulo di prenotazione",
            bookingFormDesc: "Tracciamento delle prenotazioni",
            bugTracker: "Bug Tracker",
            bugTrackerDesc: "Traccia i bug del software",
            employeeDirectory: "Elenco dei dipendenti",
            employeeDirectoryDesc: "Contiene informazioni sui dipendenti",
            errorPullTable: "Errore nell'estrazione dei dati della tabella",
            newRecordSucs: "Nuovo record creato con successo",
            failedNewRecord: "Impossibile creare un nuovo record:",
            newRecordCreateError: "Si è verificato un errore durante la creazione di un nuovo record",
            recordCount: "Conteggio dei record",
            increaseLimit: "Limite di incremento",
            newRecord: "Nuovo record",
            imports: "Importazione",
            exports: "Esportazione",
            download: "Download",
            automateYourData: "Automatizza i tuoi dati",
            recordUpdatedSucs: "Record aggiornato con successo",
            failedToUpdateRecord: "Aggiornamento del record non riuscito",
            recordUpdatingError: "Errore nell'aggiornamento del record",
            mainTable: "Tabella principale",
            filter: "Filtro",
            hideFields: "Nascondi campi",
            saveAsView: "Salva come vista",
            search: "Ricerca",
            create: "Crea",
            sinistra: "Sinistra",
            centro: "Medio",
            destra: "Destra",
            selectTimezone: "Seleziona il fuso orario",
            createFieldSucs: "Campo creato con successo",
            failedCreateField: "Impossibile creare il campo:",
            createFieldError: "Si è verificato un errore durante la creazione del campo",
            addCondition: "Aggiungi condizione",
            applyFilter: "Applica filtro",
            fieldType: "Tipo di campo",
            alignment: "Allineamento",
            blankTable: "Tabella vuota",
            templates: "Modelli",
            timezone: "Fuso orario",
            timeFormat: "Formato dell'ora",
            includeTime: "Tempo incluso",
            decimalFormat: "Formato decimale",
            currencySymbol: "Simbolo di valuta",
            mode: "Modalità",
            statica: "Statica",
            dinamico: "Dinamico",
            multipleSelection: "Selezione multipla",
            addOption: "Aggiungi opzione",
            text: "Testo",
            longText: "Testo lungo",
            number: "Numero",
            currency: "Valuta",
            datetime: "Data e ora",
            dropdown: "Elenco a discesa",
            checkbox: "Casella di controllo",
            email: "Email",
            phone: "Telefono",
            file: "File",
            immagine: "Immagine",
            video: "Video",
            audio: "Audio",
            colore: "Colore",
            automationButton: "Pulsante di automazione",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManage: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Settimana",
            readyContents: "Contenuti pronti",
            webhookIntegration: "Integrazione webhook",
            businessChannel: "Canale Business di WhatsApp",
            confirmationFeature: "Funzione di conferma",
            specialReporting: "Reporting speciale",
            aiAssistant: "Assistente IA",
            flexibleBilling: "Fatturazione flessibile",
            automaticReservation: "Prenotazione automatica",
            taskManagement: "Gestione attività",
            calendarIntegration: "Integrazione del calendario",
            activeChatbot: "Chatbot attivo",
            smsIntegration: "Integrazione SMS",
            mailIntegration: "Integrazione email",
            startChatWithVisitor: "Avvia chat con visitatore",
            whatsappManaging: "Gestione di Whatsapp",
            automaticChatbotButton: "Pulsante/Chatbot automatico",
            personalizedBroadcasts: "Trasmissioni personalizzate",
            chatWithNonContacts: "Chat con non contatti",
            broadcastMessaging: "Messaggistica di trasmissione",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Costo aggiuntivo per messaggio",
            smartTrigger: "Trigger intelligente",
            telegramIntegration: "Integrazione di Telegram",
            instagramIntegration: "Integrazione di Instagram",
            ticketFeature: "Funzione del biglietto",
            storage: "Archiviazione",
            onePanelManagement: "Gestione in un unico pannello",
            isolatedDatabaseConnection: "Connessione isolata al database",
            removeLogo: "Rimuovi il logo Supsis",
            chatBaloonCustomization: "Personalizzazione del palloncino della chat",
            chatAndNotifications: "Chat e Notifiche",
            unlimited: "Illimitato",
            specialCustomerSupport: "Supporto clienti speciale",
            softwareSupport: "Supporto software",
            standardSupport: "Supporto standard",
            teamChatIntegration: "Integrazione chat di gruppo",
            fileAndVoiceShare: "Condivisione file e voce",
            instantVisitor: "Tracciamento visitatori istantaneo",
            detailedReporting: "Segnalazione dettagliata",
            normalreporting: "Segnalazione normale",
            noExtraCosts: "Nessun costo extra",
            accessibleToAllAgents: "Accessibile a tutti gli agenti",
            dataSecurity: "Sicurezza dei dati",
            autoTranslate: "Traduzione automatica",
            chatbotVersionHistory: "Cronologia delle versioni del chatbot",
            chatbotStory: "Storia del chatbot",
            freeAgent: "Agente gratuito",
            stableAgentCount: "Numero di agenti stabili",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Piani convenienti",
            generalPlan: "Piano generale",
            specialPlan: "Piano speciale",
            currentPlan: "Piano attuale",
            selected: "Selezionato",
            popular: "Popolare",
            trialPkg: "Pacchetto di prova",
            support: "Supporto 24/7",
            flexiblePricing: "Prezzi flessibili",
            rightToCancel: "Diritto di annullare in qualsiasi momento",
            unlimitedCBScenario: "Scenari di chatbot illimitati",
            freeFirstScenario: "Primo scenario gratuito",
            unlimitedLearn: "Formazione illimitata per chatbot",
            allPlatformIntegration: "Integrazione con tutte le piattaforme",
            detailedReports: "Rapporti dettagliati",
            aiSupport: "Supporto IA",
            creativeAI: "Assistente chat IA veloce e realistico",
            unlimitedSession: "Sessioni illimitate contemporaneamente",
            assistantFromWebsite: "Creazione di assistente dal sito web",
            assistantFromDoc: "Creazione di chatbot dal documento",
            mobileApp: "Applicazione mobile",
        },
        messenger: {
            channel: "Canale Messenger",
            manageChannel: "Gestisci canale",
            channelDetail: "Dettaglio canale",
            integrationTitle: "Integrazione Messenger",
            deleteDesc: "Sei sicuro di voler eliminare il canale Messenger?",
            channels: "Canali Messenger",
            connectMessenger: "Collegati a Messenger",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Messenger",
            commentSettingsDesc: "Gestisci i tuoi commenti su Messenger",
        },
        instagram: {
            channel: "Canale Instagram",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Instagram",
            commentSettingsDesc: "Gestisci i tuoi commenti su Instagram",
            commentSettingsTicket: "Garantisce che i commenti in arrivo siano registrati nel sistema come ticket.",
            commentSettingsChatbot:
                "Seleziona a quale scenario di chatbot devono essere indirizzati i commenti in arrivo.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Mostra tutti i canali Instagram",
        },
        calendar: {
            calendari: "Calendari",
            calendarsDesc: "Evita i conflitti di orario",
            generalAvailability: "Disponibilità generale",
            generalAvailabilityDesc: "Specificare gli orari in cui si è regolarmente disponibili per gli appuntamenti",
            appointDuration: "Durata dell'appuntamento",
            appointDurationDesc: "Quanto deve durare ogni appuntamento?",
            customDuration: "Durata personalizzata",
            descriptionDesc:
                "Aggiungere una nota che descriva il servizio. La nota aggiunta apparirà sulla pagina di prenotazione e nelle e-mail di conferma.",
            resForm: "Modulo di prenotazione",
            resFormDesc: "Personalizzate il modulo che gli utenti utilizzeranno per prenotare un appuntamento",
            addField: "Aggiungi campo",
            addAnItem: "Aggiungi un elemento",
            saveItem: "Salva elemento",
            planningTimeframe: "Pianificazione temporale",
            planningTimeframeDesc: "Limita l'arco di tempo in cui è possibile fissare un appuntamento",
            availableAtMoment: "Disponibile ora",
            startAndEndDate: "Date di inizio e fine",
            maxNumberAppoint: "Numero massimo di giorni dopo i quali è possibile fissare un appuntamento",
            howLongMinAppoint: "Quanto tempo prima l'appuntamento può essere prenotato",
            planningIntervalStartEnd: "Date di inizio e fine dell'intervallo di pianificazione",
            startTime: "Ora di inizio",
            done: "Fatto",
            receivedAppointInterval: "Intervallo di appuntamenti ricevuti",
            receivedAppointIntervalDesc: "Gestione degli appuntamenti ricevuti da visualizzare nel calendario",
            interimTime: "Tempo intermedio",
            interimTimeDesc: "Aggiunge tempo tra gli intervalli di riunione",
            dayMaxRes: "Numero massimo di prenotazioni al giorno",
            dayMaxResDesc: "Limita il numero di appuntamenti prenotati che possono essere accettati in un solo giorno",
            customise: "Imposta personalizzato",
            noAvatar: "Nessun Avatar",
            organizationName: "Nome dell'organizzazione",
            enterFullAdress: "Inserire l'indirizzo completo",
            noCoverPhoto: "Nessuna foto di copertina",
            enterAboutInfo: "Inserisci informazioni su",
            service: "Servizio",
            deleteService: "Elimina servizio",
            enterGoogleMapsUrl: "Inserire l'URL di Google Maps",
            enterLatitude: "Inserire la latitudine",
            enterLongitude: "Inserire la longitudine",
            enterNumber: "Inserire il numero di telefono",
            uploadAvatar: "Carica avatar",
            teamMemberDeleteError: "Errore nell'eliminazione del membro del team:",
            setupBookingWebsite: "Configurazione del sito web di prenotazione",
            bookingLandingPageBuilder: "Costruttore della pagina di prenotazione",
            coverPhoto: "Foto di copertina",
            enterOrganisationName: "Inserire il nome dell'organizzazione",
            about: "Informazioni su",
            services: "Servizi",
            deleteServices: "Elimina servizio",
            selectReservationPlan: "Seleziona piano di prenotazione",
            addNewService: "Aggiungi un nuovo servizio",
            addNewMember: "Aggiungi un nuovo membro",
            fullAddress: "Indirizzo completo",
            latitude: "Latitudine",
            longitude: "Longitudine",
            contactDetails: "Dettagli del contatto",
            emailAddress: "Indirizzo e-mail",
            enterEmail: "Inserire l'indirizzo e-mail",
            websiteURL: "URL del sito web",
            enterWebsiteURL: "Inserire l'URL del sito web",
            reservationPolicy: "Politica di prenotazione",
            enterResPolicy: "Inserire la politica di prenotazione",
            workingHours: "Orario di lavoro",
            selectEndHour: "Selezionare l'ora di fine",
            addNewHour: "Aggiungi una nuova ora",
            updateMemberInfo: "Aggiorna le informazioni sul membro",
            errorRecevingData: "Errore nel recupero dei dati:",
            anonymService: "Servizio anonimo",
            unknownPlan: "Piano sconosciuto",
            errorCreatingMockPage: "Errore nella creazione della pagina mock:",
            failedToCreateBookingPage: "Impossibile creare la pagina di prenotazione",
            fileSizeToolLarge: "Dimensione del file troppo grande",
            errorLoadingTheLogo: "Errore nel caricamento del logo:",
            failedToLoadLogo: "Errore nel caricamento del logo",
            errorUpdating: "Errore nell'aggiornamento:",
            failedToUpdate: "Aggiornamento fallito",
            newMember: "Nuovo membro",
            errorLoadingAvatar: "Errore nel caricamento dell'avatar:",
            avatarFailedToLoad: "Errore nel caricamento dell'avatar",
            teamMemberSuccessfullyDeleted: "Membro del team cancellato con successo",
            teamMemberNotDelete: "Non è stato possibile eliminare un membro del team",
            yesDelete: "Sì, eliminare",
            sureResDelete: "Sei sicuro di voler cancellare questa prenotazione?",
            resDetails: "Dettagli della prenotazione",
            infoPersonMakingRes: "Informazioni della persona che effettua la prenotazione",
            appointmentProgram: "Programma dell'appuntamento",
            goToAppointSettings: "Vai alle impostazioni del programma di appuntamenti",
            resPlanCreateSuccess: "Piano di prenotazione creato con successo",
            pleaseEnterTitle: "Inserire il titolo",
            sureContinueSaving: "Sei sicuro di voler continuare senza salvare?",
            appointProgram: "PROGRAMMA DI PRENOTAZIONE",
            everyMonth: "Ogni mese",
            firstEveryMonth: "Primo di ogni mese",
            dayOf: "Giorno",
            notRepeat: "Non si ripete",
            daily: "Tutti i giorni",
            weekly: "Una volta alla settimana",
            monthly: "Una volta al mese",
            annually: "Una volta all'anno",
            custom: "Speciale",
            eventSaved: "Evento salvato",
            createAppoint: "Termin erstellen",
            calendarSetting: "Kalendereinstellungen",
            notAuthezord: "Nicht berechtigt, diese Aktion auszuführen",
            reservationWebPage: "Pagina web di prenotazione",
            reservationPrograms: "Programmi di prenotazione",
            addReservationProgram: "Aggiungi programma di prenotazione",
            resPlanError: "Errore nella ricezione dei programmi di prenotazione:",
            resDeleteSure: "Sei sicuro di voler eliminare questo programma di prenotazione?",
            resDeleteSuccess: "Il programma di prenotazione è stato eliminato con successo",
            resDeleteError: "Errore nell'eliminazione del programma di prenotazione:",
            unkownUser: "Utente sconosciuto",
            eventNotFound: "Evento non trovato",
            reservations: "Prenotazioni",
            events: "Eventi",
            upcoming: "İn arrivo",
            past: "Il passato",
            setting: "Impostazioni",
            delete: "Elimina",
            cancel: "Annulla",
            save: "Salva",
            close: "Chiudi",
            deleteRepeatEvent: "Elimina evento ricorrente",
            thisEvent: "Questo evento",
            thisAndOtherEvent: "Questo e altri eventi",
            allEvent: "Tutti gli eventi",
            ok: "OK",
            googleCalendarLink: "Aggiungi a Google Calendar",
            yahooCalendarLink: "Aggiungi a Yahoo Calendar",
            subject: "Oggetto",
            visitor: "Visitatore",
            allDay: "Tutto il giorno",
            title: "Titolo",
            deleteEvent: "Elimina evento",
            deleteEvents: "Elimina eventi",
            deleteEventsSure: "Sei sicuro di voler eliminare gli eventi da questo calendario?",
            deleteEventConfirm: "Sei sicuro di voler eliminare questo evento?",
            notEmptyTitle: "Il titolo non può essere vuoto!",
            tasks: "Attività",
            googleConnect: "Integrazione Google",
            googleDisconnect: "Disconnetti integrazione Google",
            sure: "Sei sicuro?",
            disconnectGoogleSure: "Sei sicuro di voler disconnettere Google?",
            yes: "Sì",
            no: "No",
            customRepeat: "Ripetizione personalizzata",
            recurrenceFrequency: "Frequenza di ripetizione",
            repeatDays: "Ripeti nei giorni:",
            never: "Mai",
            thisDate: "In questa data:",
            recurrenceCount: "Numero di ripetizioni:",
            end: "Fine",
            event: "Evento",
            calendars: "Calendari",
            newCalendar: "Crea nuovo calendario",
            changeColor: "Cambia colore",
            addCalendar: "Aggiungi calendario",
            nameCalendar: "Nome del calendario",
            description: "Descrizione",
            change: "Modifica",
            deleteCalendar: "Elimina calendario",
            deleteCalendarSure: "Sei sicuro di voler eliminare questo calendario?",
            notEmptyCalendarName: "Il nome del calendario non può essere vuoto",
            myEvents: "I miei eventi",
            everyoneEvents: "Tutti gli eventi",
            haveEvent: "eventi dell'agente",
            goCalendar: "Vai al calendario",
            goReservation: "Crea una prenotazione",
            agents: "Agenti",
            today: "Oggi",
            month: "Mese",
            week: "Settimana",
            day: "Giorno",
            list: "Lista",
        },
        ticimax: {
            segment: "Segmento",
            settings_group: "Gruppo di impostazioni",
            waitDayFromLastSend: "Giorno di attesa dall'ultimo messaggio inviato",
            automationRuleName: "Nome della regola di automazione",
            time: "Ora",
            year: "Anno",
            month: "Mese",
            dayOfMonth: "Giorno del mese",
            day: "Giorno",
            bySecond: "Per secondo",
            byMinute: "Per minuto",
            byHour: "Per ora",
            byWeekNo: "Per numero di settimana",
            byYearDay: "Per giorno dell'anno",
            byMonthDay: "Per giorno del mese",
            byMonth: "Per mese",
            december: "Dicembre",
            november: "Novembre",
            october: "Ottobre",
            september: "Settembre",
            august: "Agosto",
            july: "Luglio",
            june: "Giugno",
            may: "Maggio",
            april: "Aprile",
            march: "Marzo",
            february: "Febbraio",
            january: "Gennaio",
            byWeekDay: "Per giorno della settimana",
            interval: "Intervallo",
            seconds: "Secondi",
            minutes: "Minuti",
            hourly: "Ogni ora",
            daily: "Giornaliero",
            weekly: "Settimanale",
            monthly: "Mensile",
            yearly: "Annuale",
            frequency: "Frequenza",
            attributes: {
                vip: "VIP",
                segment: "Segmento",
                province: "Provincia",
                country: "Paese",
                phone: "Telefono",
                email: "E-mail",
                fullname: "Nome completo",
                couponPercent: "% del coupon",
                lastOrderDate: "Ultimo ordine",
                firstOrderDate: "Primo ordine",
                county: "Contea",
                lastSource: "Ultima fonte",
                firstSource: "Prima fonte",
                lastPaymentType: "Ultimo metodo di pagamento",
                firstPaymentType: "Primo metodo di pagamento",
                maxOrderAmount: "Importo massimo dell'ordine",
                minOrderAmount: "Importo minimo dell'ordine",
                totalOrderAmount: "Importo totale dell'ordine",
                totalOrderCount: "Numero totale degli ordini",
                usedCouponAmount: "Importo del coupon utilizzato",
                usedCouponCount: "Numero di coupon utilizzati",
                tookDayFromLastOrder: "Giorni dall'ultimo ordine",
                isCouponUser: "È un utente del coupon?",
            },
            createAutomation: "Crea automazione",
            previous: "Precedente",
            createAutomationDesc: "Crea e gestisci l'automazione dei messaggi",
            newTicimaxChannel: "Nuovo canale Ticimax",
            connextToTicimaxXml: "Collegati al servizio XML di Ticimax",
            connectTicimax: "Collegati a Ticimax",
            examplePreview: "Anteprima dell'esempio",
            completeAutomationRule: "Regola di automazione completa",
            configureMessage: "Configura il messaggio",
            automationTimer: "Timer di automazione",
            findTargetMembers: "Trova i membri target",
            createAutomationRule: "Crea regola di automazione",
            action: "Azione",
            status: "Stato",
            triggeredUserCount: "Numero di utenti attivati",
            nextScheduled: "Successivo programmato",
            timerRule: "Regola del timer",
            automationRules: "Regole di automazione",
            apply: "Applica",
            searchAMember: "Cerca un membro",
            segmentedMembersDesc: "Elenca e automatizza i membri segmentati",
            manageVisibilityDesc: "Gestisci la visibilità del canale",
            xmlOrderListURL: "URL dell'elenco ordini XML",
            manageIntegrationDesc: "Gestisci la tua integrazione Ticimax",
            detail: "Dettaglio",
            ticimaxChannelsTitle: "Canali Ticimax",
            ticimaxDetail: "Dettaglio Ticimax",
            settingsGroup: "Impostazioni",
            visibility: "Visibilità",
            members: "Membri",
            automation: "Automazione",
            integrationChannel: "Canale di integrazione",
            channelUpdated: "Canale aggiornato correttamente",
            channelUpdateFailed: "Aggiornamento del canale non riuscito",
        },
        notification: {
            contactOwner: "Cambia il proprietario della chat, assegna un proprietario e rimuovi un proprietario",
            mobileApp: "App Mobile",
            webPanel: "Pannello Web",
            notifications: "Notifiche",
            whatsappActions: "Azioni Whatsapp",
            chatbotActions: "Azioni del chatbot",
            companyActions: "Azioni dell'azienda",
            crmActions: "AZIONI CRM SUPSIS",
            basicActions: "Azioni di base",
            notificationSettingsDesc: "Scegli quali notifiche desideri ricevere e dove desideri riceverle.",
            noNotificationDesc2:
                "Qui vedrai tutte le notifiche relative alle offerte di lavoro, ai candidati e ai pool di talenti che stai seguendo. Puoi personalizzare le notifiche regolando le impostazioni.",
            noNotificationTitle2: "Ancora nessuna notifica.",
            noNotificationTitle1: "Nessuna notifica. Goditi il silenzio.",
            adjustSettings: "Regola impostazioni",
            showAll: "Mostra tutto",
            showOnlyUnread: "Mostra solo non letti",
            mailWasSent: "L'email è stata inviata.",
            mailAdressRemoved: "Indirizzo email rimosso.",
            chatbotPublished: "La versione <b>{version}</b> del chatbot è stata pubblicata da <b>{user}</b>.",
            chatbotDeleted: "Il chatbot <b>{chatbot}</b> è stato eliminato da <b>{user}</b>.",
            settingsUpdatedWoDetail: "Le impostazioni sono state aggiornate da <b>{user}</b>.",
            noActivityDesc: "Attualmente non ci sono attività nel sistema. Devono verificarsi alcuni eventi",
            noActivityTitle: "Ancora nessuna attività",
            actionType: "Tipo di azione",
            dateBetween: "Data compresa tra",
            selectActor: "Seleziona Utente",
            activities: "Attività",
            chatbotCreated: "Il chatbot di nome <b>{chatbot}</b> è stato creato da <b>{user}</b>.",
            taskStageChanged:
                "Lo stadio del compito <b>{task}</b> è stato cambiato da <b>{oldStage}</b> a <b>{newStage}</b> da <b>{user}</b>.",
            taskCreated: "Il compito <b>{task}</b> è stato creato da <b>{user}</b>.",
            contactPropRemoved: "La proprietà del visitatore <b>{prop}</b> è stata rimossa da <b>{user}</b>.",
            contactPropAdded: "La proprietà del visitatore <b>{prop}</b> è stata aggiunta da <b>{user}</b>.",
            userRemoved: "L'utente <b>{oldUser}</b> è stato rimosso da <b>{user}</b>.",
            loginFormUpdated: "Il modulo di accesso del visitatore è stato aggiornato da <b>{user}</b>.",
            loginFormDeactivated: "Il modulo di accesso dell'utente è stato disattivato da <b>{user}</b>.",
            loginFormActivated: "Il modulo di accesso dell'utente è stato attivato da <b>{user}</b>.",
            invoiceRefunded: "Il processo di rimborso è stato effettuato da <b>{user}</b>.",
            paymentMethodAdded: "Un nuovo metodo di pagamento è stato aggiunto da <b>{user}</b>.",
            invoicePaymentFailed: "Il pagamento della fattura non è stato accettato da <b>{user}</b>.",
            invoicePaymentReceived: "Il pagamento della fattura è stato accettato da <b>{user}</b>.",
            planStarted: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planStartedChatbot:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planCanceledChatbot:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            invoiceCreated: "La fattura è stata creata da <b>{user}</b>.",
            billingAddressUpdated: "Le informazioni sull'indirizzo sono state aggiornate da <b>{user}</b>.",
            taskWorkflowDeleted: "Il workflow <b>{workflow}</b> è stato eliminato da <b>{user}</b>.",
            whatsappBroadcastFailed: "Invio del messaggio broadcast dal titolo <b>{title}</b> fallito.",
            whatsappBroadcastCancelled: "L'invio del messaggio broadcast dal titolo <b>{title}</b> è stato annullato.",
            whatsappBroadcastCompleted:
                "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato con successo a <b>{numbers}</b> destinatari.",
            whatsappBroadcastCreated:
                "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato a <b>{numbers}</b> destinatari da <b>{user}</b>.",
            ticketAssigned: "Un ticket è stato assegnato a <b>{user2}</b> da <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> ha effettuato l'accesso a SUPSIS.",
            chatJoined: "<b>{agent}</b> si è unito alla chat con <b>{visitor}</b>.",
            chatForwarded: "La chat con <b>{visitor}</b> è stata inoltrata a <b>{agent}</b> da <b>{user}</b>.",
            chatAssigned: "La chat con <b>{visitor}</b> è stata assegnata a <b>{agent}</b> dal sistema.",
            customerGroupUpdated: "Il gruppo <b>{group}</b> è stato aggiornato da <b>{user}</b>.",
            customerGroupRemoved: "Il gruppo <b>{group}</b> è stato rimosso da <b>{user}</b>.",
            chatOwnerUpdated:
                "<b>{agent}</b> ha riassegnato <b>{visitor}</b> da <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> ha rimosso la proprietà di <b>{visitor}</b> da <b>{oldOwner}</b>, lasciandolo senza proprietario.",
            customerOwnershipAssigned:
                "<b>{actor}</b> ha assegnato la proprietà di <b>{visitor}</b> da senza proprietario a <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> ha riassegnato la proprietà di <b>{visitor}</b> da <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            customerGroupAdded: "Il gruppo <b>{group}</b> è stato creato da <b>{user}</b>.",
            contentRemoved: "Il contenuto pronto <b>{content}</b> è stato rimosso da <b>{user}</b>.",
            contentAdded: "Il contenuto pronto <b>{content}</b> è stato aggiunto da <b>{user}</b>.",
            channelVisibilityChanged:
                "La visibilità del canale di integrazione <b>{channel}</b> è stata cambiata da <b>{user}</b>.",
            taskDeleted: "Il compito <b>{task}</b> è stato eliminato da <b>{user}</b>.",
            userRemovedToDepartment:
                "L'utente <b>{user2}</b> è stato rimosso dal dipartimento <b>{department}</b> da <b>{user1}</b>.",
            userAddedToDepartment:
                "L'utente <b>{user2}</b> è stato aggiunto al dipartimento <b>{department}</b> da <b>{user1}</b>.",
            mailAddressAdded: "Indirizzo email <b>{email}</b> aggiunto da <b>{user}</b>",
            settingUpdate: "Aggiornato da <b>{user}</b>:",
            taskWFlowCreated: "Flusso di lavoro delle attività <b>{Wflow}</b> creato da <b>{user}</b>.",
            bannedWordRemoved: "La parola vietata <b>{bWord}</b> è stata rimossa da <b>{user}</b>.",
            bannedWordCreated: "La parola vietata <b>{bWord}</b> è stata creata da <b>{user}</b>.",
            welcomeMessageRemoved: "Il messaggio di benvenuto <b>{welcome}</b> è stato rimosso da <b>{user}</b>.",
            welcomeMessageAdded: "Messaggio di benvenuto <b>{welcome}</b> creato da <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> rimosso da <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> aggiunto da <b>{user}</b>.",
            roleRemoved: "Ruolo <b>{role}</b> rimosso da <b>{user}</b>.",
            roleAdded: "Ruolo <b>{role}</b> aggiunto da <b>{user}</b>.",
            departmentRemoved: "Dipartimento <b>{department}</b> rimosso da <b>{user}</b>.",
            departmentAdded: "Dipartimento <b>{department}</b> aggiunto da <b>{user}</b>.",
            triggerUpdated: "Un trigger aggiornato da <b>{user}</b>.",
            triggerRemoved: "Un trigger rimosso da <b>{user}</b>.",
            triggerAdded: "Un nuovo trigger creato da <b>{user}</b>.",
            webhookRemoved: "Webhook di <b>{user1}</b> rimosso da <b>{user2}</b>",
            webhookAdded: "Webhook aggiunto da <b>{user1}</b>, aggiunto da <b>{user2}</b>.",
            chatClosed: "La chat con <b>{visitor}</b> è stata chiusa da <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> ha avviato una chat <b>{platform}</b> con <b>{visitor}</b>.",
            chatOpenedByVisitor: "Una chat <b>{platform}</b> è stata avviata da <b>{visitor}</b>.",
            channelRemoved: "Il canale <b>{channel}</b> è stato rimosso da <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> ha creato un rappresentante di nome <b>{newAgent}</b>.",
            visitorUnblocked: "Il visitatore <b>{visitor}</b> sbloccato dall'utente <b>{agent}</b>.",
            visitorBlocked: "Il visitatore <b>{visitor}</b> bloccato da <b>{agent}</b>.",
            userStatusChanged: "L'utente <b>{name}</b> ha cambiato stato da <b>{oldStatus}</b> a <b>{newStatus}</b>.",
            channelCreated: "Il canale <b>{channel}</b> è stato creato da <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> utente ha pianificato l'appuntamento chiamato <b>{title}</b> per il <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> utente ha aggiornato l'appuntamento chiamato <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> utente ha eliminato l'appuntamento chiamato <b>{title}</b>.",
            reservationCreated:
                "Una prenotazione è stata creata per l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b>.",
            reservationDeleted:
                "L'appuntamento pianificato tra l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b> è stato cancellato.",
            chatAssignedMe: "Quando mi viene assegnata una chat",
            ticketAssignedMe: "Quando mi viene assegnato un ticket",
            taskAssignedMe: "Quando mi viene assegnato un compito",
            myChatClosed: "Quando la chat di cui sono proprietario viene chiusa",
            tagActionsToVisitor: "Tag aggiunti o rimossi da un contatto",
            ticketCreated:
                "Il ticket è creato dal visitatore o dal chatbot. Inoltre, quando viene inviato un messaggio offline dal widget di chat",
            notesActions: "Una nota è stata aggiunta o rimossa da un cliente.",
            visitorProfileUpdated: "Profilo del visitatore aggiornato",
            chatStartedByAnyPlatform: "La chat viene avviata su qualsiasi piattaforma da contatto o agente",
            userActions: "Utente creato, aggiornato o eliminato",
            departmentActions: "Dipartimento creato, aggiornato o eliminato",
            settingsActions: "Impostazioni create, aggiornate o eliminate",
            integrationsActions: "Canale di integrazione creato, aggiornato o eliminato",
            loginFormActions: "Modulo di accesso aggiornato, attivato o disattivato",
            bannedWordActions: "Parola vietata creata, aggiornata o eliminata",
            emailActions: "Account email creato o eliminato",
            preparedContentActions: "Contenuto preparato creato o eliminato",
            roleActions: "Ruolo creato, aggiornato o eliminato",
            tagActions: "Tag creato, aggiornato o eliminato",
            welcomeMessageActions: "Messaggio di benvenuto creato, aggiornato o eliminato",
            webhookActions: "Webhook creato, aggiornato o eliminato",
            billingEvents: "Eventi di fatturazione",
            workflowCreated: "Quando viene creato il flusso di lavoro",
            workflowDeleted: "Quando viene eliminato il flusso di lavoro",
            createdTask: "Quando viene creata l'attività",
            taskStatusChanged: "Quando cambia lo stato dell'attività",
            deletedTask: "Quando viene eliminata l'attività",
            taskWorkflowCrud: "Il workflow del compito viene creato, aggiornato o eliminato",
            taskCrud: "Il compito viene creato, aggiornato o eliminato",
            systemStatus: "Cambiamenti di stato online o offline del sistema",
            chatbotStoryCrud: "La storia del chatbot viene creata, aggiornata o eliminata",
            chatbotForwardAgent: "Il chatbot inoltra una chat a un agente",
            userSegmentCrud: "Il segmento utente viene creato, aggiornato o eliminato",
            chatbotCreditLow: "Quando il credito del chatbot è basso",
            wpCreditLow: "Quando il credito Whatsapp è basso",
            wpCustomerGroupCrud: "Quando viene creato, aggiornato o eliminato il gruppo clienti Whatsapp",
            wpBroadcastMessageStatus: "Quando viene inviato, completato o annullato un messaggio broadcast di Whatsapp",
            wpTemplateMesssageCrud: "Quando viene creato, aggiornato o eliminato un messaggio di modello Whatsapp",
            reservationMessageCrud: "Prenotazione creata, aggiornata, annullata",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Nuovo",
                visitor: "Persona",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automazione",
                table: "Tavolo",
                module: "Modulo",
                message: "Messaggio",
            },
            calendar: "Calendario",
            soundSettings: "Notifiche audio",
            allNotificationSettings: "Impostazioni di notifica",
            allAuditLogs: "Registri di controllo",
            allNotifications: "Tutte le notifiche",
            allActivities: "Tutte le attività",
            workFlow: "Flusso di lavoro",
            editTask: "Modifica attività",
            tasks: "Compiti",
            todo: "Cose da fare",
            tapTo: "Premere ⇥ per le operazioni '{prefix}'",
            newUsers: "Nuovo ⇥ Utente",
            newTags: "Nuovo ⇥ Etichetta",
            newRole: "Nuovo ⇥ Ruolo",
            newTrigger: "Nuovo ⇥ Trigger",
            newDepartment: "Nuovo ⇥ Dipartimento",
            newTicket: "Nuovo ⇥ Biglietto",
            jumpSettings: "Vai ⇥ Impostazioni",
            jumpIntegrations: "Vai ⇥ Integrazioni",
            jumpTeam: "Vai ⇥ Team",
            jumpUsers: "Vai ⇥ Utenti",
            jumpReport: "Vai ⇥ Report",
            timingSettings: "Impostazioni di temporizzazione",
            exampleVisitorMail: "Visitatore@mail.com",
            languageAndRegion: "Lingua e regione",
            theme: "Tema",
            appearance: "Aspetto",
            color: "Colore",
            background: "Sfondo",
            smart: "Intelligente",
            teamChat: "Chat di squadra",
            chatbot: "ChatBot",
            chatbotTraining: "Formazione Chatbot",
            chatbotUserSegments: "Segmenti utente del chatbot",
            chatbotIntegration: "Integrazione chatbot",
            chatbotEntities: "Entità chatbot",
            chatbotIntegrationWebHook: "Integrazione WebHook chatbot",
            chatbotArchive: "Archivio chatbot",
            chatbotTemplatesAI: "Modelli di intelligenza artificiale per chatbot",
            chatbotTemplates: "Modelli di chatbot",
            chatbotReportsOverall: "Rapporti complessivi del chatbot",
            chatbotReportsAllChats: "Rapporti chatbot di tutte le chat",
            chatbotReportsRatingDistribution: "Distribuzione delle valutazioni dei rapporti chatbot",
            chatbotReportsPaidChats: "Rapporti chatbot delle chat a pagamento",
            chatbotReportsBusiestPeriod: "Periodo di maggiore affluenza del chatbot",
            chatbotTemplatesAllMessages: "Modelli di chatbot per tutti i messaggi",
            chatbotTemplatesAverage: "Media dei modelli di chatbot",
            chatbotTemplatesPopularity: "Popolarità dei modelli di chatbot",
            chatbotTemplatesAllUser: "Modelli di chatbot di tutti gli utenti",
            ticket: "Richieste di assistenza",
            archivi: "Archivio",
            tag: "Tag",
            offlineSupportRequests: "Richieste di assistenza offline",
            ruoli: "Ruoli",
            utenti: "Utenti",
            soggetti: "Dipartimenti",
            contenuti: "Contenuti istantanei",
            welcomeMessages: "Messaggi di benvenuto",
            catalog: "Catalogo",
            bannedWords: "Parole vietate",
            bannedVisitors: "Visitatori vietati",
            applicazione: "Applicazione",
            mail: "Mailer",
            visitatori: "Visitatori",
            integrazioniWebhook: "Integrazione Webhook",
            billing: "Fattura",
            reportNew: "Nuovo report",
            integrazioni: "Integrazioni",
            chatbotStory: "Storie di chatbot",
            searchPlaceHolder: "Cerca, vai o aggiungi...",
            searchAreaTitle: "Ricerca Supsis",
            searchAreaDesc1: "È possibile cercare qualsiasi cosa. Solo",
            searchAreaDesc2: "o",
            searchAreaDesc3: "Digita o cerca qualsiasi cosa.",
            navigateBtn: "Naviga",
            selectBtn: "Seleziona",
            cancelBtn: "Annulla",
            integration: {
                shouldByInstaPack:
                    "Dovreste acquistare un pacchetto Instagram per creare un canale Instagram. È possibile raggiungere immediatamente i pacchetti a prezzi accessibili.",
                createInstaLimitMax: "Hai raggiunto il limite di creazione di un canale Instagram. Massimo.",
                createInstaContinue:
                    "È possibile creare un canale Instagram. Per continuare, aggiorna il tuo pacchetto o elimina alcuni dei tuoi canali Instagram.",
                privatePolicy: "Politica privata.",
                termsAndCondition: "Termini e condizioni.",
                readAndAgree: "Ho letto e accetto.",
                shouldByMessengerPack:
                    "È necessario acquistare un pacchetto Messenger per creare un canale Messenger. È possibile raggiungere immediatamente i pacchetti a prezzi convenienti.",
                createMessengerLimitMax: "Hai raggiunto il limite di creazione di un canale Messenger. Massimo.",
                createMessengerContinue:
                    "È possibile creare un canale Messenger. Per continuare, aggiornare il pacchetto o eliminare alcuni dei canali Messenger.",
                selectMessengerAccount: "Selezionare l'account Messenger.",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Tutti i reparti",
                deleteAll: "Cancella tutti",
                wpBusinessAPI: "Integrazioni - Canali API Whatsapp Business",
                wpV1: "Integrazioni - Canali Whatsapp multipli",
                instagram: "Integrazioni - Instagram",
                instagramContactList: "Integrazioni - Elenco contatti Instagram",
                mail: "Integrazioni - Mail",
                whatsapp: "Integrazioni - Whatsapp",
                whatsappContactList: "Integrazioni - Elenco contatti Whatsapp",
                wpBCRichieste: "Integrazioni - Richieste di messaggi in massa Whatsapp",
                wpBCCustomerGroups: "Integrazioni - Gruppi di clienti Whatsapp",
                wpBCTemplates: "Integrazioni - Modelli di messaggi Whatsapp Bulk",
                chatbot: "Integrazioni - ChatBot",
            },
            settings: {
                settings: "Impostazioni",
                features: "Impostazioni - Caratteristiche",
                languageAndRegion: "Impostazioni - Lingua e regione",
                bubbleSettings: "Impostazioni - Impostazioni della bolla",
                bubbleActions: "Impostazioni - Azioni bolla",
                themeSettings: "Impostazioni - Impostazioni del tema",
                visitorLoginForm: "Impostazioni - Modulo di accesso per i visitatori",
                visitorAttribute: "Impostazioni - Attributi del visitatore",
                autoAssign: "Impostazioni - Assegnazione automatica",
                talkSettings: "Impostazioni - Impostazioni della conversazione",
                chatTimingSettings: "Impostazioni - Impostazioni orario chat",
                availability: "Impostazioni - Disponibilità",
                websiteIntegration: "Impostazioni - Integrazione del sito web",
                developer: "Impostazioni - Sviluppatore",
            },
        },
        mail: {
            broadcastCreatedSuccess: "Trasmissione creata con successo",
            confirmArchive: "Sei sicuro di voler archiviare questa trasmissione?",
            archive: "Archivia",
            cancel: "Annulla",
            archiveSuccess: "Trasmissione archiviata con successo",
            archiveError: "Errore durante l'archiviazione della trasmissione",
            empty: "Vuoto",
            summerDiscounts: "Sconti estivi",
            opportunities: "Opportunità",
            newMailTemplateCreated: "Crea nuovo modello e-mail",
            dateRange: "Intervallo di date",
            templateName: "Nome del modello",
            category: "Categoria",
            templateUpdateSucs: "Il modello è stato aggiornato con successo",
            templateUpdateError: "Si è verificato un errore durante l'aggiornamento del modello",
            marketing: "Marketing",
            operational: "Operativo",
            custom: "Speciale",
            pleaseEnterTemplateName: "Inserire il nome del modello",
            pleaseEnterTemplateSubject: "Inserire l'oggetto del modello",
            pleaseSelectTemplateCategories: "Selezionare la categoria del modello",
            representMails: "Mail di rappresentanza",
            otherRepresentMails:
                "È possibile tenere traccia delle e-mail in entrata e in uscita da e verso gli indirizzi e-mail di altri rappresentanti",
            signatureAutoAdd: "Lo stato di aggiunta automatica della firma è stato modificato con successo",
            autoAdd: "Aggiunta automatica",
            forwardEmailAddSucs: "Indirizzo e-mail di inoltro aggiunto con successo",
            errorAddingForwardEmail: "Si è verificato un errore durante l'aggiunta di un indirizzo e-mail di inoltro",
            mailAddForward: "Aggiunta manuale (inoltro completato)",
            mailAddForwarding: "Aggiunta manuale (ho completato l'inoltro)",
            broadcast: "Pubblicazioni",
            templates: "Modelli",
            newMailArrived: "È arrivata nuova posta",
            mailSentSucs: "Posta inviata con successo",
            representativeMails: "Posta rappresentativa",
            composeNewEmail: "Comporre una nuova e-mail",
            couldNotUserMail: "Impossibile inviare la posta perché non c'è posta dell'utente",
            mailAddressReq: "Indirizzo di posta richiesto",
            emailAddressInvalid: "Indirizzo di posta non valido",
            departmentIsNotValid: "Reparto non valido",
            mailSendNotValid: "Indirizzo di posta non valido",
            routingSteps: "Passi di instradamento",
            owner: "Proprietario",
            whereHeDirected: "Dove ha diretto",
            forwardingEmailAddress: "Yönlendirecek Eposta Adresi",
            deleteMailDesc: "Questa azione non può essere annullata.",
            deleteMailTitle: "Sei sicuro di voler eliminare questo indirizzo email?",
            gmailForwardMail: "Inoltro email Gmail",
            senderMailAddressDesc: "Si prega di inserire l'indirizzo email del mittente",
            verified: "Verificato",
            notForwarded: "Non inoltrato",
            notVerified: "Non verificato",
            default: "Predefinito",
            isVerified: "Verificato",
            forwarding: "Inoltro",
            mailAdress: "Indirizzo email",
            addSenderAddress: "Aggiungi indirizzo mittente",
            outlookForward: "Inoltra Microsoft (Outlook/Exchange)",
            gmailForward: "Inoltra Google (Gmail)",
            senderMail: "Mail del mittente",
            mailDetail: "Dettaglio della mail",
            mailNotFound: "Mail non trovata",
            mailSelecting: "Selezione mail",
            newMail: "Nuova e-mail",
            myMails: "Le mie email",
            inbox: "Posta in arrivo",
            sent: "Inviato",
            departmentMails: "Email del dipartimento",
            newTemplate: "Nuovo Modello",
            unread: "Non letto",
            unreply: "Unanswered",
            ply: "Rispondi",
            attachments: "Allegati alla mail",
            To: "A",
            From: "Da",
            placeHolders: "Segnaposto",
            attacheFiles: "Allega file",
            replyAll: "Rispondi a tutti",
            forward: "Inoltra",
            deleteThread: "Elimina conversazione",
            markAsRead: "Segna come letto",
            markAsAllRead: "Segna tutto come letto",
            emailEditor: "Editor email",
            integrateYourMail: "Integra la tua email",
            connect: "Collegare",
            departmentMail: "Email del dipartimento",
            createMailAddress: "Crea un indirizzo email",
            createNewMail: "Crea una nuova email",
        },
        visitor: {
            downloadAll: "Scarica tutto",
            saveAsCustomerGroup: "Salva come gruppo di clienti",
            saveSearchFavorite: "Salva la ricerca tra i preferiti",
            mail: "Posta",
            visitorDetail: "Dettagli del visitatore",
            selectedUser: "{selectedUser} di {totalUsers} utenti selezionati",
            uncheck: "Deseleziona tutto",
            checkAll: "Seleziona tutto",
            matchedUsers: "{checkedCount} utenti corrispondenti",
            more: "Di più",
            exportUsers: "Esporta utenti selezionati",
            exportAllUsers: "Esporta tutti gli utenti",
            addSegment: "Aggiungi segmento",
            deleteCheckedUser: "Elimina utenti selezionati",
            deleteAllUser: "Elimina tutti gli utenti",
            matchedFilter: "Corrispondi a tutti i filtri",
            visitor: "Visitatore",
            deleteUser: "Elimina utente",
            userData: "Dati utente",
            lastSession: "Ultima sessione",
            notUserData: "Nessun dato utente trovato",
            segments: "Segmenti",
            tags: "Tag",
            addTag: "Aggiungi tag",
            userChats: "Chat utente",
            seeAll: "Vedi tutti",
            confirm: "Conferma",
            manageSegments: "Gestisci segmenti",
            search: "Ricerca",
            manageTags: "Gestisci tag",
            allAttributes: "Vedi tutti gli attributi",
            noData: "Nessun dato",
            noEmail: "Nessuna email",
            noIpAddress: "Indirizzo IP non trovato.",
            noWpNumber: "Numero non trovato.",
            filterName: "nome del filtro...",
            matchedContacts: "{chechkedCount} contatti corrispondenti",
        },
        chatbotv2: {
            typeStoryTitle: "Scrivi un titolo di storia",
            setUpYourChatbot: "Imposta il tuo chatbot",
            setUpYourChatbotDesc:
                "Addestra il tuo chatbot con i dati, usa i nostri modelli pronti all'uso o parti da zero",
            blankBot: "Bot vuoto",
            blankBotDesc: "Crea un chatbot vuoto che puoi addestrare e personalizzare in seguito",
            websiteDesc:
                "Esamina i contenuti del vostro sito web per ottenere risposte alle domande più frequenti degli utenti",
            yourNeedEnterYourOpenAi:
                "È necessario inserire la propria chiave API OpenAI per creare un chatbot automatizzato attraverso il crawling del proprio sito web",
            createOpenAiKey: "Creare la chiave Api",
            aiKnowledge: "Conoscenza dell'intelligenza artificiale",
            modalUsage: "Uso modale",
            usedContentSources: "Fonti di contenuto utilizzate",
            websites: "Siti web",
            articles: "Articoli",
            faq: "FAQ",
            file: "File",
            functions: "Funzioni",
            impostazioni: "Impostazioni",
            disableAi: "Disabilita l'intelligenza artificiale",
            enableAi: "Abilita l'intelligenza artificiale",
            lastEdited: "Ultima modifica",
            state: "Stato",
            frequentlyAskedQuestions: "Domande frequenti (FAQ)",
            faqIsCreated: "FAQ create",
            selectKnowEnabled: "Abilitazione delle basi di conoscenza selezionate...",
            selectKnowDisabled: "Le basi di conoscenza selezionate sono disabilitate...",
            selectKnowNotEnabled: "Le basi di conoscenza selezionate non sono abilitate...",
            selectKnowNotDisabled: "Le basi di conoscenza selezionate non sono disabilitate",
            risposta: "Risposta",
            addFile: "Aggiungi file",
            fileCancellato: "File cancellato",
            fileDeletedFailed: "Si è verificato un problema nell'eliminazione dei file",
            noFileAdded: "Nessun file aggiunto",
            aiFunctions: "Funzioni AI",
            addFunction: "Aggiungi funzione",
            parameterCount: "Conteggio parametri",
            auto: "Auto",
            usedByAI: "Utilizzato dall'IA",
            usedByAi: "Utilizzato dall'IA",
            notUsed: "Non utilizzato",
            saveAndClose: "Salva e chiudi",
            contentPreview: "Anteprima del contenuto",
            addContent: "Aggiungi contenuto",
            populerUserQuestion:
                "Esamina il contenuto del sito web per ottenere risposte alle domande più frequenti degli utenti",
            enterUrlAddress: "Inserire un indirizzo URL",
            sharingYourUrl:
                "Condividendo il vostro URL, confermate di avere i diritti necessari per condividerne il contenuto",
            pageSelected: "Pagine selezionate",
            trainChatbot: "Addestra il chatbot",
            thereAreOnePages: "C'è 1 pagina all'interno",
            categoryDesc:
                "Categoria. Scegliere quale utilizzare per addestrare il modello di intelligenza artificiale.",
            scarpOrAddContent:
                "Scartare o aggiungere contenuti, che AI Assist può utilizzare per rispondere alle domande dei clienti.",
            noContentAdded: "Nessun contenuto aggiunto",
            howItWorks: "Come funziona",
            editEntries: "Modifica voci",
            newEntries: "Nuovi inserimenti",
            chatbotManagement: "Gestione dei chatbot",
            chatbotScenarioList: "Chatbot Schenerio Lista",
            exportDiagramToClipboard: "Esportazione del diagramma negli appunti",
            selectedStory: "{count} storia selezionata",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Soppressione rimossa",
            suppressionAdded: "Soppressione aggiunta",
            didntSuppression: "Non hai fatto alcuna soppressione.",
            whatsappIntegrationTitle: "Integrazione di WhatsApp V1 e WhatsApp V2",
            whatsappApiIntegrationTitle: "Integrazione dell'API di WhatsApp Business",
            ReadyTemplateBadge: "Modello pronto",
            readyTemplates: "Modelli pronti",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Logo del ChatBot",
            chatbotName: "Nome del ChatBot",
            allSecnario: "Elenco degli scenari di Chatbot",
            ChatbotScenarioList: "Elenco degli scenari di Chatbot",
            Scenario: "Scenari",
            filters: {
                equal: "uguale",
                not_equal: "non uguale",
                contain: "contiene",
                not_contain: "non contiene",
                starts_with: "inizia con",
                ends_with: "finisce con",
                empty: "vuoto",
                non_empty: "non vuoto",
                longer_than: "più lungo di",
                shorter_than: "più corto di",
                less_than: "minore di",
                less_or_equal: "minore o uguale a",
                greater_than: "maggiore di",
                greater_or_equal: "maggiore o uguale a",
            },
            planRequired: "{integratable} è disponibile solo con il piano.",
            noDefaultStoryTitle: "Nessuna storia predefinita",
            noDefaultStory: "Non hai una storia predefinita.\n Vuoi impostare questa storia come predefinita?",
            noMessage: "Nessun messaggio",
            loading: "Caricamento...",
            loadMore: "Carica altro",
            hostname: "Nome host",
            allTemplates: "Tutti i modelli",
            allAITemplates: "Tutti i modelli di IA",
            templatesFromTheIndustry: "Modelli dell'industria",
            basicTemplate: "Modello di base",
            proTemplate: "Modello avanzato",
            goToStory: "Vai alla storia",
            noResultFound: "Nessun risultato trovato",
            checkYourFilterCombination: "Controlla la combinazione del filtro",
            clearYourSearch: "Cancella la tua ricerca",
            andTryAgain: "e riprova",
            withBot: "& Bot",
            userWithBot: "Utente & Bot",
            chatDetail: "Dettaglio chat",
            allUserDetail: "Tutti i dettagli degli utenti",
            sessionData: "Dati di sessione",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrato con: ",
            integration: "Integrazione",
            Users: "Utenti",
            user_id: "ID utente",
            botStory: "Storia del bot",
            categories: "Categorie",
            worksWith: "Funziona con",
            importBot: "Importa bot",
            keyFeatures: "Caratteristiche principali",
            importing: "Importazione",
            comingSoon: "Prossimamente",
            pickStory: "Scegli una storia",
            conversationId: "ID conversazione",
            integrateStoryWithSupsisWidget: "Integra la storia con Supsis Widget",
            integrateStoryWithWhatsapp: "Integra la storia con WhatsApp",
            integrateStoryWithInstagram: "Integra la storia con Instagram",
            selectIntegratingStory: "Seleziona la storia da integrare",
            install: "Installa",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Telefono",
                language: "Lingua",
                timezone: "Fuso orario",
                gender: "Genere",
                country: "Paese",
                referrer: "Referrer",
                url: "Indirizzo di visita",
                ip: "IP",
                last_seen: "Ultima visita",
                name: "Nome",
                user_id: "ID utente",
                department: "Dipartimento",
                message: "Messaggio",
                akinon_brand: "Nome del marchio",
                akinon_order_id: "ID ordine",
                akinon_product_id: "ID prodotto",
                akinon_user_id: "ID utente",
                akinon_user_name: "Nome utente",
                akinon_user_email: "E-mail utente",
                akinon_invoice_url: "URL fattura",
                akinon_order_status: "Stato ordine",
                akinon_order_price: "Prezzo ordine",
                akinon_shipper_name: "Nome spedizioniere",
                akinon_product_size: "Dimensione prodotto",
                akinon_sku: "SKU",
                akinon_product_url: "URL prodotto",
                akinon_product_title: "Titolo prodotto",
                akinon_product_image: "Immagine prodotto",
                akinon_product_stock: "Stock prodotto",
                akinon_order_date: "Data ordine",
                akinon_track_number: "Numero di tracciamento",
                akinon_track_url: "URL di tracciamento",
                akinon_latitude: "Latitudine (Posizione)",
                akinon_longitude: "Longitudine (Posizione)",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Modalità offline",
                available_agents: "Agenti disponibili",
                hour: "Ora",
                segments: "Segments",
                ticket: "biglietto",
                tags: "Tag",
                metaReferrals: "Meta referral",
            },
            storyList: "Elenco delle storie",
            douYouWannaDeleteItem: "Vuoi eliminare questo elemento?",
            douYouWannaDeleteWithChildren: "Vuoi eliminare questo elemento e i suoi figli?",
            stories: "Storie",
            templates: "Modelli",
            aitemplates: "Modelli di IA",
            integrations: "Integrazioni",
            all: "Tutti",
            installed: "Installato",
            installationOK: "Installazione OK",
            uninstall: "Disinstalla",
            remainingMessageDesc: "Hai messaggi rimanenti : ",
            openAISiteRoutingDescStart: "Per ottenere un Apikey",
            openAISiteRoutingDescEnd: " è possibile fare clic sul collegamento.",
            integrationOK: "Integrazione OK",
            chatWidget: "Supsis Widget di chat",
            artificialIntelligence: "AI",
            integratePlatform: "Chatbot {integretable} può essere integrato con",
            integrateOpenAIWithChatbot: "Integra Chat GPT-4 con Chatbot",
            integrateChatBotWithChatGPT3: "Integrazione di ChatBot con Chat GPT-4",
            integrateStoryWithTelegram: "Integra la storia con Telegram",
            webhooks: "Webhooks",
            archive: "Archivio",
            reports: "Rapporti",
            uncheckAll: "Deseleziona tutto",
            userSegments: "Segmenti utente",
            addSegment: "Aggiungi segmento",
            addToSegment: "Aggiungi al segmento",
            removeFromSegment: "Rimuovi dal segmento",
            plansVTippyContent:
                "La fatturazione per questo pacchetto verrà effettuata all'inizio di ogni mese e, nel caso in cui desideriate annullare, il vostro utilizzo verrà addebitato fino all'inizio del mese e il vostro pacchetto scadrà.<br><br>Il prezzo del pacchetto è escluso dall'IVA.<br><br>Le modifiche al pacchetto vengono riflesse nella fattura il giorno successivo.",
            segmentName: "Nome del segmento",
            sameSegment: "C'è un segmento con lo stesso nome!",
            usersInSegment: "Utenti nel segmento",
            noUsersAdded: "Nessun utente aggiunto",
            updateSegment: "Aggiorna segmento",
            newSegment: "Nuovo segmento",
            selectAll: "Seleziona tutto",
            queriesSelected: "query selezionate",
            noBlocksFound: "Nessun blocco trovato",
            userQuery: "Query utente",
            date: "Data",
            unmatched: "Non corrispondente",
            goToChat: "Vai alla chat",
            selectStory: "Seleziona storia",
            selectBlock: "Seleziona blocco",
            training: "Formazione",
            trainingAlert:
                "Per implementare le modifiche apportate alla pagina di addestramento del bot, è necessario pubblicare la nuova versione dello scenario da voi modificato.",
            unmatchedPhrases: "Frasi non corrispondenti",
            ignored: "Ignorato",
            story: "Storia",
            timePeriod: "Periodo di tempo",
            wholeTimeSpan: "Tutto il periodo",
            selectAStory: "Seleziona una storia",
            searchUserQuery: "Cerca query utente",
            time: {
                today: "Oggi",
                yesterday: "Ieri",
                last7: "Ultimi 7 giorni",
                last30: "Ultimi 30 giorni",
                "this-month": "Questo mese",
                "last-month": "Ultimo mese",
                "last-3-month": "Ultimi 3 mesi",
                "this-year": "Quest'anno",
                "last-year": "L'anno scorso",
                custom: "Personalizzato",
            },
            emailProvider: "Provider di posta elettronica",
            triggerFromAnywhere: "Attiva da qualsiasi parte",
            editWebhook: "Modifica Webhook",
            newWebhook: "Nuovo Webhook",
            webhookTitle: "Webhook connesso",
            webhookUrl: "URL Webhook",
            webhookToken: "Token Webhook",
            webhookUsername: "Nome utente Webhook",
            webhookPassword: "Password Webhook",
            allIntegrations: "Tutte le integrazioni",
            integrateYourCBwithChatWidget: "Integra il chatbot con il Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot può essere integrato con GPT-4. Chiave API GPT-4 richiesta.",
            integrateYourCBwithWebHook: "Passa facilmente le informazioni sulla chat tra ChatBot e i tuoi servizi web.",
            integrateYourCBwithIntegratable:
                "ChatBot e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            addWebhook: "Aggiungi Webhook",
            editBlock: "Modifica blocco",
            moveBlock: "Sposta blocco",
            copyBlock: "Copia blocco",
            chatbot: "Chatbot",
            addFilter: "Aggiungi filtro",
            addFilterGroup: "Aggiungi gruppo di filtri",
            clearFilter: "filtro trasparente",
            in: "in",
            and: "e",
            or: "o",
            allStories: "Tutte le storie",
            addBot: "Aggiungi bot",
            testBot: "Test bot",
            publish: "Pubblica",
            editName: "Modifica nome",
            search: "Ricerca",
            typeMoreThan3Char: "Digita più di 3 caratteri ",
            expand: "Espandi",
            expandAll: "Espandi tutto",
            noMatchingItem: "Nessun elemento corrispondente",
            hint: "Suggerimento",
            select: "Seleziona",
            navigate: "Naviga",
            dismiss: "Ignora",
            choseAttribute: "Scegli attributo",
            selectReply: "Seleziona risposta",
            preview: "Anteprima",
            draft: "Bozza",
            lastUpdate: "Ultimo aggiornamento",
            published: "Pubblicato",
            newStory: "Nuova storia",
            updateStory: "Aggiorna storia",
            storyDescription: "Descrizione della storia",
            storyTitle: "Titolo della storia",
            deleteSingleBlock: "Elimina blocco",
            deleteWithChildren: "Elimina con figli",
            startTestFromHere: "Inizia il test da qui",
            copyBlockId: "Copia ID blocco",
            gotoLiveLink: "Vai al link dal vivo",
            copyBlockIdSuccessfull: "ID blocco copiato con successo",

            collapse: "Riduci",
            collapseAll: "Riduci tutto",
            snDelay: "{delay} ritardo sec",
            blockUpdated: "Blocco aggiornato",
            addPayload: "Aggiungi payload",
            previewModeCaution:
                "Sei in modalità anteprima. I cambiamenti apportati qui non verranno salvati. Per salvare, vai alla modalità modifica.",
            enterText: "Inserisci testo",
            trackpad: "Trackpad",
            navigation: "Navigazione",
            navigationDesc:
                "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            botSetting: "Impostazioni bot",
            botSettingDesc:
                "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            languageSettingsDesc: "Seleziona la lingua in cui vuoi che il chatbot risponda alle domande.",
            mouse: "Mouse",
            Interactions: "Interazioni",
            Actions: "Azioni",
            Supsis_Actions: "Supsis Azioni",
            Shopify_Actions: "Shopify Azioni",
            Akinon_Actions: "Akinon Azioni",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "PUNTO DI PARTENZA",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "RISPOSTA BOT",
            AI_BOT_RESPONSE: "RISPOSTA DI INTELLIGENZA ARTIFICIALE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            FILTER: "FILTRO",
            addNewFilter: "Aggiungi nuovo filtro",
            FLOW: "FLUSSO",
            ATTACHMENT_INPUT: "INPUT ALLEGATO",
            USER_INPUT: "INPUT UTENTE",
            GO_TO_STEP: "VAI AL PASSO",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "IMPOSTA ATTRIBUTO",
            QUESTION: "DOMANDA",
            CLOSE_CHAT: "CHIUDI CHAT",
            CREATE_TICKET: "CREA TICKET",
            TRANSFER_CHAT: "TRASFERISCI CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "IMPOSTA DIPARTIMENTO",
            SEND_TRANSCRIPT: "INVIA TRASCRIZIONE",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SEND MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY MOSTRA IL PRODOTTO",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY STATO STOCK DEL PRODOTTO",
            SHOPIFY_ORDER_STATUS: "STATO ORDINE NEGOZIO",
            AKINON_SHOW_PRODUCTS: "MOSTRA DEL PRODOTTO AKINON",
            AKINON_FIND_PRODUCT: "TROVA IL PRODOTTO AKINON",
            AKINON_ORDER_STATUS: "STATO DELL'ORDINE AKINON",
            AKINON_SELECT_ORDER: "AKINON SELEZIONA ORDINE",
            AKINON_SELECT_SIZE: "AKINON SELEZIONA TAGLIA",
            AKINON_FIND_NEAREST_STOCK: "TROVA IL NEGOZIO PIÙ VICINO AKINON",
            AKINON_FIND_NEAREST_STORES: "TROVA I NEGOZI PIÙ VICINI AKINON",
            AKINON_SHOW_DISCOUNT_CODES: "MOSTRA CODICI SCONTO AKINON",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "RISPONDI AL COMMENTO",
            INSTAGRAM_COMMENT_DELETE: "ELIMINA COMMENTO",
            INSTAGRAM_COMMENT_SHOW: "MOSTRA COMMENTO",
            INSTAGRAM_COMMENT_HIDE: "NASCONDI COMMENTO",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RISPONDERE IN PRIVATO",
            followingAttributesFilled: "I seguenti attributi sono stati compilati",
            GET_LOCATION: "OTTIENI LA POSIZIONE",
            FALLBACK: "FALLBACK",
            SUCCESS: "SUCCESSO",
            FAILURE: "FALLIMENTO",

            Probel_Actions: "Probel Azioni",
            PROBEL_SELECT_BRANCH: "Seleziona Filiale",
            PROBEL_SELECT_CLINIC: "Scegli Clinica",
            PROBEL_SELECT_DAY: "Selezionare Giorno dell'appuntamento",
            PROBEL_SELECT_HOUR: "Seleziona Ora appuntamento",
            PROBEL_MAKE_APPOINTMENT: "Fai un appuntamento",
            PROBEL_CANCEL_APPOINTMENT: "Annulla appuntamento",
            PROBEL_GET_PATIENT_TOKEN: "Ottieni token paziente",
            PROBEL_FILL_INFO: "MERNIS Fill Info",
            PROBEL_SELECT_APPOINTMENT: "Seleziona appuntamento",

            message: "Messaggio",
            condition: "Condizione",
            score: "Punteggio",
            equal: "uguale",
            not_equal: "non uguale",
            contain: "contiene",
            not_contain: "non contiene",
            starts_with: "inizia con",
            ends_with: "finisce con",
            empty: "vuoto",
            longer_than: "più lungo",
            shorter_than: "più corto",
            less_than: "minore di",
            less_than_equal: "minore o uguale a",
            greater_than: "maggiore di",
            greater_than_equal: "maggiore o uguale a",
            value: "Valore",
            failures: "Fallimenti",
            email: "E-mail",
            name: "Nome",
            username: "Nome utente",
            source: "Fonte",
            language: "Lingua",
            timezone: "Fuso orario",
            region: "Regione",
            country: "Paese",
            referrer: "Referrer",
            url: "URL",
            ip: "IP",
            city: "Città",
            lastSeen: "Ultima visita",
            userId: "ID utente",
            selectStep: "Seleziona Passo",
            keywords: "Parole chiave",
            userSays: "Utente dice",
            addKeyword: "Aggiungi parola chiave",
            addUserMessage: "Aggiungi messaggio utente",
            set: "Imposta",
            to: "a",
            gender: "Genere",

            go_to_failure: "Vai al passo di fallimento",
            go_to_success: "Vai al passo di successo",
            untilFilled: "Fino a quando non è riempito",
            time1: "1 volta",
            time2: "2 volte",
            time3: "3 volte",
            time4: "4 volte",
            time5: "5 volte",
            any: "Qualsiasi",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alfanumerico",
            integer: "Intero",
            no: "No",
            number: "Numero",
            phone: "Telefono",
            yes: "Sì",
            yesNo: "Si - No",
            anyDescription: "Corrisponde a tutto ciò che non è nullo.",
            alphanumericDescription: "Corrisponde a qualsiasi carattere alfanumerico.",
            integerDescription: "Corrisponde a qualsiasi numero intero.",
            noDescription: "Corrisponde a no, nope, nah, non,",
            numberDescription: "Corrisponde a qualsiasi numero.",
            phoneDescription: "Corrisponde a qualsiasi numero di telefono.",
            yesDescription: "Corrisponde ai sinonimi di sì.",
            yesNoDescription: "Corrisponde ai sinonimi di sì e no.",
            emailDescription: "Corrisponde a qualsiasi indirizzo email.",
            urlDescription: "Corrisponde a qualsiasi URL.",
            temperature: "Temperatura",
            askWhenInvalid: "Chiedi quando non valido",
            applyFilter: "Applica filtro",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Aggiunto",
            notificationMessageStartError: "Si è verificato un errore, blocco ",
            notificationMessageEndError: " non aggiunto",
            blockChangedWannaUpdate: "Il blocco è stato modificato, vuoi aggiornare?",
            TEXT: "Testo",
            IMAGE: "Immagine",
            GALLERY: "Galleria",
            BUTTON: "Pulsante",
            RANDOM_TEXT: "Testo casuale",
            QUICK_REPLY: "Risposta rapida",
            FILE: "File",
            responses: "Risposte",
            flow: "Flusso",
            active: "Attivo",
            passive: "Passivo",

            chooseAttributeType: "Seleziona tipo di attributo",
            imageAttachment: "Aggiungi immagine",
            audioAttachment: "Aggiungi audio",
            videoAttachment: "Aggiungi video",
            documentAttachment: "Aggiungi documento",
            anyAttachment: "Aggiungi allegato",
            typeAttributeValue: "Inserisci valore attributo",
            typeSearchValue: "Inserisci valore di ricerca",
            male: "Maschio",
            addAttribute: "Aggiungi attributo",
            addAttributeDescription:
                "Gli attributi sono utilizzati per memorizzare le informazioni dell'utente. Ad esempio, se si desidera memorizzare il nome dell'utente, è possibile creare un attributo con il nome 'nome' e il valore 'nome utente'.",
            USER_DATA: "Dati utente",
            CUSTOM_ATTRIBUTES: "Attributi personalizzati",
            enterBotResponseHere: "Inserisci qui la risposta del bot",

            addCard: "Aggiungi carta",
            addButton: "Aggiungi pulsante",
            typeCardTitle: "Titolo della carta",
            typeCardDescription: "Descrizione della carta",
            dragAndDropBrowse: "Trascina e rilascia / Sfoglia",
            dragAndDropBrowseFile: "Trascina e rilascia / Sfoglia file",
            button: "Pulsante",
            enterYourMessage: "Inserisci il tuo messaggio",
            imageView: "Visualizzazione immagine",
            imageUploading: "Caricamento immagine...",
            fileUploading: "Caricamento file...",
            clickToChooseNewImage: "Fai clic per scegliere una nuova immagine",
            clickToChooseNewFile: "Fai clic per scegliere un nuovo file",
            removeTheExistingOne: "Rimuovi quello esistente",
            validateResponseWithEntity: "Convalida la risposta con l'entità",
            actionOnFailureInput: "Azione in caso di input non valido",
            askNextQuestion: "Chiedi la prossima domanda",
            goToSuccessBlock: "Vai al blocco di successo",
            goToFailureBlock: "Vai al blocco di fallimento",
            saveResposeToAttribute: "Salva la risposta nell'attributo",
            selectReplyType: "Seleziona tipo di risposta",
            questionVariants: "Varianti di domande",
            systemEntities: "Entità di sistema",
            delay: "Ritardo",
            retrySectionTextPart: " e riprova dopo ",
            retrySectionText: "Riprova se l'utente ha fornito una risposta non valida",
            addNextQuestion: "Aggiungi la prossima domanda",
            typeBlockTitle: "Inserisci il titolo del blocco",
            versionHistory: "Cronologia delle versioni",
            restore: "Ripristina",
            versionName: "Nome della versione",
            restoreModalText:
                "Sei sicuro di voler ripristinare questa versione? Tutte le modifiche apportate alla versione corrente verranno perse.",
            restoreVersion: "Ripristina versione",
            newVersion: "Nuova versione",
            synonymMustBeUnique: "Il sinonimo deve essere univoco",
            save: "Salva",
            entries: "Voci",
            youHaveNoEntries: "Non hai voci",
            inputsCantBeEmpty: "Le voci non possono essere vuote",
            entryNamesMustBeUnique: "I nomi delle voci devono essere univoci",
            entityNameCantBeEmpty: "Il nome dell'entità non può essere vuoto",
            entityNameMustBeUnique: "Il nome dell'entità deve essere univoco",
            synonyms: "Sinonimi",
            title: "Titolo",
            entryName: "Nome della voce",
            entities: "Entità",
            entityhasbeenUpdatedSuccessfully: "L'entità è stata aggiornata con successo",
            emptyError: "Non può essere vuoto",

            allChats: "Tutte le chat",
            paidChats: "Chat a pagamento",
            busiestPeriod: "Periodo più trafficato",
            ratingDistribution: "Distribuzione del rating",
            allMessages: "Tutti i messaggi",
            avarageMessages: "Messaggi medi",
            popularity: "Popolarità",
            allUsers: "Tutti gli utenti",
            interactionName: "Nome interazione",
            numberOfMessage: "Numero di messaggi",
            ofAllUsersMessage: "% Messaggio da tutti gli utenti",

            totalData: "Dati totali",
            avgData: "Dati medi",
            exportToCsv: "Esporta in CSV",
            exportToExcel: "Esporta in Excel",
            inMaintenance: "In manutenzione",
            ADD_TO_SEGMENT: "Aggiungi al segmento",
            REMOVE_FROM_SEGMENT: "Rimuovi dal segmento",
            users: "Utenti",
            webhookName: "Nome webhook",
            webHookUrl: "URL webhook",
            webHookToken: "Token webhook",
            delete: "Elimina",
            basicAuth: "Autenticazione di base",
            requiredFieldsCannotBeLeftBlank: "I campi obbligatori non possono essere lasciati vuoti",

            yourVerificationToken: "Il tuo token di verifica",
            yourWebHookName: "Nome webhook",
            yourWebHookUrl: "URL webhook",
            enterKey: "Inserisci chiave",
            password: "Password",
            headerValue: "Valore",
            saveSuccessfully: "Salva con successo",
            urlTypeError: "Si prega di compilare correttamente il campo (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Chiave API richiesta per OpenAI Chat GPT-4.",
                apiKeyDesc:
                    "La chiave API è necessaria per l'integrazione di Chatbot + Chat GPT-4. Si prega di ottenere la chiave API o utilizzare la chiave API sottostante per la prova. Puoi utilizzare solo 20 messaggi a scopo di prova.",
                getApiKey: "Ottieni la chiave API",
                typeApiKey: "Inserisci la chiave API",
                ownApiKey: "Ottieni la chiave API OpenAI",
                trialApiKey: "Chiave API di prova (limitata a 20 post)",
                useOurTrial: "Usa la nostra prova gratuita",
                twentyMessages: "Puoi provare e utilizzare 20 messaggi gratuitamente.",
                enableChatGpt3: "Attiva la chat GPT-4",
            },
        },
        coupon: {
            code: "codice",
            discount: "sconto",
            endDate: "Data di fine",
            name: "Nome",
            email: "E-mail",
            phone: "Telefono",
            add: "Aggiungi",
            coupons: "Coupon",
            couponDeleted: "Coupon eliminato",
            limit: "Limite",
            visitorBan: "Il visitatore è stato bloccato.",
            visitorUnBlock: "Il blocco è stato rimosso.",
        },
        instagramTitle: "Fai clic sul pulsante in basso per abilitare le funzionalità di Instagram.",
        instegramFunctionActive: "Funzione Instagram attiva",
        ChatBOT: "ChatBOT",
        WhatsappContacts: "Contatti Whatsapp",
        InstagramContacts: "Contatti Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Volume su",
        minimize: "Minimizza",
        maximize: "Massimizza",
        auditLogs: {
            auditLogsTitle: "Log di audit",
            auditLogsSub:
                "I log di audit ti consentono di tracciare gli eventi che sono avvenuti nella tua azienda negli ultimi 30 giorni.",
        },
        task: {
            priority_lowest: "Minima",
            priority_low: "Bassa",
            priority_medium: "Media",
            priority_high: "Alta",
            priority_highest: "Massima",
            workflowActions: "Azioni del flusso di lavoro",
            workflowTitle: "Titolo del flusso di lavoro",
            deleteTask: "Elimina attività",
            archivingDate: "Data di archiviazione",
            selectOption: "Selezionare un'opzione",
            notAuthorisedCreateTask: "Non siete autorizzati a creare un'attività",
            notAuthorisedCreateTaskDesc: "Non siete autorizzati a eseguire questa attività",
            goToMessage: "Vai al messaggio",
            goToChat: "Vai alla chat",
            showVisitor: "Mostra visitatore",
            closeTheTask: "Chiudi l'attività",
            sureAddCompletedList: "Sei sicuro di voler aggiungere l'attività all'elenco dei completati?",
            success: "Successo",
            successDesc: "Nuovo campo aggiunto con successo",
            moveAndDeleteTask: "Sposta ed elimina le attività",
            justDelete: "Solo eliminazione",
            selectColumnMoveTask: "Selezionare la colonna in cui si desidera spostare le attività",
            todos: "Cose da fare",
            inProgress: "In corso",
            approval: "Approvato",
            addAComment: "Aggiungi un commento...",
            deleteComment: "Sei sicuro di voler eliminare il commento?",
            edited: "Modificato",
            comments: "Commenti",
            addComment: "Aggiungi commento",
            workflow: "Flusso di lavoro",
            workflowDetail: "Dettagli del flusso di lavoro",
            workflowPerm: "Permessi del flusso di lavoro",
            perm: "Permessi",
            detail: "Dettagli",
            userPerm: "Permessi utente",
            deleteCard: "Elimina scheda",
            createCard: "Crea scheda",
            editCard: "Modifica scheda",
            dragCard: "Trascina scheda",
            allWorkflow: "Tutti i flussi di lavoro",
            createworkflow: "Crea flusso di lavoro",
            deleteWorkflow: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            permEditTask: "Non hai il permesso di modificare questa attività",
            permEditTaskDes: "Contatta il tuo amministratore per ottenere i permessi di modifica.",
            createTaskError: "Non hai il permesso di creare attività",
            createTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per creare attività.",
            moveTaskError: "Non hai il permesso di cambiare lo stato dell'attività",
            moveTaskErrorDesc:
                "Contatta il tuo amministratore per ottenere i permessi per cambiare lo stato dell'attività.",
            deleteTaskError: "Non hai il permesso di eliminare attività",
            deleteTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per eliminare attività.",
            permissionError: "Non hai il permesso di creare attività",
            permissionErrorDesc:
                "Si prega di contattare l'amministratore per ottenere i permessi di creazione delle attività",
            whatsappContactProfileTitle: "Profilo di {name} / {number}",
            createTaskVisitor: "Crea attività (Visitatore)",
            editWorkflow: "Modifica Workflow",
            visitor: "Profilo del visitatore",
            createTaskMessage: "Crea Compito (Messaggio)",
            createStage: "Crea Stage",
            stagesAndStatuses: "Fasi e stati",
            workflowCreateDesc: "Descrizione del flusso di lavoro",
            subTasks: "Sottoattività",
            followers: "Seguaci",
            collaborators: "Collaboratori",
            addRelations: "Aggiungi relazioni",
            relations: "Relazioni",
            main: "Principale",
            name: "Nome",
            completedOfCheck: "{completed} di {total} compiti completati",
            workflowUpdateMs: "Workflow aggiornato con successo",
            taskUpdateMs: "Attività aggiornata con successo",
            workflowCreatedMs: "Workflow creato con successo",
            workflowCreateError: "Impossibile creare il flusso di lavoro",
            taskCreatedMs: "Attività creata con successo",
            settingsDesc3:
                "Inoltre, il modulo attività di Supsis consente di creare il proprio flusso di lavoro con automazione personalizzabile, consentendo di gestire le attività in modo più efficace e migliorare la collaborazione all'interno del team.",
            settingsDesc4:
                "In questo modo, puoi monitorare ogni singola tua attività in dettaglio, assegnare compiti ai membri del team e gestire complessivamente i tuoi processi aziendali in modo più efficiente. Il modulo attività di Supsis fornisce una soluzione completa per la gestione delle attività e il coordinamento del team.",
            settingsDesc2:
                "Il modulo attività di Supsis non lascia nessuna attività trascurata. Puoi filtrare le attività in base a qualsiasi parametro, monitorare i carichi di lavoro per ogni fase del flusso di lavoro e organizzare il tuo calendario per allinearti ai tuoi orari.",
            settingsDesc1:
                "Il modulo Attività ti consente di organizzare il lavoro collaborativo, delegare compiti e monitorare il progresso del tuo team. Puoi personalizzare le tue attività in base alle tue esigenze selezionando qualsiasi visualizzazione e creare i tuoi flussi di lavoro personalizzati con automazioni.",
            taskModuleSettingsTitle: "Impostazioni del modulo attività",
            high: "Alta",
            medium: "Media",
            low: "Bassa",
            priority: "Priorità",
            addExistsSubtask: "Aggiungi sottoattività esistente",
            addSubtask: "Aggiungi sottoattività",
            add: "Aggiungi",
            newCheckList: "Nuova checklist",
            subtaskTitle: "Titolo della sotto-attività",
            view: "Visualizza",
            attachFiles: "Allega file",
            createTaskDesc: "Descrizione del compito",
            createWorkflow: "Crea un flusso di lavoro",
            editTask: "Modifica attività",
            createTask: "Crea attività",
            deleteColumnCont: "Sei sicuro di voler eliminare questa colonna?",
            changeStage: "Cambia Stage",
            assignees: "Assegnatari",
            owner: "Proprietario",
            stage: "Fase",
            writeSomething: "Scrivi qualcosa",
            selectAssginee: "Seleziona assegnatario",
            assignee: "Assegnatario",
            enterNewTaskDesc: "Inserisci la descrizione del nuovo compito",
            enterNewTaskTitle: "Inserisci il titolo del nuovo compito",
            task: "Compito",
            deleteTaskCont: "Sei sicuro di voler eliminare questi compiti?",
            deleteWorkFlowCont: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            completed: "Completato",
            todo: "Da fare",
            kanbanBoard: "Bacheca Kanban",
            listView: "Visualizzazione elenco",
        },
        permissionErrors: {
            userCreate: "Non hai il permesso di aggiungere utenti. Si prega di consultare l'amministratore.",
            userRead: "Non hai il permesso di visualizzare gli utenti. Si prega di consultare l'amministratore.",
            userUpdate: "Non hai il permesso di aggiornare gli utenti. Si prega di consultare l'amministratore.",
            userDelete: "Non hai il permesso di eliminare gli utenti. Si prega di consultare l'amministratore.",
            visitorBlock: "Non hai il permesso di bloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorUnblock: "Non hai il permesso di sbloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorDetailRead:
                "Non hai il permesso di visualizzare i dettagli dei visitatori. Si prega di consultare l'amministratore.",
            visitorListRead:
                "Non hai il permesso di visualizzare l'elenco dei visitatori. Si prega di consultare l'amministratore.",
            visitorDelete: "Non hai il permesso di eliminare i visitatori. Si prega di consultare l'amministratore.",
            visitorExcel: "Non hai il permesso di ottenere l'output Excel. Si prega di consultare l'amministratore.",
            visitorUpdate: "Non hai il permesso di aggiornare i visitatori. Si prega di consultare l'amministratore.",
            bannedVisitorRead:
                "Non hai il permesso di visualizzare l'elenco dei visitatori bannati. Si prega di consultare l'amministratore.",
            bannedWordCreate:
                "Non hai il permesso di aggiungere parole bannate. Si prega di consultare l'amministratore.",
            bannedWordRead:
                "Non hai il permesso di visualizzare le parole bannate. Si prega di consultare l'amministratore.",
            bannedWordDelete:
                "Non hai il permesso di eliminare le parole bannate. Si prega di consultare l'amministratore.",
            chatRead: "Non hai il permesso di visualizzare le chat. Si prega di consultare l'amministratore.",
            chatUpdate: "Non hai il permesso di modificare le chat. Si prega di consultare l'amministratore.",
            archiveRead: "Non hai il permesso di visualizzare gli archivi. Si prega di consultare l'amministratore.",
            roleCreate: "Non hai il permesso di aggiungere ruoli. Si prega di consultare l'amministratore.",
            roleRead: "Non hai il permesso di visualizzare i ruoli. Si prega di consultare l'amministratore.",
            roleUpdate: "Non hai il permesso di aggiornare i ruoli. Si prega di consultare l'amministratore.",
            roleDelete: "Non hai il permesso di eliminare i ruoli. Si prega di consultare l'amministratore.",
            departmentCreate:
                "Non hai il permesso di aggiungere dipartimenti. Si prega di consultare l'amministratore.",
            departmentRead:
                "Non hai il permesso di visualizzare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentUpdate:
                "Non hai il permesso di aggiornare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentDelete:
                "Non hai il permesso di eliminare i dipartimenti. Si prega di consultare l'amministratore.",
            preparedContentCreate:
                "Non hai il permesso di creare contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentRead:
                "Non hai il permesso di visualizzare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentUpdate:
                "Non hai il permesso di aggiornare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentDelete:
                "Non hai il permesso di eliminare i contenuti preparati. Si prega di consultare l'amministratore.",
            welcomeCreate:
                "Non hai il permesso di creare messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeRead:
                "Non hai il permesso di visualizzare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeUpdate:
                "Non hai il permesso di aggiornare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeDelete:
                "Non hai il permesso di eliminare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            settingCreate: "Non hai il permesso di creare impostazioni. Si prega di contattare l'amministratore.",
            settingRead:
                "Non hai il permesso di visualizzare le impostazioni. Si prega di contattare l'amministratore.",
            settingUpdate:
                "Non hai il permesso di aggiornare le impostazioni. Si prega di contattare l'amministratore.",
            settingDelete: "Non hai il permesso di eliminare le impostazioni. Si prega di contattare l'amministratore.",
            reportCreate: "Non hai il permesso di creare rapporti. Si prega di contattare l'amministratore.",
            reportRead: "Non hai il permesso di visualizzare i rapporti. Si prega di contattare l'amministratore.",
            reportUpdate: "Non hai il permesso di aggiornare i rapporti. Si prega di contattare l'amministratore.",
            reportDelete: "Non hai il permesso di eliminare i rapporti. Si prega di contattare l'amministratore.",
            offlineSupportRequestCreate:
                "Non hai il permesso di creare richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestRead:
                "Non hai il permesso di visualizzare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestUpdate:
                "Non hai il permesso di rispondere alle richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestDelete:
                "Non hai il permesso di eliminare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            catalogCreate: "Non hai il permesso di creare cataloghi. Si prega di contattare l'amministratore.",
            catalogRead: "Non hai il permesso di visualizzare il catalogo. Si prega di contattare l'amministratore.",
            catalogUpdate: "Non hai il permesso di aggiornare il catalogo. Si prega di contattare l'amministratore.",
            catalogDelete: "Non hai il permesso di eliminare il catalogo. Si prega di contattare l'amministratore.",
            chatbotStoryCreate:
                "Non hai il permesso di creare storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryRead:
                "Non hai il permesso di visualizzare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryUpdate:
                "Non hai il permesso di aggiornare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryDelete:
                "Non hai il permesso di eliminare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateRead:
                "Non hai il permesso di visualizzare i modelli del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateAiRead:
                "Non hai il permesso di visualizzare i modelli di IA del chatbot. Si prega di contattare l'amministratore.",
            chatbotIntegrationsRead:
                "Non hai il permesso di visualizzare le integrazioni del chatbot. Si prega di contattare l'amministratore.",
            chatbotArchiveRead:
                "Non hai il permesso di visualizzare l'archivio del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesRead:
                "Non hai il permesso di visualizzare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesCreate:
                "Non hai il permesso di creare entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesUpdate:
                "Non hai il permesso di aggiornare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesDelete:
                "Non hai il permesso di eliminare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotReportRead:
                "Non hai il permesso di visualizzare i report del chatbot. Contatta il tuo amministratore.",
            chatbotTrainRead:
                "Non hai il permesso di visualizzare la formazione del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentCreate:
                "Non hai il permesso di creare segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentRead:
                "Non hai il permesso di visualizzare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentUpdate:
                "Non hai il permesso di aggiornare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentDelete:
                "Non hai il permesso di eliminare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            integrationsRead:
                "Non hai il permesso di visualizzare la pagina delle integrazioni. Contatta il tuo amministratore.",
            whatsappIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di WhatsApp. Contatta il tuo amministratore.",
            instagramIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di Instagram. Contatta il tuo amministratore.",
            telegramIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di Telegram. Contatta il tuo amministratore.",
            integrationCreate: "Non hai il permesso di attivare le integrazioni. Contatta il tuo amministratore.",
            triggerCreate: "Non hai il permesso di creare trigger. Contatta il tuo amministratore.",
            triggerRead: "Non hai il permesso di visualizzare i trigger. Contatta il tuo amministratore.",
            triggerUpdate: "Non hai il permesso di aggiornare i trigger. Contatta il tuo amministratore.",
            triggerDelete: "Non hai il permesso di eliminare i trigger. Contatta il tuo amministratore.",
            billingRead: "Non hai il permesso di visualizzare le fatture. Si prega di contattare l'amministratore.",
            taskCreate: "Non hai il permesso di creare attività. Si prega di contattare l'amministratore.",
            taskRead: "Non hai il permesso di visualizzare le attività. Si prega di contattare l'amministratore.",
            taskUpdate: "Non hai il permesso di aggiornare le attività. Si prega di contattare l'amministratore.",
            taskDelete: "Non hai il permesso di eliminare le attività. Si prega di contattare l'amministratore.",
            calendarCreate:
                "Non hai il permesso di creare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarRead:
                "Non hai il permesso di visualizzare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarUpdate:
                "Non hai il permesso di aggiornare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarDelete:
                "Non hai il permesso di eliminare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            mailCreate: "Non hai il permesso di creare e-mail. Si prega di contattare l'amministratore.",
            mailRead: "Non hai il permesso di visualizzare le e-mail. Si prega di contattare l'amministratore.",
            mailUpdate: "Non hai il permesso di aggiornare le e-mail. Si prega di contattare l'amministratore.",
            mailDelete: "Non hai il permesso di eliminare le e-mail. Si prega di contattare l'amministratore.",
        },
        message: {
            createDepartment: "Crea dipartimento",
            goToLink: "Vai al Link",
            emailAddressYouProvide: "Esiste già un account con l’indirizzo email fornito.",
            channelPrivacyPolicyNotMet: "La politica di privacy del canale non è rispettata",
            userIsNotInDepartment: "L'utente non è in questo reparto",
            currentDepartment:"Reparto attuale",
            validDepartment:"Reparto valido",
            youCanForwardToThisDepartment:"Puoi inoltrare la conversazione a questo reparto",
            goToSettings:"Vai alle impostazioni",
            changeDepartmentAndForward:"Cambiare reparto e inoltrare",
            selectDepartmentToForwardAgent:"Selezionare il reparto a cui si desidera inoltrare la conversazione per l'agente chiamato {selectAgentName}.",
            selectDepartmentToForward: "Si prega di selezionare il dipartimento al quale si desidera reindirizzare",
            packageConfirmationMessage: "Sei sicuro di voler acquistare il pacchetto? Il pacchetto che acquisti è soggetto a costi in tempo reale. Puoi continuare a usarlo per un anno dopo la cancellazione. Il prezzo di questo prodotto è escluso IVA al 20%.",
            packagePurchaseConfirmation: "Sei sicuro di voler acquistare il pacchetto? I pacchetti mensili verranno addebitati all'inizio di ogni mese. L'uso del pacchetto terminerà dopo la data di cancellazione. Il prezzo di questo prodotto è escluso IVA al 20%.",
            annualPurchaseDiscount: "Cogli l'offerta di sconto del 30% sugli acquisti annuali!",
            customerTables: "Tabelle dei clienti",
            formIntegration: "Integrazione di modulo",
            automationIntegration: "Integrazione di automazione",
            remainingAutomationTask: "Rimanenti attività di automazione",
            createUserError: "Si è verificato un errore durante la creazione dell'utente",
            sendTemplateMessage: "Invia messaggio modello",
            startChatWithDifferentChannel: "Avvia chat con un canale diverso",
            whatsappChatStarter: "Avvio chat WhatsApp",
            pressEnterToJoin: "Premi Invio per unirti alla chat",
            pressEnterToStartChat: "Premi Invio per avviare la chat",
            cannotSendMessage: "Non puoi inviare messaggi a questa persona",
            cannotSendSessionMessage: "Non puoi inviare messaggi di sessione a questa persona",
            conversationNotInYourDepartments: "Questa conversazione non appartiene a nessuno dei tuoi dipartimenti",
            customizeImage: "Se vuoi personalizzare l'immagine",
            clickToUpload: "Clicca qui per caricare un'immagine",
            uploadNote:
                "Di seguito sono riportati i formati di file e le rispettive dimensioni accettate per il caricamento",
            imageSize: "L'immagine non può essere caricata perché supera i 2 MB",
            videoSize: "Il video non può essere caricato perché supera i 20 MB",
            documentSize: "Il documento non può essere caricato perché supera i 2 MB",
            uploading: "Caricamento immagine in corso, attendere prego...",
            uploadSuccess: "Immagine caricata con successo",
            note: "Nota",
            gridView: "Vista di tabella",
            completedTasks: "Compiti completati",
            system: "Sistema",
            destroyedBy: "Distrutto da",
            brand: "Marca",
            channelCreatedSuccess: "Canale creato con successo",
            channelCreatedError: "Impossibile creare il canale",
            plans: {
                types: {
                    supsis: "Pacchetti Rappresentanti",
                    chatbot: "Chatbot",
                    automation: "Automazione",
                    customer_tables: "Tabella Clienti",
                    mail: "Email",
                    tasks: "Compiti",
                    form: "Modulo",
                    whatsapp: "WhatsApp",
                    whatsapp_business: "WhatsApp Business",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    "artificial_intelligence": "Intelligenza Artificiale",
                    "webhook": "Webhook",
                },
            },
            vipCustomerDescription:
                "Contrassegnare questa persona come cliente VIP la porta in cima alla coda e garantisce che riceva un servizio prioritario.",
            switchOn: "Acceso",
            switchOff: "Spento",
            ownerDescription:
                "Questa funzione indica il proprietario di una chat. Indipendentemente dallo stato del proprietario (online o offline), le chat vengono sempre assegnate al proprietario. Le chat di proprietà possono essere visualizzate solo dal rispettivo proprietario e non possono essere risposte dal chatbot.",
            permissionError: "Non hai il permesso di eseguire questa azione!",
            copySuccess: "Contenuto copiato con successo!",
            unowned: "Senza proprietario",
            jsonPreview: "ANTEPRIMA JSON",
            enterNewValue: "Inserisci un nuovo valore",
            updatePreferredLanguage: "Aggiorna lingua preferita",
            updateTags: "Aggiorna tag",
            updateEmail: "Aggiorna email",
            enterNewEmail: "Inserisci una nuova email",
            deleteConfirmation: "Conferma eliminazione",
            confirmDelete: "Sei sicuro di voler eliminare questa funzione?",
            yesDelete: "Sì, elimina",
            vipCustomer: "★ Cliente VIP",
            takeControlFromChatbot: "Prendi il controllo dal chatbot",
            enterJoin: "Puoi entrare nella conversazione premendo il tasto Invio",
            watchChat: "Guarda la conversazione",
            untitledAutomation: "👉 Automatizzazione di clic sul profilo senza titolo",
            event: "Evento",
            chatbotSettings: "Impostazioni di routing del chatbot",
            chatbotScenarioNotFound: "Scenario del chatbot non trovato",
            noChatbotScenario: "Nessuno scenario di chatbot trovato nel sistema.",
            scenarioNotFound: "Scenario non trovato",
            descNotAvailable: "Descrizione non disponibile",
            lastRegulation: "Ultima regolamentazione",
            taskCreator: "Creatore del compito",
            noPermission: "Non hai il permesso di creare attività.",
            noPermissionDescription: "Non hai il permesso di eseguire questa azione.",
            notAppointed: "Non nominato",
            changeStage: "Cambiare fase",
            selectedCandidates: "1 candidato selezionato",
            coverPhotoRemove: "Rimuovere la foto di copertura",
            coverPhotoSet: "Imposta come foto di copertura",
            autoTransfer: "Trasferisci automaticamente i tuoi contatti a Zoho",
            autoTransferDescription:
                "I contatti che arrivano a questo canale vengono trasferiti automaticamente al modulo contatti di Zoho CRM. Quelli trasferiti a Zoho attivano i widget di Zoho.",
            zohoChannelRequiredTitle: "Canale Zoho CRM necessario",
            zohoChannelRequiredContent: "Non hai un canale Zoho CRM. Clicca qui per aggiungerne uno immediatamente.",
            okText: "Aggiungi canale Zoho CRM",
            cancelText: "Annulla",
            forceQueueForNoOwnerContacts: "Costringere i contatti senza proprietario ad attendere in coda",
            forceQueueDescription:
                "Solo i contatti posseduti vengono assegnati automaticamente, costringendo i contatti senza proprietario ad attendere in coda.",
            showNoOwnerContactsToAdmins: "Mostra i contatti senza proprietario solo agli amministratori",
            showNoOwnerContactsDescription: "I contatti senza proprietario sono visibili solo agli amministratori.",
            autoAssignOwner: "Assegnazione automatica del proprietario del contatto",
            autoAssignOwnerDescription:
                "Quando la chat viene assegnata automaticamente a un rappresentante, viene anche assegnata come proprietario.",
            creator: "Creatore",
            hideShow: "Nascondi / Mostra",
            url: "URL",
            cannedMessages: "Messaggi predefiniti",
            templateMessages: "Messaggi di modello",
            chatbots: "Chatbot",
            noCannedMessages: "Nessun messaggio predefinito trovato",
            filterToFindMore: "Puoi trovare più messaggi predefiniti modificando i tuoi filtri.",
            runPrompt: "Esegui Prompt",
            noLeadsFound: "Nessun lead trovato per questa persona",
            deals: "Offerte",
            noDealsFound: "Nessuna offerta trovata per questa persona",
            loadingDeals: "Caricamento delle offerte",
            zohoCRM: "Zoho CRM",
            viewContact: "Visualizza contatto",
            noNotesAdded: "Nessuna nota aggiunta ancora",
            attachments: "Allegati",
            addNewNote: "Aggiungi nuova nota",
            savingg: "Salvataggio...",
            warningFillFields: "Si prega di compilare i campi titolo e contenuto.",
            successNoteAdded: "Nota aggiunta con successo.",
            errorAddingNote: "Si è verificato un errore durante l'aggiunta della nota.",
            noteTitle: "Titolo della nota",
            noteContent: "Contenuto della nota",
            selectPreferredAgent: "Seleziona l'agente preferito che desideri assegnare al visitatore.",
            postOperations: "Operazioni di pubblicazione",
            loadingPostOperations: "Caricamento delle operazioni di pubblicazione",
            noPostOperations: "Nessuna operazione di pubblicazione trovata per questa persona",
            postOperationDetails: "Dettagli delle operazioni di pubblicazione",
            noMediaDocuments: "Nessun media o documento disponibile per questa persona.",
            selectionLimitError: "Puoi selezionare un massimo di 30 elementi.",
            showNote: "Mostra nota a tutti",
            hideNote: "Nascondi nota",
            updateNote: "Aggiorna nota",
            addUserNote: "Aggiungi una nota sull'utente",
            privateNote: "Nota privata",
            metaReferrals: "Riferimenti Meta",
            noMetaReferrals: "Nessuna interazione pubblicitaria Meta trovata.",
            searchPrompt: "Cerca qualcosa.",
            noRecentResults: "Nessun risultato recente trovato.",
            contactInfo: "Informazioni di contatto",
            noPropertiesAdded: "Nessuna proprietà aggiunta ancora.",
            propertyAddedUpdated: "Proprietà aggiunta/aggiornata con successo.",
            propertyError: "Si è verificato un errore durante l'aggiunta/aggiornamento della proprietà.",
            propertyDeleted: "Proprietà eliminata con successo.",
            propertyDeleteError: "Si è verificato un errore durante l'eliminazione della proprietà.",
            zohoSynchronization: "Sincronizzazione Zoho",
            zohoSyncConfirmation: "Vuoi apportare modifiche alla persona in Zoho?",
            hideOtherInfo: "Nascondi altre informazioni",
            showOtherInfo: "Mostra altre informazioni",
            whatsappChatStart: "Avvia chat WhatsApp",
            ownership: "Proprietà del cliente",
            countryAndLanguage: "Paese, Lingua",
            calendarEvent: "Evento del calendario",
            reservation: "Prenotazione",
            contact: "Contatto",
            user: "Utente",
            customerOwnership: "Proprietà del cliente",
            ownerless: "Senza proprietario",
            preferredDepartment: "Dipartimento preferito",
            flowluTransfer: "Trasferisci a Flowlu",
            mergeSuccess: "Operazione di fusione completata con successo.",
            visitorOwnershipWarning: "Questo visitatore è di proprietà di un altro utente.",
            newAutomation: "Nuova automazione",
            automations: "Automazioni",
            createProfileAutomation: "Crea automazione profilo",
            profileButtonClicked: "Pulsante profilo cliccato",
            profileButtonDescription: "Questa automazione verrà attivata quando viene cliccato un pulsante profilo.",
            automationName: "Nome dell'automazione",
            create: "Crea",
            dayRange: "Intervallo di giorni",
            hourRange: "Intervallo di ore",
            last24Hours: "Ultime 24 ore",
            today: "Oggi",
            yesterday: "Ieri",
            thisWeek: "Questa settimana",
            lastWeek: "Settimana scorsa",
            last7Days: "Ultimi 7 giorni",
            last30Days: "Ultimi 30 giorni",
            thisMonth: "Questo mese",
            lastMonth: "Mese scorso",
            startDateTime: "Data e ora di inizio",
            endDateTime: "Data e ora di fine",
            complaint: "Reclamo",
            opens: "Aperture",
            clicks: "Clic",
            mockData: "(Dati di prova)",
            preferredRepresentative: "Seleziona un agente preferito",
            forwardToDepartment: "Invia a dipartimento",
            toMobileAgents: "Ai agenti mobili",
            noMediaAndDocuments: "Questo utente non ha media o documenti",
            reportBug: "Segnala un errore",
            waitingForReply: "In attesa di risposta",
            memorySize: "Dimensione della memoria",
            usedMemory: "Memoria utilizzata",
            availableMemory: "Memoria disponibile",
            memoryLimit: "Limite della memoria",
            memoryLimitPrice: "Prezzo per la memoria aggiuntiva",
            telegramBotIsReachable: "Il servizio di bot di Telegram ha un errore",
            telegramBotIsHealthy: "Il servizio di bot di Telegram è sano",
            telegramBotIsUnhealthy: "Il servizio di bot di Telegram ha un errore",
            pieView: "Vista a torta",
            chartView: "Vista grafico",
            tableView: "Vista tabella",
            lastUpdate: "ultimo aggiornamento",
            workflow: "flusso di lavoro",
            task: "task",
            filterBy: "Per filtro",
            watchAllLive: "Guarda tutte le dirette",
            sessionsUnique: "Sessioni (utenti unici)",
            sessionsAll: "Sessioni (tutti gli utenti)",
            moreFeaturesDesc:
                "Più funzioni, più integrazioni, più agenti! Agisci subito per gestire meglio il tuo team e far crescere la tua attività al massimo del suo potenziale!",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads connessi con successo",
            failedToConnectMetaLeads: "Connessione fallita a Meta Leads",
            forbiddenChannel: "Canale vietato",
            forbiddenChannelDesc: "Non sei autorizzato a visualizzare questo canale",
            firstContact: "Primo contatto",
            needsAnalysis: "Analisi dei bisogni",
            offerSent: "Offerta inviata",
            offerReview: "Revisione dell'offerta",
            decisionPhase: "Fase decisionale",
            personDeleted: "Persona eliminata",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Numero di telefono non valido",
            owner: "Proprietario",
            addAnItem: "Aggiungi un elemento",
            saveItem: "Salva elemento",
            customItem: "Elemento personalizzato",
            backgroundPhoto: "Immagine di sfondo",
            whenYouActivateFeature: "Quando si attiva questa funzione, essa non apparirà nella pagina di prenotazione",
            logo: "Logo",
            noLogo: "Nessun logo",
            addTeamMember: "Aggiungi un membro del team",
            timezone: "Fuso orario",
            selectDayys: "Seleziona giorno/i",
            selectStartHour: "Selezionare l'ora di inizio",
            selectEndHour: "Selezionare l'ora di fine",
            moveLeft: "Sposta a destra",
            moveRight: "Sposta a sinistra",
            reply: "Risposta",
            replyToAll: "Rispondi a tutti",
            deleteThreadMessage: "Messaggio di cancellazione della discussione",
            totalEmailsBounced: "Totale email rimbalzate",
            totalEmailsComplained: "Totale email di cui ci si lamenta",
            untilNowTotalEmailOpens: "Totale aperture di email finora",
            untilNowTotalEmailLinkClicks: "Totale clic sul link dell'email fino a quel momento",
            uniqueClicks: "Clic unici",
            untilNowTotalUniqueEmail: "Totale di clic unici sul link dell'email (per destinatario)",
            emailCampaignTimeline: "Timeline della campagna e-mail",
            receivedBroadcasts: "Trasmissioni ricevute",
            groupDeletedSuccessfully: "Gruppo eliminato con successo",
            verify: "Verifica",
            done: "Fatto",
            pleaseSelectAnEmailAddress: "Selezionare un indirizzo e-mail",
            goBack: "Torna indietro",
            show: "Mostra",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Salva design",
            exportHTML: "Esportazione HTML",
            saveAsEmailCustomerGroup: "Salva come gruppo di clienti e-mail",
            saveAsWhatsappCustomerGroup: "Salva come gruppo di clienti Whatsapp",
            deleteModalFormDesc:
                "Se si elimina questo modulo, tutti i dati del modulo saranno eliminati in modo permanente. Siete sicuri di voler continuare?",
            todo: "Cose da fare",
            inProgress: "In corso",
            approval: "Approvazione",
            completed: "Completato",
            transactionType: "Tipo di transazione",
            previousBalance: "Saldo precedente",
            nextBalance: "Saldo successivo",
            amount: "Importo",
            wpIntegrationChannelRequired: "Canale di integrazione Whatsapp Web richiesto",
            wpIntegrationChannelRequiredDesc:
                "L'integrazione Chatbot + Whatsapp Web richiede un canale Whatsapp Web. Creare un nuovo canale",
            wabaIntegrationChannelRequired: "Canale di integrazione Whatsapp Business richiesto",
            wabaIntegrationChannelRequiredDesc:
                "L'integrazione Chatbot + Whatsapp Business API richiede il canale web Whatsapp. Creare un nuovo canale",
            instaIntegrationChannelRequired: "Canale di integrazione Instagram richiesto",
            instaIntegrationChannelRequiredDesc:
                "L'integrazione Chatbot + Instagram richiede un canale Instagram. Si prega di creare un nuovo canale",
            createWpChannel: "Crea canale web Whatsapp",
            createWabaChannel: "Crea canale API Whatsapp Business",
            createInstaChannel: "Crea canale Instagram",
            failedToDeleteGroup: "Errore nell'eliminazione di un gruppo",
            failedToDeleteGroups: "Errore nell'eliminazione dei gruppi",
            failedToFetchGroupContacts: "Impossibile recuperare i contatti del gruppo",
            mailAddressDeletedSuccessfully: "Indirizzo di posta eliminato con successo",
            defaultMailAddressChangedSuccessfully: "L'indirizzo di posta predefinito è stato modificato con successo",
            mailAddressAlreadyRegistered: "L'indirizzo di posta non può essere già registrato o vuoto",
            pleaseVerifyByClicking: "Si prega di verificare cliccando sul link inviato al proprio indirizzo e-mail",
            signSucsRegistered: "Firma registrata con successo",
            myContacts: "I miei contatti",
            unanswered: "Mancato",
            emailBroadcasts: "Trasmissioni e-mail",
            monthlyLimit: "Limite mensile",
            totalShipments: "Totale spedizioni",
            shippingStatus: "Stato della spedizione",
            lastAction: "Ultima azione",
            receiver: "Ricevitore",
            delivered: "Consegnato",
            opened: "Aperto",
            clicked: "Cliccato",
            bounced: "È tornato",
            clickedLinks: "Link cliccati",
            reason: "Motivo",
            timer: "Timer",
            implemented: "Implementato?",
            module: "Modulo",
            excelDownload: "Download di Excel",
            serviceFeatures: "Caratteristiche del servizio",
            mailAddressDeletedSucs: "Indirizzo di posta cancellato con successo",
            inputSearchText: "Inserire il testo di ricerca",
            createRecord: "Crea record",
            separatorCharacter: "Carattere separatore",
            exampleResultPreview: "Anteprima del risultato",
            importRecords: "Importazione di record",
            equals: "Uguale",
            notEquals: "Non uguale",
            beginsWith: "Inizia con",
            endsWith: "Finisce con",
            greaterThan: "Maggiore",
            lessThan: "Meno di",
            before: "Prima",
            after: "Dopo",
            is: "O",
            isNot: "Non",
            empty: "Vuoto",
            notEmpty: "Non vuoto",
            isOneOff: "Una volta",
            field: "Campo",
            records: "Record",
            addIntegration: "Aggiungi integrazione",
            chatbotScenarioReleased: "Scenario chatbot rilasciato",
            chatbotScenarioHasBeenCancelled: "Scenario chatbot annullato",
            titleAndDesc: "Titolo e descrizione",
            templateAndMailSelection: "Modello e selezione della posta",
            peopleToSend: "Persone a cui inviare",
            submissionPlans: "Piano di invio",
            summary: "Riepilogo",
            broadcastTitle: "Titolo della trasmissione",
            sentByEmail: "Email inviata",
            emailTemplate: "Modello di e-mail",
            onlyPeopleWithEmail: "Solo le persone con un indirizzo e-mail sono valide per l'invio",
            sendNow: "Invia ora",
            plan: "Piano",
            senderEmail: "Email del mittente",
            totalBuyer: "Acquirente totale",
            estimatedDuration: "Durata stimata",
            person: "Persona",
            shippingIsNowComplete: "La spedizione è completata!",
            back: "Indietro",
            customerName: "Nome del cliente",
            customerEmail: "Email del cliente",
            customValue: "Valore personalizzato",
            selectMailTemplate: "È necessario selezionare un modello di posta",
            youMustSelectSendingMailAddress: "È necessario selezionare l'indirizzo di posta elettronica di invio",
            youMustSelectCustomerGroupSend: "È necessario selezionare il gruppo di clienti a cui inviare",
            createBroadcast: "Creare una trasmissione",
            broadcastDetails: "Dettagli della trasmissione",
            youCanCheckYourEmailStatus:
                "Puoi controllare lo stato delle tue e-mail aggiornando il tuo piano. Puoi controllare lo stato delle tue e-mail aggiornando il tuo piano.",
            sentDetails: "Dettagli dell'invio",
            failed: "Non riuscito",
            total: "Totale",
            totalEmailsProcessed: "Totale email elaborate",
            totalEmailsDelivered: "Totale email inviate",
            toAvailableAgents: "Per gli agenti disponibili",
            toAvailableDepartments: "Per i reparti disponibili",
            toWithAgentAndDepartment: "Con agente e reparto",
            toMobilAgents: "Agli agenti mobili",
            toPreferredAgents: "Agli agenti preferiti",
            searchAgent: "Agente di ricerca",
            searchDepartment: "Reparto di ricerca",
            searchMobileAgent: "Agente mobile di ricerca",
            searchAgentOrDepartment: "Agente o reparto di ricerca",
            searchPreferredAgent: "Cerca l'agente preferito",
            noAgentsAvailableToForward: "Nessun agente disponibile per l'inoltro",
            noDepartmentsAvailableToForward: "Nessun reparto disponibile per l'inoltro",
            noMobileAgentsAvailableToForward: "Nessun agente mobile disponibile per l'inoltro",
            noPreferredAgentsAvailableToForward: "Nessun agente preferito disponibile per l'inoltro",
            ifYouSendThisConversationToTheQueue:
                "Se si invia questa conversazione alla coda, l'utente viene rimosso dalla chat e la conversazione viene messa in coda. Se l'assegnazione automatica della chat è abilitata, la conversazione verrà assegnata a un agente appropriato e potrà essere ritrasferita all'utente",
            ifAutomaticChatAssignmentIsDisabled:
                "Se l'assegnazione automatica della chat è disabilitata, la chiamata rimarrà in coda. Il personale autorizzato può prendere la chiamata dalla coda",
            sendQueue: "Invia alla coda",
            agentName: "Nome agente",
            departmentName: "Nome del reparto",
            toQueue: "Coda",
            web: "Web",
            mobile: "Mobile",
            noGrouping: "Nessun raggruppamento",
            groupByThis: "Raggruppa per questo",
            selectGroupingCriteria: "Seleziona criteri di raggruppamento",
            activeUsers: "Utenti attivi",
            passiveUsers: "Utenti passivi",
            noPlatform: "Nessuna piattaforma specificata",
            noRole: "Ruolo non specificato",
            noDepartment: "Nessun dipartimento specificato",
            noLanguage: "Nessuna lingua specificata",
            group2: "Gruppo",
            groupedByStatus: "Raggruppati per stato",
            grouping: "Raggruppamento",
            activeSubjects: "Soggetti attivi",
            passiveSubjects: "Soggetti passivi",
            groupSubjects: "Soggetti del gruppo",
            showAll: "Mostra tutti",
            onlyActive: "Solo attivi",
            onlyPassive: "Solo i passivi",
            groupBy: "Raggruppa per Stato",
            selectTimezone: "Selezionare il fuso orario",
            userFilter: "Filtro utente",
            confidenceScore: "Punteggio di fiducia",
            chatbotLanguage: "Lingua del chatbot",
            botScenerio: "Scenario bot",
            selectTemplate: "Seleziona modello",
            importFromReadyTemplates: "Importa da modelli pronti",
            classification: "Classificazione",
            addClassification: "Aggiungi classificazione",
            expressionClassified: "Espressione da classificare",
            zohoModuleName: "Nome del modulo Zoho",
            selectModule: "Seleziona modulo",
            standardFields: "Campi standard",
            selectStandardField: "Seleziona campo standard",
            customFields: "Campi personalizzati",
            selectCustomFields: "Seleziona campo personalizzato",
            aiFunction: "Funzione di intelligenza artificiale",
            aiFunctionDesc:
                "Gestione della funzione di intelligenza artificiale per eseguire azioni basate sugli input dell'utente",
            functionName: "Nome della funzione",
            functionDesc: "Descrizione della funzione",
            addParameter: "Aggiungi parametro",
            chooseAiStory: "Scegli una storia di IA",
            chatbotAiPromptDesc:
                "L'intelligenza artificiale apprende e determina il comportamento da tenere ricevendo istruzioni su un compito o un problema specifico grazie alla funzione 'prompt'",
            enterPrompt: "Inserire il prompt",
            aiParameterTunings: "Regolazione dei parametri dell'intelligenza artificiale",
            aiParameterTuningsDesc:
                "È possibile regolare i parametri dell'IA per renderla più reattiva e precisa. Questi parametri sono usati per controllare il comportamento dell'IA e il modo in cui risponde agli input dell'utente.",
            temperatura: "Temperatura",
            temperatureDesc:
                "La temperatura di campionamento da utilizzare, compresa tra 0 e 2. Valori più alti, come 0,8, renderanno l'output più casuale, mentre valori più bassi, come 0,2, lo renderanno più mirato e deterministico.",
            topDesc:
                "In alternativa al campionamento per temperatura, il cosiddetto campionamento kernel, il modello considera i risultati dei token con la massa di probabilità top_p. Quindi 0,1 significa che vengono considerati solo i token con la massa di probabilità superiore al 10%. Di solito si consiglia di cambiare questo o la temperatura, ma non entrambi.",
            toolChoices: "Opzioni dello strumento",
            noneDesc:
                "Nessuno significa che il modello non richiamerà alcuno strumento e genererà invece un messaggio.",
            autoDesc:
                "La modalità automatica è il valore predefinito e significa che il modello può scegliere se generare un messaggio o invocare uno o più agenti.",
            requiredDesc:
                "La modalità richiesta è che il modello deve chiamare uno o più agenti prima di rispondere all'utente.",
            createArticles: "Crea articolo",
            createArticlesDesc: "Crea articoli per aiutare gli utenti a trovare risposte alle loro domande",
            articlesTitle: "Titolo dell'articolo",
            articlesContent: "Contenuto dell'articolo",
            createFaq: "Creare una domanda frequente (FAQ)",
            createFaqDesc:
                "Crea una nuova FAQ per il tuo chatbot. Questo aiuterà il chatbot a rispondere alle domande dell'utente",
            question: "Domanda",
            saveAndClose: "Salva e chiudi",
            contentPreview: "Anteprima del contenuto",
            upgradePackageTitle: "Aggiornate il vostro pacchetto ed evitate i limiti",
            upgradePackageDescription:
                "Più funzioni, più integrazioni, più agenti! Agite subito per gestire meglio il vostro team e massimizzare il vostro potenziale commerciale!",
            upgradePackage: "Aggiornamento",
            deleteSelected: "Eliminare i file selezionati",
            newFolder: "Nuova cartella",
            newFile: "Nuovo file",
            noFilesFound: "Non sono stati trovati file in questa cartella",
            uploadFile: "Carica file",
            enterFolderName: "Inserire il nome della cartella",
            folderName: "Nome cartella",
            dropFileHere: "Lascia i file qui",
            createFolder: "Crea cartella",
            fileUploadingError: "Si è verificato un errore durante il caricamento di un file",
            fileUploadingSucs: "Cartella creata con successo",
            folderNameNotEmpty: "Il nome della cartella non può essere vuoto",
            deleteFolder: "Elimina cartella",
            sureDeleteFolder: "Sei sicuro di voler eliminare questa cartella e tutti i file in essa contenuti?",
            deletionSucs: "Cancellazione riuscita",
            deleteFile: "Elimina file",
            sureDeleteFile: "Siete sicuri di voler eliminare questo file?",
            deletionError: "Si è verificato un errore durante il processo di cancellazione",
            selectFile: "Seleziona file",
            moreThanOneSelect: "È possibile selezionare più di un file",
            selectAnFile: "Selezionare un file",
            removeZohoLinkbulkSms: "SMS di massa",
            sendBulkSmsCustomers: "Invia SMS di massa ai tuoi clienti",
            writeYourMessage: "Scrivi qui il tuo messaggio",
            sendSms: "Invia SMS",
            sendSmsYourCustomers: "Invia SMS ai tuoi clienti",
            manageChannelDetail: "Gestisci informazioni sul canale",
            details: "Dettagli",
            teamGramChannels: "Canali TeamGram",
            newTeamGramIntegration: "Nuova integrazione di TeamGram",
            teamGramIntegration: "Integrazione TeamGram",
            notMoreThanOneTeamGramChannels: "Non è possibile creare più di un canale TeamGram",
            teamGramDetail: "Dettaglio TeamGram",
            manageYourTeamGramIntegration: "Gestisci la tua integrazione TeamGram",
            trendyolChannels: "Canali Trendyol",
            trendyolStoreIntegration: "Integrazione del negozio Trendyol",
            trenyolStoreConnection: "Connetti il tuo negozio Trendyol",
            deleteTrendyolIntegration: "Elimina l'integrazione Trendyol",
            sureDeleteTrendyolIntegration:
                "Siete sicuri di voler eliminare l'integrazione Trendyol? Questa azione è irreversibile",
            trendyolStoreChannel: "Canale del negozio Trendyol",
            deleteTrendyolChannel: "Cancellare il canale Trendyol",
            channelUpdatedSucs: "Canale aggiornato con successo",
            failedUpdateChannel: "Aggiornamento del canale non riuscito",
            trendyolStoreIntegrationDetail: "Dettaglio integrazione negozio Trendyol",
            configureTrendyolStoreIntegrationDetail: "Configura la tua integrazione con il negozio Trendyol",
            trenyolStoreProductQuestManage: "Trendyol Store - Gestione delle richieste di prodotto",
            trendyolStoreDesc:
                "È possibile utilizzare le seguenti impostazioni per gestire le richieste di informazioni sui prodotti del negozio Trendyol",
            zohoCrmChannels: "Canali di Zoho CRM",
            zohoPersonalChannel: "Canali personali Zoho",
            connectZoho: "Connettiti a Zoho CRM",
            updateChannelDesc5: "Aggiornamento del canale Zoho CRM",
            zohoCrmIntegration: "Integrazione di Zoho CRM",
            sureDeleteZohoChannel: "Sei sicuro di voler eliminare il canale Zoho CRM?",
            createNotMoreThanOneZohoChannels: "Non è possibile creare più di un canale Zoho",
            removeZohoLink: "Rimuovere il collegamento Zoho",
            connectToZoho: "Connettersi a Zoho",
            chatClosed: "Chat chiusa",
            scoreChat: "Conversazione conclusa",
            createdTicket: "Biglietto creato",
            updatedTicket: "Biglietto aggiornato",
            newUserCreated: "Nuovo utente creato",
            updateUser: "Utente aggiornato",
            deleteUsers: "Utente cancellato",
            changeStatusRepresent: "Lo stato del rappresentante è cambiato",
            incomingMessage: "Messaggio in arrivo",
            outgoingMessage: "Messaggio in uscita",
            createdNewTicket: "Nuovo biglietto creato",
            bitrix24Channels: "Canali Bitrix24",
            sureDeleteBitrixChannel: "Sei sicuro di voler cancellare il canale Bitrix24?",
            bitrix24Integrations: "Integrazione Bitrix24",
            notCreateMoreThenOneChannel: "Non è possibile creare più di un canale Ideasoft",
            connectToBitrix24: "Connetti a Bitrix24",
            connectToBitrix24Api: "Connetti a Bitrix24 Api",
            updateChannel: "Canale di aggiornamento",
            updateChannelDesc: "Aggiorna il canale Api di Bitrix24",
            yourBitrix24Domain: "Il vostro nome di dominio Bitrix24",
            bitrix24ConnectedSucs: "Bitrix24 connesso con successo",
            failedToConnectBitrix24: "Connessione fallita a Bitrix24",
            channelCreatedSuccessfully: "Canale creato con successo",
            failedToCreateChannel: "Canale non creato",
            holidayPlusChannels: "Canali Holiday+",
            newHolidayPlusIntegration: "Nuova integrazione Holiday+",
            holidayPlusIntegrations: "Integrazione Holiday+",
            notCreateMoreThanOneHolidayChannel: "Non è possibile creare più di un canale Holiday+",
            holidayPlusDetail: "Dettaglio Holiday+",
            manageHolidayPlusIntegration: "Gestisci l'integrazione Holiday+",
            ideasoftChannels: "Canali Ideasoft",
            connectToIdeasoft: "Connettiti a Ideasoft",
            connectToIdeasoftApi: "Connettersi a Ideasoft api",
            updateChannelDesc2: "Aggiornamento del canale Whatsapp business api",
            ideasoftIntegration: "Integrazione Ideasoft",
            sureDeleteIdeasoftChannel: "Sei sicuro di voler eliminare il canale Ideasoft?",
            moreThanOneChannelError: "Non è possibile creare più di un canale Ideasoft",
            websiteAddress: "Indirizzo del sito web",
            ideasoftConnectedSucs: "Ideasoft si è connesso con successo",
            failedToConnectIdeasoft: "Connessione fallita a Ideasoft",
            redirectURLcopiedToClipboard: "URL di reindirizzamento copiato negli appunti",
            openAIChannels: "Canali openAI",
            newOpenAiChannel: "Nuovo canale OpenAI",
            createNewChannelOpenAi: "Crea un nuovo canale per OpenAI",
            updateChannelDesc3: "Aggiornamento del canale Whatsapp business api",
            openAiIntegration: "Integrazione OpenAI",
            sureDeleteOpenAiChannel: "Sei sicuro di voler eliminare il canale OpenAI?",
            createMoreThenOneOpenAiChannel: "Non è possibile creare più di un canale OpenAI",
            postaCellChannels: "Canali PostaCell",
            newPostaCellChannel: "Nuovi canali PostaCell",
            createNewPostaCellChannel: "Crea un nuovo canale per il provider di sms PostaCell",
            updateChannelDesc4: "Aggiornamento del canale Whatsapp business api",
            accessControl: "Controllo degli accessi",
            leads: "Conducenti",
            ensureFacebookAccount: "Assicurarsi che abbia un account e una pagina Facebook",
            ensureAdAccount: "Assicurarsi che abbia un account pubblicitario",
            page: "Pagina",
            questions: "Domande",
            leadCount: "Conteggio dei lead",
            showLeads: "Mostra lead",
            syncLeeds: "Sincronizza Leeds",
            wpStartChat: "Lanciatore di chat Whatsapp",
            archivedIn: "Archiviato?",
            makeSelect: "Effettua selezione",
            newLead: "Nuovo Leed",
            initalContact: "Primo contatto",
            needsAssessnment: "Analisi dei bisogni",
            proposalSent: "Offerta inviata",
            proposalReview: "Revisione della proposta",
            negotiation: "Contrattazione",
            decisionStage: "Fase decisionale",
            closure: "Kanapnış",
            followUp: "Follow",
            campagin: "Campagna",
            adSet: "Ad Set",
            ad: "Annuncio",
            inArchived: "Archiviato",
            deletedSelectedPerson: "Elimina le persone selezionate",
            sureDelSelectedPerson: "Sei sicuro di voler cancellare le persone selezionate?",
            deletePerson: "Cancellare una persona",
            sureDeletePerson: "Sei sicuro di voler cancellare la persona?",
            phoneNumberNotAvailable: "Numero di telefono non disponibile",
            statusSucsUpdated: "Stato aggiornato con successo",
            statusUpdatedFailed: "Si è verificato un errore durante l'aggiornamento dello stato",
            archivedContact: "Contatto archiviato",
            sureWantArchivePerson: "Sei sicuro di voler archiviare questa persona?",
            personArchived: "Persona archiviata",
            personArchivedHead: "Operazione di archiviazione non riuscita",
            metaLeadChannels: "Meta Lead Channels",
            wpStartSpeech: "Avvio discorso Whatsapp",
            pleaseSelectStartChat: "Selezionare il canale su cui si desidera avviare la chat:",
            phoneNumber: "Numero di telefono",
            phoneNumberDesc: "Codice paese con solo numeri senza spazi",
            channelDesc: "Su quale canale si desidera avviare la chat",
            pleaseSelectStartChatOn: "Selezionare il canale su cui si desidera avviare la chat",
            notAuthorisedChannel: "Non sei autorizzato ad accedere a questo canale",
            phoneNumberError: "Numero di telefono non corretto",
            chatStartError: "Si è verificato un errore nell'avvio della chat. Riprovare",
            noRecordFailed: "Nessun record trovato",
            metaLeadsChannel: "Canale Meta Leads",
            mlChannelDetails: "Dettagli del canale Meta Leads",
            manageMlChannel: "Gestisci i tuoi Meta Leads",
            deleteMetaLeadsChannelInfo: "Sei sicuro di voler eliminare il canale Meta Leads?",
            contactPage: "Pagina dei Contatti",
            addRouted: "Aggiungi instradato",
            otherEmailProviders: "Altri provider di posta elettronica",
            visitorScreenNaming: "Nomi delle schermate dei visitatori",
            enterCatalogTitle: "Inserire il titolo del catalogo...",
            passwordUpdate: "Aggiornare la password",
            showCenterScreen: "Visualizzazione al centro dello schermo",
            skipNow: "Salta ora",
            confirm: "Confermare",
            newTable: "Nuova tabella",
            actions: "Transazioni",
            integrationsTrendyol:
                "Collega il tuo negozio Trendyol e rispondi automaticamente alle domande dei tuoi clienti.",
            integrationsHoliday: "Integra Holiday+ per fornire hotel e camere tramite chatbot!",
            integrationsTeamgram:
                "Trasferisci i tuoi clienti da Supsis a Teamgram per semplificare la gestione dei clienti!",
            integrationsTicimax: "Invia un messaggio automatico ai membri segmentati di Ticimax.",
            integrationsBitrix24: "Attiva l'API Bitrix24 per un'esperienza chatbot migliorata per i tuoi clienti.",
            integrationsIdeasoft: "Attiva l'API Ideasoft per un'esperienza chatbot migliorata per i tuoi clienti.",
            integrationsOpenAI:
                "Attivare i servizi OpenAI, Risposta dell'IA del Chatbot, Assistente IA CoPilot, Base di conoscenza dell'IA del Chatbot.",
            integrationsSMSPostacell: "Attiva l'invio di SMS tramite il fornitore di SMS PostaCELL.",
            integrationsMetaLeads:
                "Gestisci i tuoi contatti Meta tramite Supsis. Collega i contatti ai ticket, al chatbot o al supporto live.",
            integrationsZoho: "Integrate i vostri processi aziendali in Zoho CRM con Supsis.",

            forward: "in avanti",
            packUpRequired: "Aggiornamento del pacchetto richiesto",
            upgradePack: "Pacchetto di aggiornamento",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "App per IOS e Android sul mercato!",
            sendEmail: "Invia e-mail",
            jumpToMessage: "Clicca per andare al messaggio",
            doesntMatter: "Non importa",
            events: "Calendario eventi",
            reservations: "Prenotazioni",
            designer: "Design",
            targetContacts: "Contatti di destinazione",
            scheduler: "Scheduler",
            planAndTask: "Piano e compiti",
            insights: "Approfondimenti",
            createRole: "Crea ruolo",
            createSubject: "Creare il soggetto",
            createUser: "Crea utente",
            blockManuel: "Blocco Manuel",
            showHide: "mostra/nascondi",
            contactSearch: "Ricerca contatti",
            favorite: "preferiti",
            downloadAllData: "scaricare tutti i dati",
            downloadThePage: "Scarica la pagina",
            choosePoints: "scegli punti",
            channel: "Canale",
            createdAt: "Creato a",
            action: "azione",
            searchChannel: "Ricerca Canali",
            activeChannels: "Canali attivi",
            deleteChannels: "Canali eliminati",
            selectChannel: "Seleziona Canale",
            channelFilter: "Filtro canale",
            noConversationDesc: "Qui puoi vedere le chat attive e le chat assegnate a te.",
            forMe: "Per me",
            unAssigned: "Non assegnato",
            agentDetails: "Dettagli dell'agente",
            contactProperties: "Proprietà di contatto",
            goToProfile: "Vai al profilo",
            addNote: "Aggiungi nota",
            noPreferredAgent: "Nessun agente preferito ancora",
            toPrefer: "Preferire",
            inChat: "Nella chat",
            watching: "Guardando",
            chatsTitle: "Chat",
            dealyTimeMaxValueError: "Il tempo di ritardo può essere al massimo 15",
            dealyTimeTypeError: "Il valore del tempo di ritardo deve essere un numero",
            passedTimeHm: "{hour} Ore {min} Minuti",
            passedTimeMs: "{min} Minuti {sec} secondi",
            passedTimeSc: "{sec} Secondi",
            translateMessage: "Il tuo messaggio è stato tradotto dall'intelligenza artificiale.",
            toneChanged: "Il tono del messaggio è stato cambiato in {tone}",
            aiResponseAdded: "Risposta AI aggiunta al messaggio",
            messageLonger: "Messaggio reso più lungo",
            grammarFixed: "Grammatica corretta",
            aiTranslate: "Traduzione",
            other: "Altro",
            yourLanguage: "La tua lingua",
            contactLanguage: "lingua del cliente",
            myLanguage: "La mia lingua",
            forwardToChatbot: "Inoltra al Chatbot",
            friendly: "Amichevole",
            confident: "Sicuro",
            straightForward: "Diretto",
            casual: "Casuale",
            professional: "Professionale",
            longSentence: "Frase Lunga",
            changeTone: "Cambia Tonalità",
            fixGrammar: "Correggi Grammatica",
            aiResponse: "Risposta AI",
            templateButtonNote:
                "Per vietare il contatto, fare attenzione a utilizzare i seguenti testi sul pulsante di divieto. Indipendentemente dalle lettere maiuscole o minuscole",
            templateButtonTags: "#Invia messaggio# | #Annulla iscrizione# | #Vieta# | #Blocca#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Modulo calendario",
            taskModule: "Modulo di gestione delle attività",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Nessun dipartimento preferito",
            searchForDepartment: "Cerca dipartimento",
            departmentAssignedToTheVisitor: "Seleziona il dipartimento che desideri assegnare al visitatore.",
            assignPreferredDepartment: "Assegna il dipartimento preferito",
            smsChannel: "Canale SMS: ",
            whatsappv2Channel: "Canale Whatsapp V2: ",
            whatsappv1Channel: "Canale Whatsapp V1: ",
            wBChannel: "Canale Whatsapp Business: ",
            messengerChannel: "Canale Messenger: ",
            instagramChannel: "Canale Instagram: ",
            allPlatforms: "Tutte le piattaforme",
            cbStartMessage: "Messaggio di avvio del chatbot",
            cbStartMessageDesc:
                "Il primo messaggio inserito dall'utente viene elaborato automaticamente dal chatbot e indirizzato all'indirizzo rilevante.",
            messengerUserProfile: "Profilo utente di Messenger",
            instagramUserProfile: "Profilo utente Instagram",
            noEventFound: "Nessun evento trovato",
            visitorMails: "Mail dei visitatori",
            visitorActions: "Azioni dei visitatori",
            notVerified: "Non verificato",
            visitorEvents: "Eventi dei visitatori",
            assignedTasks: "Compiti assegnati",
            mails: "Mail",
            prefferedAgents: "Agenti preferiti",
            createEvent: "Crea evento",
            blockManagement: "Gestione del blocco",
            deleteUser: "Elimina utente",
            blocked: "Bloccato",
            profiles: "Profili",
            similiarProfiles: "Profili simili trovati",
            ReplyAsAPm: "Rispondi come messaggio privato e chiudi",
            replyAsAComment: "Rispondi come commento e chiudi",
            messengerAddDesc: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddPrivacyCheckDesc: "Ho letto e accetto la {Privacy} e i {Terms and Conditions}",
            instaAddDesc5: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddDesc4: "Registrati come sviluppatore Facebook",
            instaAddDesc3: "Assicurati che il commutatore <b>'Consenti l'accesso ai messaggi'</b> sia attivato",
            instaAddDesc2:
                "Assicurati che il tuo account professionale Instagram sia collegato alla tua pagina Facebook",
            instaAddDesc1:
                "Assicurati che il tuo account Instagram sia un account professionale Instagram (account aziendale).",
            selectedDepartment: "Dipartimento selezionato",
            departmentForwardEnable: "Regola di inoltro del dipartimento abilitata",
            departmentForwardRule: "Regola di inoltro del dipartimento",
            departmentForwardDesc: "Seleziona a quale dipartimento inoltrare le chat in arrivo al canale.",
            channelName: "Nome del canale",
            forwardToLiveAgents: "👉 Inoltra agli agenti in diretta",
            manageIgChannel: "Gestisci il tuo canale Instagram",
            igDetail: "Dettaglio Instagram",
            manageVisibilityDesc: "Gestisci chi può vedere questo canale",
            selectAnIgAccount: "Seleziona un account Instagram",
            connectToInsta: "Collegati a Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Sei sicuro di voler eliminare il canale Instagram?",
            instagramChannels: "Canali Instagram",
            suspendedDescription: "Il tuo account è stato sospeso a causa di fatture non pagate.",
            onlyChatbot: "Solo Chatbot",
            onlyAgents: "Solo Agenti",
            checkboxWarning: "Questo campo deve essere obbligatoriamente selezionato",
            sendingAllow: "Invio",
            receiving: "Ricezione",
            platform: "Piattaforma",
            banModalTitle: "Finestra modale di divieto visitatori",
            selectDepartmentDesc: "Seleziona i dipartimenti di cui vuoi modificare la visibilità",
            selectAgentDesc: "Seleziona gli agenti di cui vuoi modificare la visibilità",
            selectDepartment: "Seleziona Dipartimento",
            selectAgent: "Seleziona Agente",
            visibleDepartments: "Dipartimenti visibili",
            visibleAgents: "Agenti visibili",
            visibilityInfoCont: "Tutti gli agenti e i dipartimenti possono vedere questo canale",
            editDepartmentVisibility: "Modifica permessi dipartimento",
            editAgentVisibility: "Modifica permessi agente",
            typeSTToSearch: "Digita qualcosa per cercare gli utenti",
            exportToCSV: "Esporta in CSV",
            clear: "Cancella",
            usedSessionCount: "Numero di sessioni utilizzate",
            maxSessionCount: "Numero massimo di sessioni",
            leftSessionCount: "Numero di sessioni rimanenti",
            planManagement: "Gestione del piano",
            maxAutomationTask: "Numero massimo di attività di automazione",
            teamChat: "Chat di squadra",
            templateNameIsNotValid: "Il nome del modello non è valido",
            relatedAdvertisement: "Pubblicità correlata",
            whatsappNumber: "Numero di Whatsapp",
            integrationsWhatsappV1:
                "È necessario un piano WhatsApp per una comunicazione senza problemi tra Supsis e WhatsApp.",
            integrationsWhatsappV2: "Puoi facilmente condividere le informazioni della chat tra Supsis e WhatsApp.",
            integrationsWhatsappBusiness:
                "Puoi trasmettere rapidamente e comodamente le informazioni della chat tra Supsis e WhatsApp.",
            selectDays: "Seleziona giorni",
            addTime: "Aggiungi ora",
            instagramContactList: "Lista contatti Instagram",
            archiveAllRated: "Recupera tutte le conversazioni con qualsiasi valutazione.",
            allChannels: "Tutti i canali",
            comment: "commento",
            news: "cosa c'è di nuovo",
            speechTermination: "Terminazione del discorso",
            noSystemMessage: "Nessun messaggio di sistema",
            supsisCustomerService: "Supsis Servizio Clienti,",
            supsisClickExperience: "Clicca per provare l'esperienza",
            customerPage: "Pagina cliente",
            buttonTitle: "Titolo del pulsante",
            buttonType: "Tipo di pulsante",
            buttonSendMessage: "Invia messaggio",
            buttonGoToBlock: "Vai al blocco",
            buttonOpenUrl: "Apri URL",
            buttonPhoneCall: "Chiamata telefonica",
            buttonOpenMoment: "Apri Momento",
            buttonCloseChat: "Chiudi chat",
            buttonTransferChat: "Trasferisci chat",
            buttonCreateTicket: "Crea ticket",
            you: "Tu",
            and: "e",
            deleteVisitor: "Elimina visitatore",
            dndBlocked: "Blocco DND",
            tokenCopied: "Token copiato",
            apiIntegration: "Integrazione API",
            generateToken: "Genera token",
            copyToken: "Copia token",
            labels: "Etichette",
            noData: "Nessun dato",
            color: "Colore",
            titleColor: "Colore del titolo",
            secondTitleColor: "Colore del secondo titolo",
            tag_name_indicator: "Nome dell'etichetta",
            sendMessage: "Invia messaggio",
            removeFromG: "Rimuovi dal gruppo",
            delChannel: "Sei sicuro di voler eliminare questo canale?",
            new_name: "Nuovo nome",
            set_group_info: "Modifica informazioni di gruppo",
            shortcut_desc_num: "Passa da una conversazione all'altra con cifre numeriche",
            copilot_desc_num: "Ti consente di aprire Copilot nella schermata della chat",
            typing_w_chat: "sta scrivendo...",
            edit_group_info: "Modifica informazioni del gruppo",
            notif_sound: "Attiva i suoni delle notifiche",
            notif_mute: "Silenzia le notifiche",
            leave: "Lasciare",
            group: "Gruppo",
            updateTag: "Aggiorna Tag",
            ordered_desc: "Assegna le chat ai rappresentanti in ordine.",
            random_desc: "Assegna le chat ai rappresentanti in modo casuale.",
            Rrobin_desc:
                "Assegna le chat ai rappresentanti in modo round robin. (Priorità ai rappresentanti meno occupati)",
            RrobinRev_desc:
                "Assegna le chat ai rappresentanti in modo round robin inverso. (Priorità ai rappresentanti più occupati)",
            algo_desc: "Seleziona l'algoritmo per l'assegnazione automatica delle chat",
            algorithm: "Algoritmo",
            os_browser: "Sistema operativo e browser",
            addTag: "Aggiungi tag",
            tags: "Tag",
            searchRepresentative: "Ricerca rappresentante",
            voting: "Votazione",
            chatWidget: "Widget chat",
            webhooks: "Webhooks",
            selectHooks: "Seleziona hooks",
            planRequired: "{integratable} Piano Obbligatorio.",
            allIntegrations: "Tutte le integrazioni",
            disableAgentSystemMessages: "Disabilita i messaggi di sistema dell'agente",
            disableAgentSystemMessagesDesc: "Nascondi messaggi di sistema dell'agente.",
            disableAutoTranslate: "Disabilita la traduzione automatica",
            disableAutoTranslateDesc:
                "Traduce automaticamente i messaggi da diverse lingue. In questo modo puoi comunicare più facilmente con i tuoi clienti.",
            shouldAddMethod:
                "È necessario compilare il campo Metodo di pagamento e indirizzo di fatturazione!\nNessun denaro verrà prelevato dal tuo conto.\n" +
                "Alla fine del mese, verrà creata una fattura in base all'importo dell'utilizzo.",
            approveSelection: "Approva selezione",

            trialDaysEndSelectPlan: "Conferma la selezione del piano",
            trialDaysEndSelectPlanDesc:
                "La tua versione di prova è terminata. Devi confermare selezionando il piano qui sotto.",
            infinitePlay: "Riproduzione infinita",
            hideBubbleOnMobile: "Nascondi la bolla sul cellulare",
            deleteSystemLanguage: "dal sistema {code} si asciuga la lingua",
            assignedChat: "Chat assegnata",
            check: "Controllo",
            systemStatus: "Stato del sistema",
            chatAssignedToUser: "Chat assegnata a {user}",
            inactiveThresholdTime: "Tempo limite inattivo (minuti)",
            tippyInactiveThresholdTime:
                "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione è considerata passiva, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            inactiveTerminateTime: "Tempo limite di inattività (minuti)",
            tippyInactiveTerminateTime:
                "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione viene terminata, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            removePendingMessage: "Rimuovi messaggio in sospeso",
            disconnected: "Disconnesso",
            visitorWriteEmptyChatTippy: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorWriteEmptyChat: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorConnectionEventSystemMessageEnabled:
                "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            openBubble: "Apri bolla",
            changeLogo: "Cambia logo",
            changePhoto: "Cambia foto",
            addPhoto: "Aggiungi una foto",
            seePhoto: "Guarda la foto",
            deletePhoto: "Eliminare la foto",
            askQuestion: "Fai una domanda",
            locationPermsNeeded:
                "Per utilizzare la funzione di condivisione della posizione, è necessario abilitare i permessi di posizione.",
            useMyLocation: "Usa la mia posizione",
            acceptingChat: "Accettazione chat",
            notAcceptingChat: "Non accettazione chat",
            websiteChatWidgetIntegration: "Integrazione del widget di chat del sito web",
            loggedOut: "Disconnesso",
            listStatuses: "Stati della lista",
            hideInactiveAgents: "Nascondi agenti inattivi",
            hideMinorValues: "Nascondi valori minori",
            agentActivities: "Attività dell'agente",
            newHASHContent: "Nuovo contenuto HASH",
            hash: "HASH",
            languageRemovalQuestion: "dal sistema {code} Stai per cancellare la tua lingua!",
            blockBy: "Rappresentante",
            hashText: "Biglietto",
            exampleHash: "tracciamento dell'ordine",
            notValidHash: "Non deve contenere spazi",
            videoCallEnabledDesc: "Attiva per abilitare la funzione di videochiamata",
            videoCallEnabled: "Videochiamata",
            audioCallDesc: "Attiva per abilitare la funzione di chiamata audio",
            audioCallEnabled: "Funzione di ricerca vocale",
            assignPreferredAgent: "Assegna agente preferito",
            representativeAssignedToTheVisitor: "Seleziona l'agente preferito che desideri assegnare al visitatore.",
            agentFileSendEnabledDesc: "Consente ai delegati di inviare file",
            agentFileSendEnabled: "I delegati possono inviare file",
            visitorFileSendEnabledDesc: "Consente ai visitatori di inviare file",
            visitorFileSendEnabled: "I visitatori possono inviare file",
            visitorAutoLogin: "Accesso automatico del visitatore",
            visitorAutoLoginDesc: "Il visitatore viene automaticamente connesso al sistema",
            agentVoiceRecordEnabledDesc: "I rappresentanti possono abilitare la funzione di registrazione vocale",
            agentVoiceRecordEnabled: "I rappresentanti possono registrare la voce",
            visitorVoiceRecordEnabledDesc: "I visitatori possono abilitare la funzione di registrazione vocale",
            visitorVoiceRecordEnabled: "I visitatori possono registrare la voce",
            startVideoCall: "Videochiamata",
            startAudioCall: "Chiamata audio",
            visitorGDPRDeleteEnabledDesc: "I visitatori possono eliminare tutte le informazioni",
            visitorGDPRDeleteEnabled: "I visitatori possono eliminare tutte le informazioni",
            visitorLocationEnabled: "I visitatori possono condividere la posizione",
            visitorLocationEnabledDesc: "I visitatori possono condividere la posizione",
            customerLocationEnabled: "I rappresentanti possono condividere la posizione",
            customerAutoMergeEnabled: "Unisce automaticamente le stesse persone",
            customerAutoMergeEnabledDesc:
                "Questa funzione effettua automaticamente l'unione dei dati relativi alle stesse persone in modo efficace. Ciò assicura che gli utenti con profili simili siano rappresentati in modo più coerente e ordinato nei set di dati.",
            chatAiCopilot: "Assistente chat AI",
            chatAiCopilotDesc:
                "Rispondi automaticamente alle domande dei tuoi clienti utilizzando l'Assistente chat AI",
            customerLocationEnabledDesc: "I rappresentanti possono condividere la posizione",
            thoesNotOwners: "Mantieni i non proprietari in coda",
            thoesNotOwnersDesc:
                "Si attiva questa funzione per mantenere in coda le persone che non sono proprietarie della conversazione",
            hideContactInfo: "Nascondi le informazioni di contatto",
            hideContactInfoDesc:
                "Quando si attiva questa funzione, i numeri e le e-mail dei clienti saranno nascosti agli agenti",
            triggerAlreadyExists: "Il trigger esiste già",
            ticketStatusForm: "Titolo dello stato del ticket",
            statusFormTitle: "Titolo",
            allStatus: "Tutti gli stati",
            triggers: "Trigger",
            trigger: "Trigger",
            noTrigger: "Nessun trigger",
            triggerSkipLoginForm: "Modulo di accesso",
            triggerSkipLoginFormTrue: "Mostra modulo di accesso",
            triggerSkipLoginFormFalse: "Salta il modulo di accesso e passa direttamente al messaggio",
            noContent: "Nessun contenuto",
            toCreate: " per creare",
            clickTheButton: "Clicca il pulsante",
            triggerContent:
                " per creare un trigger. I trigger sono utilizzati per inviare messaggi automatici ai visitatori in base alle condizioni impostate.",
            triggerDrag: "Trascina e rilascia i trigger per riordinarli.",
            triggerNewCondition: "Nuova condizione",
            triggerNoConditionDescription1:
                "Ziyaretçi sayfasında aynı koşullara sahip tetikleyicilerden yalnızca bir tanesi aktif olarak gözükür.",
            triggerNoConditionDescription2:
                "Eğer bir tetikleyiciyi aktif olarak görmek istiyorsanız, diğer tetikleyicilerin koşullarını değiştirmeniz gerekmektedir.",
            triggerShowAndHide: "Tetikleyiciyi göster/gizle",
            countryLanguage: "Paese/Lingua",
            addTrigger: "Aggiungi trigger",
            yesPlease: "Sì grazie!",
            noThanks: "No grazie.",
            firstAnswer: "Prima risposta",
            secondAnswer: "Seconda risposta",
            noTitle: "senza titolo",
            sumChat_MediaFile: "Media e documenti",
            importantWarning: "AVVERTENZA IMPORTANTE!",
            images: "Immagini",
            URLS: "Collegamenti",
            files: "File",
            warning: "Attenzione!",
            noCondition: "Nessuna condizione",
            showTriggers: "Mostra trigger",
            showThisTrigger: "Mostra questo trigger",
            hideTriggers: "Nascondi trigger",
            hideThisTrigger: "Nascondi questo trigger",
            updateTrigger: "Aggiorna trigger",
            conditions: "Condizioni",
            messageDurationPerRow: "Durata del messaggio (per riga)",
            dayTime: "Orario di lavoro",
            weekDay: "Giorno della settimana",
            spendTimePage: "Tempo trascorso sulla pagina",
            spendTimeSite: "Tempo trascorso sul sito",
            pageUrl: "URL della pagina",
            pageTitle: "Titolo della pagina",
            equal: "Uguale",
            not_equal: "Non uguale",
            less_than: "Minore di",
            greater_than: "Maggiore di",
            less_than_or_equal: "Minore o uguale",
            greater_than_or_equal: "Maggiore o uguale",
            visitorName: "Nome del visitatore",
            seconds10: "10 secondo",
            seconds30: "30 secondo",
            minute1: "1 minuto",
            minutes5: "5 minuto",
            minutes10: "10 minuto",
            minutes30: "30 minuto",
            hour1: "1 ora",
            hours2: "2 ora",
            hours4: "4 ora",
            hours8: "8 ora",
            hours12: "12 ora",
            hours24: "24 ora",
            maxCondition: "Massimo 5 condizioni",
            doYouWishToDeleteTrigger: "Vuoi eliminare il trigger?",
            contains: "Contiene",
            not_contains: "Non contiene",
            chatLanguage: "Lingua della chat",
            translating: "Traduzione",
            liveSupportStartingWait: "Live support starting, please wait...",
            noConnection: "No connection",
            buyWhatsapp: "Buy Whatsapp",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to refund this invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice marked as paid successfully.",
            invoiceMarkedAsPaidError: "Invoice marked as paid error.",
            deleteConfirm: "Questo {object} Vuoi davvero eliminare?",
            markPaidConfirm: "Sei sicuro di voler contrassegnare questa fattura come pagata?",
            startChatDesc: "Inizia una chat con i visitatori",
            addLink: "Aggiungi link",
            selectStep: "Seleziona passo: ",
            addGOTO: "Aggiungi GOTO",
            sendFastLink: "Invia link di accesso senza password",
            or: "o",
            allTags: "Tutti i tag",
            showDetail: "Mostra dettagli",
            hideDetail: "Nascondi dettagli",
            weLlSendPhone: "Invieremo un SMS",
            weLlSendEmail: "Invieremo un'e-mail",
            linkSentToPhone: "Link inviato al tuo telefono",
            offerlinkSendToPhone: "Invieremo un SMS con il link per scaricare l'applicazione.",
            offerlinkSendToMail: "Invieremo un'e-mail con il link per scaricare l'applicazione.",
            theEmail: "L'email",
            differentEmail: "diverso dall'email di registrazione",
            linkSentToMailBox: "Link inviato alla tua casella di posta",
            errorOccurred: "Si è verificato un errore !",
            clickStoreIcon: "Fai clic sull'icona del tuo negozio",
            meetWithSupsis: "Incontra Supsis",
            downloadMobileApps: "Scarica le app mobili",
            getApps: "Ottieni le app",
            info: "Informazioni",
            conversationHistory: "Cronologia della conversazione",
            planInfoHeader: "Informazioni sul piano",
            planInformation:
                "il tuo piano {selectedPlan} Piano ({detailMaxAgentCount} Rappresentante) ({freeAgent} agente libero)",
            creditAvailable: "Il tuo credito agente disponibile sul tuo piano: ",
            upDownGradePlan: "Se desideri eseguire l'upgrade/downgrade del tuo piano, per favore",
            click: "clicca",
            all: "Tutti",
            allDepartments: "Tutti i dipartimenti",
            preferredLanguage: "Lingua preferita",
            kmkAutoDepartmentBind: "KMK Auto Department Bind",
            kmkAutoDepartmentBindDesc: "KMK Auto Department Bind",
            visitorEmailUpdated: "Email del visitatore aggiornata",
            visitorEmailIsNotValid: "L'email del visitatore non è valida",
            visitorNameUpdated: "Nome del visitatore aggiornato",
            clickToEdit: "Clicca per modificare",
            addEmail: "+ Aggiungi e-mail",
            addFullname: "+ Aggiungi nome completo",
            partner: "Partner",
            isIntegrated: "Integrato",
            agentCount: "Conteggio agente",
            autoStartChat: "Chat di avvio automatico",
            bubbleColor: "Colore della bolla",
            openFolder: "Apri cartella",
            preDefined: "Predefinito",
            customIcon: "Icona personalizzata",
            theme: "Tema",
            themeSettings: "Impostazioni del tema",
            chatThemeSettings: "Impostazioni del tema della chat",
            bubbleSettings: "Impostazioni della bolla",
            inputHeightOfBubble: "Altezza della bolla",
            inputPixelsOfChatBubble: "Pixel della bolla di chat",
            modalTitleIsMarginAsPixelInfo: "Distanza della bolla della chat dai bordi :  ",
            inputPxOfXaxis: "Posizione orizzontale",
            inputPxOfYaxis: "Posizione verticale",
            inputPxOfMobileXaxis: "(Mobile) Posizione orizzontale",
            inputPxOfMobileYaxis: "(Mobile) Posizione verticale",
            animations: "Animazioni",
            preferredAnimation: "Animazione preferita",
            selectAnAnimation: "Seleziona un'animazione",
            inputOfBubbleMessage: "Aggiungi contenuto a enormi bolle di chat.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Impostazione per nascondere il fumetto della chat in base allo stato di accesso. Se è disattivato, verrà mostrato a tutti i visitatori.",
            showChatBubbleOnlyLoggedUser: "Mostra la bolla solo agli utenti che hanno effettuato l'accesso. (ideasoft)",
            helloDoUNeedHelp: "Ciao, posso aiutarti!",
            bubbleIcon: "Icona della bolla",
            overrideMargins: "Override Margins",
            autoHideBubble: "Nascondi automaticamente la bolla",
            vtippyAutoHideBubble: "Nasconde automaticamente la bolla dopo 5 secondi.",
            hideBubble: "Nascondi la bolla",
            vtippyHideBubble: "Nasconde la bolla.",
            overrideMobileMargin: "Override Mobile Margin",
            vtippyMobileMargin: "Mobile için margin değerini override eder.",
            vtippyHideBubbleOnMobile: "Il fumetto della chat è nascosto agli utenti mobili.",
            isFabsActive: "Mostra popup",
            isAlwaysActive: "Il menu è sempre aperto",
            isAlwaysActiveDesc: "Vuoi che il menu della chat rimanga sempre aperto nella visualizzazione web?",
            bubbleOpenableMenu: "Menu a discesa della bolla della chat",
            vtippyIsFabsActive: "Impostazione per mostrare/nascondere i menu a comparsa",
            vtippyIsFabsAsIcon: "È l'impostazione della visualizzazione delle icone nel menu a discesa.",
            vtippyTranslateButton: "Traduce la lingua selezionata in altre lingue.",
            vtippyTranslateClearButton: "Pulisce la traduzione.",

            vtippySelectnotification: "Seleziona la notifica",
            vtippyVoiceLevel: "Impostazione del livello di volume",
            vtippyStartVoice: "Avvia la notifica vocale",
            vtippyInfiniteNotification:
                "Impostazione per riprodurre la notifica vocale in modo continuo. (Se è disattivato, verrà riprodotto solo una volta.)",

            vtippyNewVisitorNotification: "Impostazione per la notifica vocale dei nuovi visitatori.",
            vtippyNewChatNotification: "Impostazione per la notifica vocale dei nuovi chat.",
            vtippyNewConversationNotification: "Impostazione per la notifica vocale delle nuove conversazioni.",
            vtippyNewMessageNotification: "Impostazione per la notifica vocale dei nuovi messaggi.",
            vtippyPrivateMessageNotification: "Impostazione per la notifica vocale dei messaggi privati.",

            isFabsAsIcon: "Mostra icone",
            setMarginAsPixel: "Imposta margini come pixel",
            returnDefaultMargins: "Ripristina i margini predefiniti",
            closePreviewColors: "Chiudi anteprima colori",
            previewColors: "Anteprima colori",
            videoCalls: "Chiamate video",
            filterLost: "Filtro perso",
            vtipyCustomLogin:
                "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            vtipyLoginlessChat:
                "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            loginlessChat: "Chat senza accesso",
            imageUrl: "URL dell'immagine",
            replied: "Risposto",
            solved: "Risolto",
            openImage: "Apri immagine",
            writeFeedback: "Scrivi un feedback",
            feedbackFailed: "Invio del feedback non riuscito.",
            feedbackSuccessful: "Feedback inviato con successo.",
            sendFeedback: "Invia feedback",
            errorReport: "Segnala un errore",
            sendErrorFeedBack: "Invia feedback di errore",
            successImgUpload: "Immagine caricata con successo",
            successImgDelete: "Immagine eliminata con successo.",
            errorImgUpload: "Errore durante il caricamento dell'immagine",
            errorImgDelete: "Si è verificato un errore durante l'eliminazione dell'immagine",
            chatBotEndStatics: "Statistiche di fine chatbot",
            videoCallDist: "Distanza della chiamata video",
            deleteSite: '" {siteName} " Eliminare il sito?',
            deleteThisSite: "Elimina questo sito",
            departmentInfo: "Informazioni sul dipartimento",
            infoAboutDepartment: "Informazioni sul dipartimento",
            deleteDepartmentQuestion: "Eliminare il dipartimento?",
            departmentDeleted: "Dipartimento eliminato",
            departmentTitle: "Titolo del dipartimento",
            updateDepartmentForm: "Modulo di aggiornamento del dipartimento",
            updateCompleted: "Aggiornamento completato",
            CatalogUpdatedSuccessfully: "Catalogo aggiornato con successo",
            integrateSupsiswithIntegratable:
                "Supsis e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            installationOK: "Caricato",
            newDepartmentForm: "Nuovo modulo di registrazione del dipartimento",
            newDepartment: "Nuovo dipartimento",
            departmentSaved: "Dipartimento salvato",
            sameDepartment: "C'è un dipartimento con lo stesso nome",
            sameValue: "C'è un valore con lo stesso nome!",
            departments: "Dipartimenti",
            department: "Dipartimento",
            announcements: "Annunci",
            announcement: "Annuncio",
            newAnnouncement: "Nuovo annuncio",
            announcementInfo: "Informazioni sull'annuncio",
            infoAboutAnnouncement: "Informazioni sull'annuncio",
            deleteAnnouncementQuestion: "Eliminare l'annuncio?",
            announcementDeleted: "Annuncio eliminato",
            announcementTitle: "Titolo dell'annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento dell'annuncio",
            newAnnouncementForm: "Nuovo modulo di registrazione dell'annuncio",
            announcementSaved: "Annuncio salvato",
            chatTimingSettings: "Impostazioni di temporizzazione della chat",
            assetOversize: "La dimensione del file deve essere inferiore a 10 MB",
            assetOversizeMB: "La dimensione del file che desideri inviare non deve superare i {mb} MB.",
            assetOversizeWithExt: "La dimensione del file deve essere inferiore a 10 MB. ({ext})",
            messageDeleted: "Messaggio eliminato",
            filterVideoCall: "Filtra le chiamate video",
            filterLostChat: "Filtra le chat perse",
            filterClosedByAgent: "Filtra le chat chiuse dall'agente",
            notificationText: "Testo della notifica ",
            notificationTitle: "Titolo della notifica",
            deniedText: "Le tue notifiche sono chiuse, devi attivarle per non perdere i tuoi clienti.",
            deniedTitle: "Per favore, attiva le notifiche",
            deniedHeader: "Notifiche disattivate",
            showNotificationGuide: "Clicca per vedere i dettagli",
            howToEnableNotification: "Come posso abilitare le notifiche",
            notificationOK: "OK",
            notificationUnderstood: "Compreso!",
            notificationCancel: "Annulla",
            howToEnableNotificationInstruction1:
                "Fare clic sull'icona del lucchetto nella barra degli indirizzi del browser",
            howToEnableNotificationInstruction2: "Se Notifiche è disabilitato nella sezione Autorizzazioni, abilitalo",
            howToEnableNotificationInstruction3:
                'Se "Notifiche" è disabilitato nella sezione "Autorizzazioni", abilitarlo',
            howToEnableNotificationInstruction4:
                'Se "Notifiche" è disabilitato nella sezione "Autorizzazioni", abilitarlo',
            checkPaymentMethod: "Controlla il metodo di pagamento",
            pushNotificationEnabled: "Notifiche push abilitate",
            pushNotificationDenied: "Notifiche push negate",
            suspendedMessage: "Il tuo account è stato sospeso",
            enableNotification: "Abilita notifiche",
            languageSettings: "Impostazioni della lingua",
            problemsSound:
                "Se non senti il suono, controlla le impostazioni del tuo browser. (Se il problema persiste, contatta il tuo amministratore.)",
            betweenRepresentative: "Tra rappresentante",
            desktopNotifications: "Notifiche desktop",
            notificationDisable: "Notifiche disabilitate",
            notificationEnabled: "Notifiche abilitate",
            newMessageAlert: "Nuovo messaggio",
            newConversationAlert: "Nuova conversazione",
            chatBot: "Chatbot",
            ticketResponse: "Risposta al ticket: ",
            archived: "Archiviato",
            chatbotChatCount: "CHATBOT",
            closeChat: "Chiudi chat",
            ticket: "Ticket",
            formStep: "Passaggio del modulo",
            menuStep: "Passaggio del menu",
            contentStep: "Passaggio del contenuto",
            menuTitle: "Titolo del menu",
            messageContent: "Contenuto del messaggio",
            goToLive: "Vai in diretta",
            prevStep: "Passaggio precedente",
            button: "Pulsante",
            addImage: "Immagine",
            addText: "Testo",
            stepTitle: "Titolo del passaggio",
            addTicket: "Ticket",
            formDescription: "Domanda",
            addInput: "Domanda",
            addRandomText: "Testo casuale",
            changeTitle: "Cambia titolo",
            changeVisitorTitle: "Cambia indirizzo visitatore",
            catalog: "Catalogo",
            openTheCatalog: "Apri il catalogo",
            catalogNotOpen:
                "Il catalogo non è aperto. Per aprire il catalogo, vai alla sezione Impostazioni e attiva il catalogo.",
            showCatalogCategories: "Mostra categorie",
            showChatBot: "Mostra chatbot",
            openCatalog: "Apri catalogo",
            unreadMessages: "Messaggi non letti",
            personalFirstMsg: "Primo messaggio personale",
            personalRating: "Valutazione personale",
            soundSettings: "Impostazioni audio",
            newPrivateMessage: "Nuovo messaggio privato",
            addNewGroup: "Creare un nuovo gruppo",
            newMessage: "Nuovo messaggio",
            newConversation: "Nuova conversazione",
            newVisitor: "Nuovo visitatore",
            chatPosition: "Posizione della chat",
            bottomLeftCorner: "angolo in basso a sinistra",
            leftDocked: "lasciato ancorato",
            bottomRightCorner: "nell'angolo in basso a destra",
            rightDocked: "agganciato a destra",
            chatPositionSelect: "Seleziona la posizione della chat",
            teamChatGroup: "Messaggi di gruppo",
            teamChatDepartment: "Messaggi del dipartimento",
            teamChatTeam: "Messaggi di squadra",
            teamChatDm: "Messaggi DM",
            bottomLeft: "In basso a sinistra",
            left: "Sinistra",
            bottomRight: "In basso a destra",
            right: "Destra",
            mailorname: "Email o nome",
            breaksByTime: "Interruzioni per tempo",
            clPlaceholder: "Scrivi un messaggio",
            fieldName: "Nome",
            value: "Valore",
            addSetting: "Aggiungi impostazione",
            globalSettings: "Impostazioni globali",
            target: "Target",
            duration: "Durata",
            arrivalCount: "Conteggio di arrivo",
            bootMaxLife: "Durata massima di avvio",
            startLoadTest: "Avvia test di carico",
            noClusterInstanceFound: "Nessuna istanza cluster trovata",
            stopLoadTest: "Ferma il test di carico",
            integrationDesc: "Descrizione dell'integrazione",
            integrationDemoCode: "Codice demo di integrazione",
            integrationWindow: "Finestra di integrazione",
            notIntegrated: "Non integrato",
            help: "Aiuto",
            notIntegratedDesc:
                "Non hai ancora integrato il tuo sito web. Per integrare il tuo sito web, vai alla sezione Impostazioni e segui le istruzioni.",
            backToLogin: "Torna al login",
            passwordlessLoginUnsuccessful: "Il login senza password non è riuscito. Per favore, riprova.",
            passwordlessLogin: "Login senza password",
            loginWithEmail: "Accedi con e-mail",
            loginWithPassword: "Accedi con password",
            enteringPasswordless: "Stai entrando nel tuo account senza password",
            toMainPath: "Vai al percorso principale",
            userRoleChanged: "Il ruolo dell'utente è stato modificato",
            passwordChangeSuccess: "La password è stata modificata con successo",
            feedback: "Feedback",
            showFeedbackHistory: "Mostra cronologia dei feedback",
            newSelfServiceSite: "Nuovo sito di self-service",
            subdomain: "Sottodominio",
            rootUserEmail: "Email",
            rootUserName: "Nome",
            newVersion: "Nuova versione",
            closeLiveSupport: "Chiudi supporto live",
            newVersionShort: "Nuova versione",
            bannedWordRestrict: "Restrizione parole vietate",
            ticketShow: "Consentire ai clienti di creare ticket",
            ticketShowDesc: "Attivare l'opzione di creazione ticket nel menu della chat",
            autoLoadIframe: "Iframe di caricamento automatico",
            autoLoadIframeDesc: "Carica automaticamente l'iframe sul tuo sito web",
            bannedWordRestrictDesc: "Se abilitato, i messaggi contenenti parole vietate non verranno inviati",
            agentDown: "Agente inattivo",
            delayChat: "Ritardo chat",
            tableSettingTippy: "Impostazioni tabella",
            tableSettings: "Impostazioni tabella",
            tableSettingsInfo:
                "Seleziona le colonne che desideri visualizzare nella tabella. Le impostazioni verranno salvate automaticamente.",
            privateParametry: "Parametri utente personalizzati",
            systemOperetor: "Informazioni di sistema",
            cityAndDistrict: "Città/Paese",
            general: "Generale",
            availability: "Disponibilità",
            home: "Home",
            successful: "Riuscito",
            forgetPasswordSent: "Ti abbiamo inviato un'e-mail per reimpostare la password.",
            saturday: "Sabato",
            friday: "Venerdì",
            thursday: "Giovedi",
            wednesday: "Mercoledì",
            tuesday: "Martedì",
            monday: "Lunedì",
            sunday: "Domenica",
            download: "Scarica",
            calendarPassedTimeHour: "{hour} ora {name}",
            calendarPassedTime: "{hour} ora {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",

            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} ora {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Dell'utente {sDate} Calendario del lavoro giornaliero",
            workSchedule: "{name} Il tuo nome utente {sDate} - {eDate} Tra orario di lavoro",
            calendar: "Calendario",
            noRating: "Nessuna valutazione",
            rateDist: "Distribuzione delle valutazioni",
            distConversation: "Distribuzione della conversazione",
            distributionConversa: "Distribuzione della conversazione",
            distChatbotAgent: "Chatbot & Agente",
            distAgent: "Agente",
            distFugitive: "Discorso mancato e discorso ricevuto",
            distLive: "Live Cha",
            distChatbot: "Chatbot",
            distComplex: "Complesso",
            distHandled: "Gestito",
            distMissed: "Mancato",
            distWeb: "Web",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Totale chat Whatsapp",
            statsByTime: "Statistiche per tempo",
            selectRep: "Seleziona rappresentante",
            allRepresentatives: "Tutti i rappresentanti",
            avgRating: "Distribuzione punti ({point}) ({count} valutazione)",
            avgFirstMessageTime: "Tempo medio del primo messaggio ",
            totalBreakTime: "Tempo totale di pausa",
            totalBreakNum: "Numero totale di pause",
            averageConTime: "Tempo medio di conversazione",
            multiWpReportTitle: "Conteggio conversazioni multiple Whatsapp",
            multiWpReport: "Numero di chat multiple di WhatsApp",
            multiWpReportExplanation: "Puoi vedere la quantità di chat dei tuoi canali  Whatsapp.",
            longestConTime: "Tempo di conversazione più lungo",
            shortestConTime: "Tempo di conversazione più breve",
            refresh: "Ricarica",
            waitingReply: "In attesa di risposta",
            organizationName: "Nome dell'organizzazione",
            companySlogan: "Nome lungo dell'organizzazione",
            messageSentErr: "Errore nell'invio del messaggio",
            messageSent: "Messaggio inviato",
            openPrivateChat: "Apri chat privata",
            escKey: "Premi Esc per chiudere",
            archiveChatKey: "Premi Ctrl + E per archiviare la chat",
            chatCopilot: "Attiva Chat CoPilot",
            privateChat: "Chat privata",
            multiModeAlertDesc:
                "Se abilitato, i rappresentanti possono gestire più chat contemporaneamente. Se disabilitato, i rappresentanti possono gestire solo una chat alla volta.",
            useHereText: "Usa qui",
            brandVisibility: "Visibilità del marchio",
            focusInput: " Inserisci il tuo messaggio qui",
            send: "Invia",
            notYet: "Non ancora",
            sending: "Invio",
            onlyRepresentative: "Solo rappresentante",
            yourMessage: "Il tuo messaggio",
            liveFabListDescription: "Live Chat",
            messengerIntegrationDesc:
                "Chatta con i tuoi clienti tramite la pagina Facebook, invia messaggi automatici con il chatbot.",
            checkDepartmentToAgent: "Controlla il Dipartimento per l'Agente Online",
            ifAllOfflineStory: "Storia per Indirizzare se Tutti Offline",
            AssignMessagesToAgents: "Assegna Tutti i Messaggi agli Agenti",
            firstChatbotAndAssign: "Prima risponde il Chatbot e poi viene assegnato a un agente",
            hybridAssign:
                "Il sistema controlla il dipartimento per vedere se c'è un agente online, e se non c'è un agente online, lo assegna al chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefono",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "a questa zona {channelLink} Puoi mettere il link del tuo canale.",
            typeYourAccountLink: "a questa zona {accountLink} Puoi mettere il link del tuo canale.",
            typeYourMessage: "Il tuo messaggio",
            typeYourMessageMail:
                "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            typeYourMessageDesc:
                "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            sendNumber: "Numero di telefono a cui inviare il messaggio: {path}",
            callNumber: "Numero di telefono che il tuo cliente può chiamare: {phoneNumber}",
            numberIsNotCorrect: "Numero mancante inserito!!",
            emailIsNotCorrect: "E-mail non corretta!",
            selectFab: "Scegli un favoloso",
            notValid:
                "È possibile inserire solo lettere (carattere singolo). Le lettere e,d,f,z,a,x,c,v,w,t,n non sono valide",
            forMacUsers: " Gli utenti Mac possono usare il tasto Control(⌃)",
            basePriceValue: "Base Fiyat",
            basePriceDiscount: "Sconto",
            basePriceCurrency: "Valuta",
            customerDBEnabled: "Selezione del database: utilizzare il server del database del cliente",
            customerDBDisabled: "Selezione del database: utilizzare il server del database Supsis",
            mongoConnectionString: "Collegamento Mongo",
            whatsappBasePriceValue: "Prezzo base Whatsapp",
            whatsappPlusBasePriceValue: "Prezzo base Whatsapp Plus",
            instagramBasePriceValue: "Prezzo base Instagram",
            instagramPlusBasePriceValue: "Prezzo base di Instagram Plus",
            clientAddress: "Indirizzo del cliente",
            customerClientAddress: "Cliente Cliente Indirizzo",
            apiAddress: "Indirizzo API",
            socketAddress: "Indirizzo Socket",
            backendAddress: "Indirizzo Backend",
            panelLogoUrl: "URL del logo del pannello",
            panelCustomCssUrl: "URL CSS personalizzato del pannello",
            customerLogoUrl: "URL del logo del cliente",
            customerCssUrl: "URL CSS personalizzato del cliente",
            siteAlias: "Alias del sito",
            language: "Lingua",
            features: "Caratteristiche",
            interactionPopularity: "Popolarità dell'interazione",
            interactionCount: "Numero di interazioni",
            uniqueUserCount: "Numero di utenti unici",
            allUserPercentage: "(%) Percentuale di tutti gli utenti",
            represantativeSettings: "Impostazioni rappresentative",
            documentTitle: "Modulo documento supsis",
            supsisDocument: "Documento Supsis",
            ApiDoc: "Documentazione API",
            chatBalloonTehemeSettings: "Impostazioni del tema della bolla di chat",
            customLoginFormSettingsTitle: "Impostazioni del modulo di accesso personalizzato",
            addNewField: "Aggiungi nuovo campo",
            editField: "Modifica campo",
            typeHere: "Scrivi qui",
            pco: "PÇO",
            perPage: "/ pagina",
            perPageInFilter: "Pezzo",
            noUserInfoFound: "Nessuna informazione utente trovata",
            startFilter: "Filtro di avvio",
            CHAT: "CHAT",
            showMyChats: "Mostra le mie chat",
            showOnlineAgents: "Mostra agenti online",
            showWaitingChats: "Mostra chat in attesa",
            addNewStatus: "Aggiungi nuovo stato",
            newTitleContent: "Nuovo titolo",
            roleName: "Nome del ruolo",
            error: "Errore",
            contentType: "Tipo di contenuto",
            contentTitle: "Titolo del contenuto",
            newSiteForm: "Nuovo modulo di registrazione del sito",
            updateSiteForm: "Modulo di registrazione del sito di aggiornamento",
            newBannedWordForm: "Nuovo modulo di registrazione delle parole vietate",
            updateBannedWordForm: "Modulo di registrazione delle parole vietate di aggiornamento",
            newWelcomeMessageForm: "Nuovo modulo di registrazione del messaggio di benvenuto",
            updateWelcomeMessageForm: "Modulo di registrazione del messaggio di benvenuto di aggiornamento",
            newDefaultContentForm: "Nuovo modulo di registrazione del contenuto predefinito",
            updateDefaultContentForm: "Modulo di registrazione del contenuto predefinito di aggiornamento",
            newSubjectForm: "Nuovo modulo di registrazione dell'argomento",
            updateSubjectForm: "Modulo di registrazione dell'argomento di aggiornamento",
            showIntro: "Mostra introduzione",
            showChatColorMeaning: "Mostra significato del colore della chat",
            options: "Opzioni",
            resetPassword: "Resetta la password",
            audioLevel: "Livello audio",
            privateChatNotificationSound: "Suono di notifica della chat privata",
            continue: "Continua",
            newRoleForm: "Nuovo modulo di registrazione del ruolo",
            updateRoleForm: "Modulo di registrazione del ruolo di aggiornamento",
            newUserForm: "Nuovo modulo di registrazione utente",
            updateUserForm: "Modulo di registrazione utente di aggiornamento",
            changeOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            tooltipOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            newOSRForm: "Nuovo modulo di registrazione del messaggio offline",
            newOSRMessages: "Nuovo messaggio offline",
            newOsrMessageTitle: "Titolo del messaggio offline",
            updateOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            osrTitle: "Titolo",
            osrTitleDescription: "Il titolo del modulo di supporto offline",
            osrContent: "Contenuto",
            osrContentDescription: "Il contenuto del modulo di supporto offline",
            hello: "Ciao",
            date: "Data",
            startDate: "Data di inizio",
            finish: "Fine",
            start: "Inizio",
            search: "Ricerca",
            endDate: "Data di fine",
            representative: "Rappresentante",
            representative_: "Rappresentante",
            star: "Stella",
            filter: "Filtro",
            reset: "Reset",
            dailyChatList: "Elenco chat giornaliero",
            dailyChatDuration: "Durata della chat giornaliera",
            chatDuration: "Durata della chat",
            dailyChatGraph: "Grafico chat giornaliero",
            ok: "Ok",
            cancel: "Annulla",
            chatCount: "Numero di chat",
            shortest: "Il più breve",
            longest: "Il più lungo",
            average: "Media",
            count: "Contare",
            averagePoint: "Punto medio",
            pointDist: "Distribuzione dei punti",
            point: "Punto",
            filters: "Filtri",
            totalCustomer: "Totale clienti",
            avResponseTime: "Tempo di risposta medio",
            breakDuration: "Durata della pausa",
            breakCount: "Numero di pause",
            active: "Attivo",
            passive: "Passivo",
            userForm: "Modulo utente",
            startChat: "Inizia chat",
            sender: "Mittente",
            profile: "Profilo",
            name: "Nome",
            number: "Numero",
            username: "Nome utente",
            updateUserName: "Aggiorna nome utente",
            email: "E-mail",
            password: "Parola d'ordine",
            oldPassword: "Vecchia password",
            newPassword: "Nuova password",
            passwordAtLeast: "Password (almeno {num} caratteri)",
            passwordRepeat: "Ripeti la password",
            changePassword: "Cambia la password",
            status: "Stato",
            enableState: "Abilita stato",
            douYouWishToDeleteUser: "Vuoi davvero eliminare l'utente?",
            douYouWishToDeleteAnnouncement: "Vuoi davvero eliminare l'annuncio?",
            userDeleted: "Utente eliminato",
            userSaved: "Utente salvato",
            oldPasswordError: "La vecchia password non è corretta",
            chooseAnOption: "Scegli un'opzione",
            userVolumeUpdated: "Volume utente aggiornato",
            save: "Salva",
            update: "Aggiornare",
            addNewMenu: "Aggiungi nuovo menu",
            addNewContent: "Aggiungi nuovo contenuto",
            pleaseTitleEnter: "Inserisci il titolo",
            like: "Piace",
            disLike: "Non mi piace",
            users: "Utenti",
            visitor: "Visitatore",
            allContacts: "Tutti i contatti",
            allUsers: "Tutti gli utenti",
            allSites: "Tutti i siti",
            newUser: "Nuovo utente",
            noNewUser: "Non ci sono ancora nuovi utenti",
            noNewAdminUser: "Non ci sono ancora nuovi utenti amministratori",
            noNewAnnouncement: "Non ci sono ancora nuovi annunci",
            noRoleFound: "Nessun ruolo trovato",
            noBannedWordFound: "Nessuna parola vietata trovata",
            noWelcomeMessageFound: "Nessun messaggio di benvenuto trovato",
            noSubjectFound: "Nessun argomento trovato",
            noVisitorFound: "Nessun visitatore trovato",
            noContactFound: "Nessun contatto trovato",
            sendResponse: "Invia risposta",
            delete: "Elimina",
            duplicate: "Duplicare",
            makeDefault: "Rendi predefinito",
            checkMore: "Controlla di più",
            useReadyTemplates: "Usa modelli pronti",
            useAITemplates: "Usa modelli AI",
            noRePresentativeFound: "Nessun rappresentante trovato",
            noLiveSupportFound: "Nessun supporto live trovato",
            noLiveSupportFoundWithDepartment: " Nessun supporto live trovato con questo dipartimento",
            noBannedVisitorFound: "Nessun visitatore vietato trovato",
            removeBanDescription: "Vuoi davvero rimuovere il divieto?",
            editThisItem: "Modifica questo elemento",
            removeThisItem: "Rimuovi questo elemento",
            role: "Ruolo",
            newRolePlaceHolder: "Inserisci il nome del ruolo",
            autoChatAssignLimit: "Limite di assegnazione chat automatica",
            chatAssignInfo:
                "-1 = Predefinito di sistema, 0 = Nessuna assegnazione, >0 = Assegnazione tanto quanto il valore dato.",
            relatedDepartments: "Dipartimenti correlati",
            subjectInfo: "Seleziona i dipartimenti correlati per questo argomento",
            archive: "Archivio",
            offlineSupportRequests: "Richieste di supporto offline",
            offlineModeMessage: "Messaggio non in linea",
            offlineMode: "Modalità offline",
            first: "Primo",
            last: "Ultimo",
            query: "Query",
            clean: "Pulito",
            loading: "Caricamento",
            loadMore: "Carica altro",
            noMessage: "Nessun messaggio",
            selectChat: "Seleziona chat",
            noMessageInChat: "Nessun messaggio in chat",
            noMediaToShow: "Nessun contenuto multimediale da mostrare",
            firstSeen: "Prima Visione",
            userInfo: "Informazioni sull'utente",
            userProfile: "Profilo",
            addCalendarEvent: "Evento +",
            chatId: "ID chat",
            visitorId: "ID visitatore",
            visitingPage: "Pagina visitata",
            osAndBrowser: "Sistema operativo e browser",
            customerClientVersion: "Versione cliente",
            visitorFeedback: "Feedback del cliente",
            notes: "Note",
            nameSurname: "Nome cognome",
            chats: "Chat",
            bannedVisitors: "Visitatori vietati",
            country: "Nazione",
            city: "Città",
            cityDistrict: "Quartiere cittadino",
            browser: "Browser",
            os: "Sistema operativo",
            ipAddress: "Indirizzo IP",
            connectionDate: "Data di connessione",
            transaction: "Transazione",
            banRemoved: "Divieto rimosso",
            bannedWords: "Parole vietate",
            newBannedWord: "Nuova parola vietata",
            noBannedWord: "Nessuna parola vietata",
            bannedWordForm: "Modulo parola vietata",
            word: "Parola",
            bannedWordAndWordGroup: "Parola/frase vietata",
            doYouWishToDeleteBannedWord: "Vuoi davvero eliminare questa parola vietata?",
            doYouWishToOfflineSupportRequest: "Vuoi eliminare questo messaggio?",
            bannedWordSaved: "Parola vietata salvata",
            deletedSuccessfully: "Eliminato con successo",
            deleteErrorMsg: "Errore durante l'eliminazione",
            socketError: "Problema di connessione presa. Perfavore ricarica la pagina e riprova.",
            socketConnecting: "Connessione al server...",
            offlineModeDescription: "Il sistema è in modalità offline. I visitatori non possono inviare messaggi.",
            offlineModeSettingsDescription:
                "Se la modalità offline è attiva, i visitatori non possono inviare messaggi. Se la modalità offline è disattivata, i visitatori possono inviare messaggi.",
            offlineModeUser: "Modalità offline",
            adminCannotConnectSocket: "L'amministratore non può connettersi al socket. Controlla la connessione.",
            liveSupport: "Supporto dal vivo",
            siteVisitors: "Visitatori del sito",
            visitors: "Visitatori",
            thoseConnectedToLiveSupport: "Coloro che sono connessi al supporto dal vivo",
            visitorHistory: "Cronologia del visitatore",
            visitorHistoryDescription: "Puoi visualizzare e scaricare la cronologia delle chat dei visitatori.",
            privateMessage: "Messaggio privato",
            addRepresentative: "Aggiungi rappresentante",
            forwardRepresentative: "Inoltra rappresentante",
            keyboardShortcuts: "Tasti di scelta rapida",
            chatColorMeanings: "Significati dei colori della chat",
            connLostCheckInternet: "Connessione persa. Controlla la tua connessione a Internet.",
            wishToEndThisChat: "Vuoi davvero terminare questa chat?",
            defaultContents: "Contenuti predefiniti",
            contents: "Contenuti",
            newDefaultContent: "Nuovo contenuto predefinito",
            newCTRLContent: "Nuovo contenuto CTRL",
            newALTContent: "Nuovo contenuto ALT",
            newTABContent: "Nuovo contenuto TAB",
            title: "Titolo",
            shortcutChar: "Carattere di scelta rapida",
            pickOne: "Scegli uno",
            writeSomething: "Digita un carattere (a-z|0-9)",
            letterSequence: "Sequenza di lettere",
            exampleText: "Esempio: calcio -> calcio",
            anyChar: "Qualsiasi carattere",
            shorcutKey: "tasto di scelta rapida",
            content: "Contenuto",
            shortcutName: "Nome di scelta rapida",
            type: "Tipo",
            shortcut: "Scelta rapida",
            deleteContentQuestion: "Vuoi davvero eliminare questo contenuto?",
            defaultContentDeleted: "Contenuto predefinito eliminato",
            defaultContentSaved: "Contenuto predefinito salvato",
            defaultContentForm: "Modulo contenuto predefinito",
            titleContentForm: "Intestazione del contenuto pronta",
            contentMoved: "Contenuto spostato",
            cannotMoveFullParent: "Non puoi spostare un elemento completo sotto un altro elemento completo.",
            yourEmail: "La tua email",
            yourName: "Il tuo nome e cognome",
            lostPassword: "Hai perso la password?",
            login: "Accesso",
            forgotPassword: "Password dimenticata",
            multipleSession: "Sessione multipla",
            notAuthorizedToDisplayPage: "Non sei autorizzato a visualizzare questa pagina.",
            permissions: "Permessi",
            newPermission: "Nuovo permesso",
            permissionForm: "Modulo di autorizzazione",
            displayTitle: "Titolo visualizzato",
            key: "Chiave",
            keyToUseInSystem: "Chiave da utilizzare nel sistema",
            deletePermissionQuestion: "Vuoi davvero eliminare questo permesso?",
            permissionDeleted: "Permesso eliminato",
            permissionSaved: "Permesso salvato",
            newRole: "Nuovo ruolo",
            selectARole: "Seleziona un ruolo",
            yes: "Sì",
            no: "No",
            fullAuth: "Autorizzazione completa",
            roleDeleted: "Ruolo eliminato",
            sameRole: "C'è un ruolo con lo stesso nome.",
            roleSaved: "Ruolo salvato",
            roleForm: "Modulo ruolo",
            roles: "Ruoli",
            settings: "Impostazioni",
            selectTopic: "Seleziona un argomento",
            autoCallTransfer: "Trasferimento automatico della chiamata",
            customerTyping: "Digitazione del cliente",
            typing: "Digitazione",
            agentTyping: "Digitazione dell'agente",
            disconnectTime: "Tempo per terminare la conversazione (sec)",
            tippyDissconnectTime: "Imposta il numero di secondi dopo i quali la sintesi vocale viene disattivata.",
            queueNumberVisibleFeature: "Funzionalità di visualizzazione del numero di coda",
            privateChatEnabled: "Chat privata abilitata",
            delayedTalkTime: "Tempo di conversazione ritardato (sec)",
            employeeAverageChatCount: "Numero medio di chat per dipendente",
            customerDownTimeWhenRepExit: "Tempo di inattività del cliente quando l'agente esce (sec)",
            autoAssignLimit: "Limite di assegnazione automatica",
            wasted: "Perdere tempo (sec)",
            settingsSaved: "Impostazioni salvate",
            settingsCannotSaved: "Impostazioni non possono essere salvate",
            noAuthorization: "Nessuna autorizzazione",
            warningBadInput: "Si consiglia di inserire un numero compreso tra 0 e 70.",
            warningBadInputMarginY: "Avviso sull'inserimento del margine verticale ⚠️",
            warningBadInputMarginX: "Avviso sull'inserimento del margine orizzontale ⚠️",
            warningBadInputBubbleSize: "Avviso sull'immissione delle dimensioni del fumetto ⚠️",
            settingFormWrong: "I dati inseriti non sono corretti, controlla e riprova.",
            delayTime: "Tempo di ritardo",
            sites: "Siti",
            newSite: "Nuovo sito",
            noSiteYet: "Non hai ancora creato un sito.",
            siteAddress: "Indirizzo del sito",
            turnBack: "Torna indietro",
            customerRepLimit: "Limite cliente / rappresentante",
            siteSaved: "Sito salvato.",
            siteSaveError: "Si è verificato un errore durante il salvataggio del sito.",
            subjects: "Argomenti",
            newSubject: "Nuovo argomento",
            noSubject: "Non hai ancora creato un argomento.",
            subject: "Soggetto",
            subjectTitle: "Titolo dell'argomento",
            description: "Descrizione",
            infoAboutSubject: "Informazioni sull'argomento",
            deleteSubjectQuestion: "Vuoi davvero eliminare questo argomento?",
            subjectDeleted: "Argomento eliminato",
            subjectSaved: "Argomento salvato",
            osrFromMessageSaved: "OSR da messaggio salvato",
            welcomeMessages: "Messaggi di benvenuto",
            newWelcomeMessages: "Nuovo messaggio di benvenuto",
            noWelcomeMessage: "Non hai ancora creato un messaggio di benvenuto.",
            welcomeMessageContent: "Contenuto del messaggio di benvenuto",
            makeChoice: "Fai una scelta",
            welcomeMessage: "Messaggio di benvenuto",
            repLoggedIn: "Temsilci giriş yaptı",
            loginMessage: "Messaggio di disconnessione",
            message: "Messaggio",
            messageTitle: "Titolo del messaggio",
            deleteWelcomeMessageQuestion: "Vuoi davvero eliminare questo messaggio di benvenuto?",
            welcomeMessageDeleted: "Messaggio di benvenuto eliminato",
            welcomeMessageSaved: "Messaggio di benvenuto salvato",
            welcomeMessageForm: "Modulo messaggio di benvenuto",
            noRep: "Nessun rappresentante",
            addChat: "Aggiungi chat",
            forwardChat: "Inoltra chat",
            ago: "fa",
            repName: "Nome rappresentante",
            lastOnline: "Ultimo online",
            lastStatusChange: "Ultima modifica dello stato",
            activeChat: "Chat attiva",
            userMaxCapacity: "Capacità massima dell'utente",
            noActiveChat: "Nessuna chat attiva",
            watch: "Guarda",
            join: "Unisciti",
            open: "Aperto",
            directMessage: "Messaggio diretto",
            block: "Blocca",
            transactions: "Transazioni",
            informations: "Informazioni",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Nome completo",
            waitChatTime: "Tempo di attesa della chat",
            blockUserConfirm: "Vuoi davvero bloccare questo utente?",
            messaging: "Messaggistica",
            hideChat: "Nascondi chat",
            block_: "Blocca",
            privateMessage_: "Messaggio privato",
            assignRep: "Assegna rappresentante",
            joinChat: "Unisciti alla chat",
            forwardRep: "Inoltra rappresentante",
            leaveChat: "Lascia la chat",
            endChat: "Termina la chat",
            translatedTextDescription: "Amazon ha tradotto {from} -> {to} di questo messaggio.",
            autoTranslate: "Traduzione automatica",
            translateThisMessage: "Traduci questo messaggio",
            autoTranslateDetectedDesc:
                "Il visitatore parla {visitorLanguage}. Fare clic qui per abilitare la traduzione automatica",
            on: "Acceso",
            off: "Spento",
            copy: "Copia",
            prevChats: "Chat precedenti",
            noShortCut: "Nessuna scorciatoia",
            leaveChartConfirm: "Vuoi davvero lasciare questa chat?",
            endChatConfirm: "Vuoi davvero terminare questa chat?",
            chatBar: "Barra della chat",
            endConversation: "Termina la conversazione",
            onlyOneRep: "Solo un rappresentante",
            chatList: "Elenco chat",
            unreadTitle: "Non letto",
            visitorLeftTitle: "Visitatore lasciato",
            activeChatTitle: "Chat attiva",
            autoAssignedTitle: "Assegnato automaticamente",
            watchModeTitle: "Modalità di guardia",
            lostChat: "Chat persa",
            repLostConn: "Connessione persa",
            chatWidthDelay: "Larghezza della chat",
            repChatWidthDelay:
                "Se la larghezza della chat è impostata su 0, la larghezza della chat sarà la larghezza del contenitore della chat.",
            unreadMsg: "Se ci sono messaggi non letti, l'arco sarà rosso.",
            visitorLeftChat: "Se il visitatore lascia la chat, l'arco sarà rosso.",
            activeChatMsg: "Se la chat è attiva, l'arco sarà verde.",
            autoAssignMsg: "Se la chat è assegnata automaticamente, l'arco sarà blu.",
            watchModeMsg: "Se la modalità di guardia è attiva, l'arco sarà blu.",
            online: "Online",
            beRightBack: "Torno subito",
            away: "Assente",
            busy: "Occupato",
            offline: "Offline",
            logout: "Disconnettersi",
            forWindows: "Per Windows",
            forMac: "Per Mac",
            nextChatFromActive: "Passa alla chat successiva dall'attiva",
            previousChatFromActive: "Passa alla chat precedente dall'attiva",
            hideActiveChat: "Nascondi chat attiva",
            closeActiveChat: "Chiudi chat attiva",
            firsthiddenChat: "Connettiti alla conversazione del cliente che ha atteso di più",
            firstChatWaiting: "Connettiti alla prima conversazione in attesa",
            previousOpenedChat: "Connettiti alla conversazione del cliente che hai aperto per primo",
            hashHintMessage: "Con il tasto # puoi inviare un messaggio veloce (esempio: #ciao)",
            pmHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            vtippyTicketNotification: "Nuovo ticket",
            newTicketSound: "Suono nuovo ticket",
            vtippyDepartmentNotification:
                "Impostazioni di notifica per i messaggi dalla conversazione del dipartimento",
            vtippyGroupNotification: "Impostazioni di notifica per i messaggi dai gruppi creati",
            vtippyAnnouncemenNotification: "Impostazioni di notifica per i nuovi annunci",
            languageSelection: "Selezione della lingua",
            shortcutHintMessage: "Con il tasto / puoi inviare un messaggio veloce (esempio: /ciao) ",
            switchBetweenConversations: "Passa tra le conversazioni",
            atNameHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            dndHintMessage: "Non disturbare",
            pasteFile: "Incolla file",
            atEmailHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @email)",
            pastePlainText: "Incolla testo semplice",
            pressAndTalk: "Press and talk",
            historyDetails: "Dettagli cronologia",
            chat: "Chat",
            chatNotFound: "Chat non trovata",
            dataNotFound: "Dati non trovati",
            visitorInfo: "Informazioni sul visitatore",
            timeSpent: "Tempo trascorso",
            noActiveVisitors: "Nessun visitatore attivo",
            select: "Seleziona",
            fullname: "Nome completo",
            text: "Testo",
            numeric: "Numerico",
            phone: "Telefono",
            optionsPlaceholder: "Opzioni separate da virgola",
            selectField: "Seleziona campo",
            fullnameField: "Nome completo",
            textField: "Testo",
            labelField: "Etichetta",
            numericField: "Numerico",
            phoneField: "Telefono",
            departmentField: "Dipartimento",
            emailField: "Email",
            visible: "Visibile",
            required: "Richiesto",
            label: "Etichetta",
            totalConnected: "Totale connessi",
            missedChat: "Chat perse",
            workTime: "Tempo di lavoro",
            closedChatCount: "Numero di chat chiuse",
            activeConvo: "Conversazioni attive",
            notAnswered: "Non risposto",
            delayedConvo: "Conversazioni ritardate",
            leavingRep: "Rappresentante che lascia",
            staffRate: "Valutazione dello staff",
            customLoginAlert: "Accedi con il tuo account",
            atLeastOneLanguage: "Seleziona almeno una lingua",
            requiredField: "Questo campo è obbligatorio.",
            notRequiredField: "Questo campo non è obbligatorio.",
            visibleField: "Questo campo è visibile nel form.",
            notVisibleField: "Questo campo non è visibile nel form.",
            connectServer: "Connessione al server...",
            disconnectServer: "Disconnessione dal server...",
            liveChatOff: "Live chat disattivata",
            visitorScreen: "Schermo del visitatore",
            viewOnTheSite: "Visualizza sul sito",
            viewOnTheSiteTippy: "Visualizza sul sito",
            showHint: "Mostra suggerimento",
            dontShowHint: "Non mostrare suggerimento",
            liveChatOn: "Live chat attivata",
            nightModeOff: "Modalità notturna disattivata",
            nightModeOn: "Modalità notturna attivata",
            edit: "Modifica",
            deleteField: "Elimina campo",
            arrow_upward: "Sposta su",
            arrow_downward: "Sposta giù",
            doubleClickEdit: "Doppio click per modificare",
            newCatalogCategory: "Nuova categoria di catalogo",
            childCreate: "Crea figlio",
            updateCatalogCategoryFrom: "Aggiorna categoria di catalogo",
            newCatalogCategoryFrom: "Nuova categoria di catalogo",
            catalogMenu: "Menu catalogo",
            catalogContent: "Contenuto catalogo",
            catalogCategoryName: "Nome categoria catalogo",
            newCatalogContentFrom: "Nuovo contenuto catalogo",
            catalogContentName: "Nome contenuto catalogo",
            catalogCategorySaved: "Categoria di catalogo salvata.",
            catalogCategoryDeleted: "Categoria di catalogo eliminata.",
            catalogCategoryRate: "Valutazione categoria catalogo",
            catalogContentFeature: "Caratteristica contenuto catalogo",
            vtipyAudioLevel: "Utilizzato per disattivare o riattivare i suoni di notifica.",
            vtipyOrganizationName: "Nome dell'organizzazione.",
            vtipyBrandVisibility: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyBrandVisibilityForced: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyVisitorPreferredLang: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientLanguageDetect:
                "Seleziona se vuoi che la lingua del cliente venga rilevata automaticamente.",
            vtipySelectTopic:
                "Seleziona l'argomento che vuoi che i tuoi clienti vedano quando aprono la pagina del cliente.",
            vtipyAutoCallTransfer: "Seleziona se vuoi che le chiamate vengano trasferite automaticamente.",
            vtipyCustomerTyping: "Mostra quando il cliente sta scrivendo.",
            vtipyAgentTyping: "Mostra quando l'agente sta scrivendo.",
            vtipyQueueNumberVisibleFeature:
                "Seleziona se vuoi che il numero di coda sia visibile o meno quando il cliente apre la pagina del cliente.",
            vtipyPrivateChatEnabled: "Seleziona se vuoi che il chat privata sia abilitata o meno.",
            vtipyDelayedTalkTime:
                'Se nessun agente è connesso alla conversazione durante questo periodo, verrà etichettata come "Parola ritardata".',
            vtipyOfflineMode: "Seleziona se vuoi che la modalità offline sia abilitata o meno.",
            vtipyAutoAssignLimit: "Seleziona il numero massimo di conversazioni che un agente può gestire.",
            vtipyCustomerDownTimeWhenRepExit: "Seleziona il tempo di inattività del cliente quando l'agente esce.",
            tippyDisconnectTime: "Seleziona il tempo di disconnessione.",
            changeSettings: "Cambia impostazioni",
            totalBg: "chat totali",
            activeBg: "chat attive",
            watchBg: "GUARDARE",
            waitingBg: "chat in sospeso",
            lateBg: "conversazioni di passaggio",
            freeBg: "GRATUITO",
            maxCapacityBg: "CAPACITÀ MASSIMA",
            addNewSettings: "Aggiungi nuove impostazioni",
            darkMode: "Modalità scura",
            clientDefault: "Lingua predefinita del cliente",
            customerClientDefault: "Lingua predefinita del cliente",
            customerClientLanguageDetect: "Rilevamento automatico della lingua del cliente",
            visitorPreferredLang: "Lingua preferita del visitatore",
            preferredThemeColor: "Colore del tema preferito",
            detail: "Dettaglio",
            langSetting: "Impostazione della lingua",
            supportUs: "Supportaci su Patreon",
            changeLang: "Cambia lingua",
            fontSizeSetting: "Impostazione della dimensione del carattere",
            changeLangDesc: "lingua dell'applicazione {code} come impostazioni.",
            trLang: "Turco",
            enLang: "Inglese",
            fieldRequired: "{field} il campo è obbligatiorio.",
            selectALanguage: "Scegli una lingua",
            selectATheme: "Scegli un tema",
            responseForm: "Modulo di risposta",
            clientRequestInfo: "Informazioni sulla richiesta del cliente",
            createdDate: "Data di creazione",
            descMessage: "Messaggio descrittivo",
            new: "Nuovo",
            lastLoginPlatform: "Ultima piattaforma di accesso",
            requiredFieldField: "il campo è obbligatiorio.",
            catalogCategoryMenu: "Menu categoria catalogo",
            catalogCategoryLeaf: "Foglia categoria catalogo",
            selectAllPermission: "Seleziona tutti i permessi",
            catalogCategories: "Categorie di catalogo",
            copiedClipboard: "Copiato negli appunti",
            organizationLogo: "Logo dell'organizzazione",
            changePlan: "Cambia piano",
            close: "Chiudi",
            vtipyUploadLogo:
                "Puoi caricare il logo dell'organizzazione. Il logo verrà visualizzato nella parte superiore della pagina del cliente.",
            tagName: "Nome del tag",
            tagDescription: "Descrizione del tag",
            tagColor: "Colore del tag",
            userInformations: "informazioni utente",
            incomingChat: "Chat in arrivo",
            support: "Supporto",
            team: "Impostato",
            groups: "Gruppi",
            newConversationStarted: "Nuova conversazione iniziata",
            allHistoryLoaded: "Tutta la cronologia caricata",
            chatCreator: "Creatore di chat",
            enterGroupTitle: "Inserisci il titolo del gruppo",
            requiredTitle: "Non puoi lasciare vuoto il campo del titolo",
            requiredChannel: "Il nome del canale non può essere vuoto",
            next: "Confermare",
            selectPeople: "Seleziona Persone",
            textLimitAlertMessage:
                "Il limite di caratteri in WhatsApp è di 19 caratteri e oltre questo limite non verrà visualizzato. Tuttavia, sul Web, i testi che superano il limite di 19 caratteri vengono automaticamente spostati nella riga successiva e visualizzati.",
        },
        telegram: {
            typeInTelegramToken: "Inserisci il token di Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Token di Telegram",
            telegramAlertForm: "Modulo di avviso di Telegram",
            telegramAlertTitle: "Titolo dell'avviso di Telegram",
            telegramAlertText: "Testo dell'avviso di Telegram",
        },
        wp: {
            sendAgain: "Invia di nuovo",
            shippingDetails: "Dettagli di spedizione",
            importContactsFromFile: "Importa contatti da File",
            whatsapp: "Whatsapp",
            chatStartingWait: "Avvio della chat, attendere prego...",
            chatStarted: "Chat avviata",
            chatNotStarted: "Chat non avviata",
            contactSelected: "Contatto selezionato",
            startChatWithAnyNo: "Avvia una chat con qualsiasi numero",
            toLittleChar: "Inserisci almeno 3 caratteri",
            typeInANumberDesc: "Digita un numero di telefono per avviare una chat",
            wpPlusAndLicenceRequired: "Piano Whatsapp Plus e licenza richiesti.",
            wpPlusAndLicenceRequiredDesc:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            agreement: "Accordo",
            purchase: "Acquista",
            activating: "Attivazione",
            authenticating: "Autenticazione",
            ready: "Pronto",
            activationTitle: "Abilitare l'integrazione di Whatsapp su Supsis:",
            wpIntegrationInstruction1: "Apri Whatsapp sul tuo telefono e vai su Impostazioni.",
            wpIntegrationInstruction2: "Selezionare Menu o Impostazioni e fare clic su Dispositivi connessi. ",
            wpIntegrationInstruction3: "Punta il telefono su questa schermata per scansionare il codice",
            qrGeneratingWait: "Generazione del codice QR in corso, attendere...",
            pleaseContinueToWaitUntilCompleted:
                "Dopo che il codice QR è stato verificato, passerà automaticamente al campo completato. Attendere prego...",
            authenticatingWait: "Accesso, attendere prego...",

            enableFeature: "Abilita funzionalità",
            unsubscribeWpInetgration: "Annulla l'abbonamento all'integrazione di Whatsapp",
            unsubscribeIGIntegration: "Annulla l'abbonamento all'integrazione di Instagram",
            wpBack: "Torna a Whatsapp",
            terminatelWpInetgration:
                "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Whatsapp.",
            cancelWpInetgration: "Vuoi annullare l'abbonamento all'integrazione di Whatsapp?",
            terminatelIGIntegration:
                "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Instagram.",
            cancelIGIntgeration: "Vuoi annullare l'abbonamento all'integrazione di Instagram?",
            startChatWp: "Avvia chat su Whatsapp",
            readAndAgree: "Ho letto e accetto l'accordo",
            subscribe: "Abbonati",
            subscribed: "Abbonato",
            toEnableWpDescription:
                "Per abilitare l'integrazione di Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            waitForWpActivationDescription:
                "Attendere che il servizio Whatsapp venga attivato. Questo processo può richiedere fino a 24 ore. Riceverai una notifica quando il servizio verrà attivato.",
            greatWpActivatedDescription:
                "Grande! Il servizio Whatsapp è stato attivato. Puoi iniziare a utilizzare il servizio.",
            unsubscribe: "Annulla abbonamento",
            planDetails: "Dettagli del piano",
            sendReceiveMessage: "Invia & Ricevi Messaggio ",
            sendReceiveImage: "Invia & Ricevi Immagine",
            sendReceiveAudio: "Invia & Ricevi Audio ",
            sendReceiveGif: "Invia & Ricevi Gif ",
            startChat: "Supsis Avvia Chat",
            supsisFunctionality: "Funzionalità Supsis",
            onePhoneMultiAgent: "Un telefono, più agenti",
            basicIntegration: "Integrazione di base",
            purchaseHeader: "Acquistare Integrazione Supsis-Whatsapp",
            wpServices: "Servizi Whatsapp",
            wpServicesIntegrationCompleted: "Integrazione dei servizi Whatsapp completata",
            purchasePaymentDescription:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            wpIntegrationFeatures: "Funzionalità di integrazione di Whatsapp",
            saveChanges: "Salva modifiche",
            contactList: "Elenco dei contatti",
            broadcast: {
                broadcast: "Trasmissione",
                detail: "Dettaglio",
                customer: "Cliente",
                phoneNumbers: "Numeri di telefono",
                showMore: "Mostra di più",
                showLess: "Mostra meno",
                groupName: "Nome del gruppo",
                messages: "Messaggi",
                status: "Stato",
                usageCost: "Costo di utilizzo",
                sendingTime: "Tempo di invio",
                progress: "Progresso",
                groupDetail: "Dettaglio del gruppo",
                messagesPerContact: "Messaggi per contatto",
                successRatio: "Rapporto di successo",
                message: "Messaggio",
            },
            messages: "Messaggi",
            broadcastRequests: "Richieste di trasmissione",
            customerGroups: "Gruppi di clienti",
            messageTemplates: "Modelli di messaggi",
            plans: "Piani",
            wpIntegrationRequired: "Integrazione di Whatsapp richiesta",
            wpRequiredIntegrationDescription:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            integrateWp: "Integra Whatsapp",
            active: "Attivo",
            archived: "Archiviato",
            createBroadcastMessage: "Crea un messaggio di trasmissione",
            title: "Titolo",
            description: "Descrizione",
            createdAt: "Creato a",
            numbers: "Numeri",
            actions: "Azioni",
            action: "Azione",
            createCustomerGroup: "Crea un gruppo di clienti",
            search: "Ricerca",
            name: "Nome",
            contacts: "Contatti",
            noContactFound: "Nessun contatto trovato",
            broadcastTitle: "Titolo della trasmissione",
            recipients: "Destinatari",
            selectRecipients: "Seleziona i destinatari",
            writeYourMessage: "Scrivi il tuo messaggio",
            schedule: "Programma",
            scheduleNowOrLater: "Programma ora o più tardi",
            summary: "Sommario",
            cancel: "Annulla",
            send: "Invia",
            sending: "Invio",
            deleteCustomerGroup: "Sei sicuro di voler eliminare questo gruppo di clienti? {name}",
            customerGroupDeleting: "Eliminazione del gruppo di clienti in corso",
            customerGroupDeletingSuccess: "Gruppo di clienti eliminato con successo",
            customerGroupDeletingError: "Errore durante l'eliminazione del gruppo di clienti",
            wpPlusRequired: "Richiesto Whatsapp Plus",
            broadcastMessageArchived: "Messaggio di trasmissione archiviato",
            broadcastMessageNotArchived: "Il gruppo di messaggi broadcast non è stato archiviato",
            groupNameSearch: "Inserisci il nome del gruppo cliente",
            groupNameDesc: "Il nome del gruppo cliente identifica i tuoi gruppi di clienti",
            save: "Salva",
            number: "NUMERO",
            addColumn: "Aggiungi colonna",
            addColumnDesc: "Aggiungi una colonna alla tabella",
            addNewContact: "Aggiungi nuovo contatto",
            addNewContactDesc: "Aggiungi una persona alla tabella",
            importFile: "Importa da file",
            importFileDesc: "Importa i contatti da un file Excel o CSV",
            contactAdded: "Contatto aggiunto",
            updateCustomerGroup: "Aggiornamento gruppo cliente in corso...",
            updateCustomerGroupSuccess: "Gruppo cliente aggiornato con successo",
            sendBroadcastMessage: "Invia messaggio broadcast",
            columnName: "Nome colonna",
            columnType: "Tipo colonna",
            defaultValue: "Valore predefinito",
            setDefaultValue: "Imposta il valore predefinito per i contatti esistenti",
            age: "Età",
            location: "Posizione",
            gender: "Genere",
            selectContactFile: "Seleziona il file dei contatti",
            selectContactCsvOrExcel: "Seleziona un file CSV o Excel",
            importConfiguration: "Importa la tua configurazione",
            customizeFile: "Personalizza il file dei contatti aggiunti",
            sendMessageTo: "A chi desideri inviare il messaggio?",
            allContact: "Tutti i contatti",
            messageTypes: "Tipi di messaggio",
            whenSendMessage: "Quando desideri inviare il messaggio?",
            instantlyRightNow: "Immediatamente, adesso",
            completed: "Completato",
            scheduleFuture: "Pianifica per una data futura",
            messageDesc: "Il tuo messaggio sarà inviato istantaneamente a tutti i destinatari",
            messageSendAt: "Il tuo messaggio sarà inviato a tutti i destinatari in questa data: ",
            estimatedPrice: "Prezzo stimato",
            estimatedTime: "Tempo stimato",
            now: "Adesso",
            tenMinute: "10 minuti",
            cancelled: "Annullato",
            failed: "Fallito",
            running: "In esecuzione",
            queued: "In coda",
            scheduled: "Pianificato",
            noNumberAdded: "Nessun numero aggiunto",
            csvOrExcelFile: "File CSV o Excel",
            broadcastMessagesToContactFile: "Invia messaggi broadcast alla lista contatti",
            broadcastMessageTemplates: "Modelli di messaggi broadcast",
            messageFlow: "Flusso del messaggio",
            textMessageSupport: "Supporto messaggi di testo",
            imageMessageSupport: "Supporto messaggi con immagini",
            spamPreventions: "Prevenzione dello spam",
            includesAllBasicPlans: "Include tutte le funzionalità del pacchetto WhatsApp",
            chatbotIntegration: "Integrazione con chatbot",
            messageToNewNumbers: "Invio messaggi ai nuovi numeri",
            broadcastMessageToEveryone: "Invio messaggi broadcast a tutti",
            personalizedBroadcastMessage: "Messaggi broadcast personalizzati",
            customerGroupSegmentation: "Segmentazione del gruppo cliente",
            scheduleBroadcastMessage: "Pianificazione messaggi broadcast",
            locationMessageSupport: "Supporto messaggi di posizione",
            advancedSpamPreventions: "Prevenzione avanzata dello spam",
            whatsappPlans: "Piani WhatsApp",
            selectBestPlan: "Seleziona il piano migliore per te",
            comingSoon: "Disponibile a breve...",
            selectFile: "Seleziona un file",
            created: "Creato",
            message: "Messaggio",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            instagramComments: "Commenti Instagram",
            messengerComments: "Commenti Messenger",
            trendyolComments: "Commenti Trendyol",
            ticketSelection: "Ticket Selezionato",
            bulkClose: "Chiusura di Massa",
            igComment: "Commento Instagram",
            igMentioned: "Menzioni su Instagram",
            incomingReqChatbot: "Richieste in arrivo con Chatbot",
            incomingReqWebForm: "Richieste da modulo web",
            incomingReqAutomation: "Richieste dall'automazione",
            thisPersonEmailAnswered: "Questa persona vuole una risposta via e-mail",
            thisPersonWpAnswered: "Questa persona è in attesa di una risposta via WhatsApp",
            clickStartWpChat: "Fare clic per avviare una chat WhatsApp",
            requestProgress: "Stato di avanzamento della richiesta",
            requestMessage: "Messaggio di richiesta",
            clickAddMailAddress: "Clicca per aggiungere un indirizzo e-mail",
            sendReplyCloseTicket: "Invia risposta e chiudi il biglietto",
            closeTicket: "Chiudi biglietto",
            selectEmailSender: "Seleziona il mittente dell'e-mail",
            withEmailWillNotRecievice:
                "Non sarà possibile ricevere risposte all'e-mail quando si invia con questo indirizzo e-mail!",
            deleteCommentAndClose: "Cancella e chiudi il commento",
            sendReplyAndClose: "Invia risposta e chiudi",
            startChatWp: "Avvia chat WhatsApp",
            sureWantToDeleteTicket: "Sei sicuro di voler eliminare un biglietto?",
            bulkDeleteConfirmation: "Conferma di cancellazione in blocco",
            selectedTicketSucsDelete: "I biglietti selezionati sono stati eliminati con successo",
            thereErrorDeletingTicket: "Si è verificato un errore durante l'eliminazione dei biglietti",
            deleteConfirm: "Conferma l'eliminazione",
            sureDeleteTicket: "Sei sicuro di voler cancellare questo biglietto?",
            ticketSucsDelete: "Biglietto eliminato con successo",
            represantiveSucsAppoint: "L'agente è stato nominato con successo",
            ticketClosedSucs: "Biglietto chiuso con successo",
            ticketCloureFailed: "Chiusura del biglietto non riuscita.",
            unprocessed: "Non elaborato",
            pleaseSelectValidStatus: "Selezionare uno stato valido",
            ticketStatusBeenUpdatd: "Lo stato del biglietto è stato aggiornato",
            doYouWantCloseTicket: "Vuoi chiudere il biglietto?",
            ticketWillMarkedClosed: "Il biglietto sarà contrassegnato come chiuso e archiviato",
            errorUpdatingTicketFailed: "Si è verificato un errore durante l'aggiornamento dello stato del biglietto",
            igCommentDeleteIgPost: "Il commento Instagram è stato eliminato dal vostro post IG",
            igCommentHideChange: "Lo stato di nascondimento dei commenti di Instagram è stato modificato",
            pleaseChooseRepresent: "Selezionare un rappresentante",
            selectedTicketSucsDelegated: "I biglietti selezionati sono stati delegati con successo",
            errorOccuredDuringDelegation: "Si è verificato un errore durante il processo di delega",
            bulkTicketClosing: "Chiusura di un biglietto in blocco",
            sureWantCloseTicket: "Sei sicuro di voler chiudere il ticket?",
            selectedTicketSucsClosed: "I ticket selezionati sono stati chiusi con successo",
            thereErrorClosingTicket: "Si è verificato un errore durante la chiusura dei ticket",
            changeFilterTicketPage: "Modifica dei filtri della pagina Biglietti",
            nameOfFilter: "Nome del filtro",
            filterValue: "Valore del filtro",
            deletesSelectedTickets: "Cancella i biglietti selezionati",
            idTicketBeDelete:
                "Gli id dei biglietti da eliminare (id dei biglietti selezionati o tutti gli id dei biglietti elencati)",
            assignsAgentSelectedTickets: "Assegna un rappresentante ai biglietti selezionati",
            idTicketBeAssigned:
                "ID dei biglietti da assegnare. (ID dei biglietti selezionati o ID di tutti i biglietti elencati)",
            idAgentAssigned: "ID del rappresentante da assegnare",
            changesStatusSelectedTicket: "Cambia lo stato dei biglietti selezionati",
            idTicketWhoseStatus:
                "ID dei biglietti di cui cambiare lo stato. (ID dei biglietti selezionati o ID di tutti i biglietti elencati)",
            newStatus: "Nuovo Stato",
            selectedTicketsSucsUpdated: "Lo stato dei biglietti selezionati è stato aggiornato con successo.",
            errorWhileChangingStatus: "Si è verificato un errore durante la modifica dello stato dei biglietti.",
            thisPageVoiceAssistant: "C'è un assistente vocale in questa pagina",
            hello: "Ciao!",
            voiceAssistantContent: ` Sapevi che c'è un <strong>Assistente AI</strong> che può aiutarti in questa pagina? Puoi provare a usare l'assistente con i seguenti metodi:`,
            commandHoldingDownTheKey: "puoi tenere premuto il tasto combinato e dare comandi parlando.",
            topRightContent: "In alto a destra",
            clickOnTheIcon: "clicca sull'icona per avviare l'assistente.",
            sampleVoiceCommands: "Esempi di comandi vocali:",
            showMyTickets: "Mostra i miei biglietti",
            showMeZeynepsOpenTicket: "Mostra i biglietti aperti di Zeynep oggi",
            deleteTicketsScreen: "Cancella i biglietti sullo schermo",
            assigntLastTicketAli: "Assegna l'ultimo biglietto ad Ali",
            changeStatusAllTicket: "Cambia lo stato di tutti i biglietti in done",
            setStatusTicketsScreen: "Imposta lo stato dei biglietti sullo schermo su .......",
            assigntUserTicketScreen: "Assegna i biglietti sullo schermo all'utente .....",
            assigntFirstTicket: "Assegna il primo biglietto a me",
            showIgTickets: "Mostra i biglietti instagram del mese scorso",
            makeChoice: "Effettua una selezione",
            makeAssignment: "Assegnazione",
            tickets: "Biglietti",
            instagramTickets: "Biglietti Instagram",
            facebookTickets: "Biglietti Facebook",
            trendyolTickets: "Biglietti Trendyol",
            automationTickets: "Biglietti di automazione",
            supsisFormTickets: "Supsis Form Tickets",
            columnSettings: "Impostazioni della colonna",
            ticketField: "Area biglietti",
            contactPropertyFields: "Raggiungere le aree di proprietà",
            ticketFilterList: {
                archivedRequests: "Richieste archiviate",
                comingFromFacebook: "In arrivo da Facebook",
                comingFromInstagram: "Provenienti da Instagram",
                unassignedOpenRequests: "Richieste aperte non assegnate",
                openRequests: "Richieste aperte",
                requestsOpenedThisWeek: "Richieste aperte questa settimana",
                specialList: "Elenco speciale",
                creationDate: "Data di creazione",
                supsisFromTheForm: "Supsis dal modulo",
                fromTrendyol: "Da Trendyol",
                comesWithAutomation: "Viene dall'automazione",
                label: "Etichetta",
                status: "Stato",
                subject: "Oggetto",
                email: "Email",
                name: "Nome",
                phone: "Telefono",
                type: "Tipo",
                assignedUser: "Utente assegnato",
            },
            appointingRepresentative: "Nomina un rappresentante",
            ticketTagFilter: "Filtro Tag Ticket",
            ticketEmails: "Lista Indirizzi Email di Reindirizzamento Ticket",
            save: "Salva",
            delete: "Elimina",
            transactions: "Transazioni",
            noEmailTicketNotifications: "Nessuna notifica via email per il reindirizzamento dei ticket trovata",
            emailIsNotValid: "Indirizzo email non valido",
            emailNotificationDeleted: "Notifica via email per il reindirizzamento dei ticket eliminata",
            emailNotificationDeleteError:
                "Impossibile eliminare la notifica via email per il reindirizzamento dei ticket",
            tagFilterRequired:
                "È necessario specificare un filtro di tag per i ticket. Puoi utilizzare il carattere jolly '*' per tutti i ticket!",
            emailsRequired: "È necessario specificare almeno un indirizzo email per il reindirizzamento dei ticket",
            emailNotificationCreated: "Creata notifica via email per il reindirizzamento dei ticket",
            emailNotificationCreateError: "Impossibile creare la notifica via email per il reindirizzamento dei ticket",
            ticketForwarding: "Reindirizzamento Email dei Ticket",
            ticketTagFilterDesc:
                "Utilizza i tag dei ticket utilizzati nel design del chatbot per filtrare i ticket. Puoi inserire un tag diverso e premere Invio per aggiungerlo. Seleziona '*' per tutti i ticket.",
            ticketEmailsDesc:
                "Elenco degli indirizzi email a cui reindirizzare i ticket. Puoi selezionare gli indirizzi email dei rappresentanti del sistema o aggiungere indirizzi email esterni.",
            ticketList: "Regole di Reindirizzamento dei Ticket",
            ticketTagFilterPlaceHolder: "Filtro ticket, seleziona '*' per tutti",
            ticketEmailsPlaceHolder: "Elenco indirizzi email di reindirizzamento",
        },
        theme: {
            headerColor1: "Colore Intestazione (Sinistra)",
            headerColor1A: "Colore/Trasparenza dell'Intestazione",
            headerColor2: "Colore Intestazione (Destra)",
            headerColor2A: "Colore/Trasparenza dell'Intestazione 2",
            backgroundColor: "Colore di Sfondo (Sinistra)",
            backgroundColorA: "Colore/Trasparenza di Sfondo 1",
            backgroundColor2: "Colore di Sfondo (Destra)",
            backgroundColor2A: "Colore/Trasparenza di Sfondo 2",
            opacity: "Trasparenza",
            textColor: "Colore Testo Generale",
            errorTheme: "Colore Errore",
            bubbleBackground: "Colore Sfondo Bubble (Agente)",
            bubbleVisitorBackground: "Colore Sfondo Bubble (Visitatore)",
            bubbleBackgroundA: "Trasparenza Bubble (Agente)",
            bubbleVisitorBackgroundA: "Trasparenza Bubble (Visitatore)",
            bubbleText: "Colore Testo Bubble (Agente)",
            bubbleVisitorText: "Colore Testo Bubble (Visitatore)",
            textFormColor: "Colore Testo Form",
            selectCustom: "Seleziona Tema Personalizzato",
            font: "Carattere",
            headerColorSecond: "Colore Superiore Intestazione",
            headerColorFirst: "Colore Inferiore Intestazione",
            backgroundColorFirst: "Colore Superiore Sfondo",
            formColor: "Colore Testo Form",
            buttonColor: "Colore Pulsante",
            backgroundColorSecond: "Colore Inferiore Sfondo",
            chatBotButtonText: "Colore del carattere del chatbot",
            chatBotButtonColor: "Colore pulsante chatbot",
        },
        billing: {
            billingContactInfo: "Informazioni sul contatto di fatturazione aggiornate con successo",
            defaultRootEmail: "Predefinito: Email di base",
            invoiceEmailAddress: "Indirizzo e-mail di fatturazione",
            invoiceSettings: "Impostazioni della fattura",
            updateChannelDesc6: "Aggiornamento del canale Whatsapp business api",
            newWabaChannel: "Nuovo canale Whatsapp Business",
            newWabaChannelDesc: "Crea un nuovo canale per Whatsapp business api",
            popular: "Popolare",
            selectedPlan: "Piano selezionato",
            editPlan: "Modifica piano",
            removePlan: "Rimuovi piano",
            showPlan: "Mostra piano",
            hiddenPlan: "Piano nascosto",
            contactSales: "Contatto vendite",
            showLess: "Mostra meno",
            more: "Di più",
            selectTransactionType: "Seleziona il tipo di transazione",
            walletLogs: "Registri del portafoglio",
            addBalance: "Aggiungi saldo",
            availableBalance: "Saldo disponibile",
            appsumoPack: "Pacchetto Appsumo",
            updatePlan: "Aggiorna piano",
            createPlan: "Crea piano",
            freePack: "Pacchetto gratuito",
            instantFee: "Verrà addebitato un costo immediato",
            planSequence: "Sequenza di piani",
            areYouSoreRefundInvoice: "È sicuro di voler elaborare un rimborso per questa fattura?",
            requiredCodes: "Numero di codici richiesti",
            subHeading: "Sottointestazione",
            featureKey: "Chiave caratteristica",
            customerKey: "Chiave cliente",
            monthlyPrice: "Prezzo mensile",
            monthlyNonDiscounted: "Prezzo mensile non scontato (visualizzazione non funzionale)",
            twoYearDiscount: "Sconto di 2 anni",
            yearDiscount: "Sconto annuale",
            sixMonthDiscount: "6 mesi",
            threeMonthDiscount: "3 mesi",
            features: "Proprietà",
            sessionCount: "Conteggio delle sessioni",
            subType: "Tipo di abbonamento",
            skipTrialVersion: "Salta la versione di prova",
            skipTrialVersionDesc:
                "È possibile saltare la versione di prova e continuare selezionando il pacchetto appropriato per la propria attività. Se si salta la versione di prova, questa azione non può essere annullata.",
            skipStep: "Salta questo passaggio",
            switchToPay: "Passa a pagare",
            forward: "Avanti",
            pleaseFillInCard: "Inserire i dati della carta!",
            fillInTheBillingAddress: "Inserisci i dati dell'indirizzo di fatturazione!",
            cardNumberWrong: "Il numero della carta è sbagliato!",
            pleaseConfirmTheUser: "Si prega di confermare l'accordo con l'utente",
            pleaseCheckYourCard: "Controlla la tua carta e i tuoi dati.",
            sito: "Sito",
            period: "Periodo",
            billStatus: "Stato della fattura",
            totalPrice: "Prezzo totale + IVA",
            depotMoneyWallet: "Deposito nel portafoglio",
            threeMonthly: "3 mesi",
            sixMonthly: "6 mesi",
            twoYearly: "2 anni",
            forever: "Per sempre",
            extraPackage: "Pacchetto extra",
            teamPackage: "Pacchetti di squadra",
            adventPackage: "Pacchetti vantaggiosi",
            cupponError: "Il codice del buono è errato o scaduto",
            enterYourCard: "Inserire la carta di credito",
            invalidCard: "Carta di credito non valida, pagamento non ricevuto",
            calculateThis: "Calcola per:",
            adventageousPackage: "Vantaggiosi sconti sui pacchetti!",
            cupponApplied: "Coupon applicato con successo",
            subStart: "Abbonamento avviato",
            subSuccessStart: "L'abbonamento è stato avviato con successo",
            success: "Successo",
            succesDesc: "Abbonamento creato con successo",
            successDesc: "La funzione è stata attivata con successo.",
            maxNumber: "Numero massimo di rappresentanti che possono intervenire",
            currentAmountDetails: "Dettagli sull'importo corrente",
            endOfMonthForecastDetails: "Dettagli della previsione di fine mese",
            totalAmount: "Importo totale",
            vatAmount: "Importo IVA (20%)",
            totalAmountIncludingVAT: "Importo totale IVA inclusa",
            hideDetails: "Nascondi dettagli",
            createInvoice: "Crea fattura",
            reimbursementMade: "Rimborso effettuato",
            invalidInvoice: "Fattura non valida",
            balanceTopUp: "Ricarica saldo",
            paidSuccesfully: "La fattura è stata pagata con successo",
            paymentFailed: "Il processo di pagamento della fattura non è riuscito",
            areYouSurePaid: "Sei sicuro di voler contrassegnare questa fattura come pagata?",
            invoiceMarkedPaid: "La fattura è stata contrassegnata come pagata",
            invoiceMarkedFailed:
                "Si è verificato un errore e non è stato possibile contrassegnare la fattura come pagata",
            areYouSureRefundInvoice: "Sei sicuro di voler elaborare un rimborso per questa fattura?",
            youMustFillInEmpty: "È necessario riempire tutti gli spazi vuoti",
            createdNewInvoice: "La nuova fattura è stata creata con successo",
            createdNewInvoiceFailed: "Si è verificato un errore durante la creazione della fattura",
            invoiceUpdated: "L'importo della fattura è stato aggiornato con successo...",
            invoiceUpdatedFailed: "Si è verificato un problema durante l'aggiornamento della fattura",
            plans: "Piani",
            companyName: "Nome della società",
            company: "Azienda",
            person: "Persona",
            invoiceAddressInfo: "Informazioni sull'indirizzo della fattura",
            idNo: "ID turco",
            taxOffice: "Ufficio delle imposte",
            taxNumber: "Numero di imposta",
            packageCanNotDownSupsis:
                "Il pacchetto non può essere declassato. Rimuovere o disattivare alcuni agenti per eseguire il downgrade del pacchetto.",
            packageCanNotDownWp:
                "Il vostro pacchetto non può essere declassato. Eliminate alcuni dei vostri canali Whatsapp per declassare il vostro pacchetto.",
            packageCanNotDownWPBussiness:
                "Il tuo pacchetto non può essere declassato. Si prega di eliminare alcuni dei canali Whatsapp Business per declassare lo stato del pacchetto.",
            chooseYourPlan: "Scegli il tuo piano.",
            numberOfRepresentatives: "Numero di rappresentanti",
            numberOfChannels: "Numero di canali",
            wpNumberOfChannels: "Numero di canali Whatsapp",
            igNumberOfChannels: "Numero di canali Instagram",
            msNumberOfChannels: "Numero di canali Messenger",
            cancelIt: "Cancelar",
            activePlan: "Plan Atif",
            activate: "Activar",
            noTransition: "Sin transición",
            daysLater: "días después",
            payBack: "Rimborso",
            paid: "Pagato",
            unPaid: "Non pagato",
            editPrice: "Modifica prezzo",
            payNow: "paga ora",
            youAreCurrentlyOnTrial: "Sei attualmente in prova. Puoi saltare la prova per vedere i pacchetti esclusivi.",
            youAreCurrentlyLimited:
                "Sei attualmente limitato dal sistema perché i tuoi pacchetti non soddisfano le condizioni.",
            youHaveOneRepresentative: "Hai un rappresentante.",
            deactivateOrDeleteYourPiece:
                "Disattiva o elimina il tuo rappresentante Piece o acquista un rappresentante.",
            youHaveOneWhatsappQRChannel: "Hai un canale Whatsapp QR.",
            deleteYourWhatsAppQR: "Elimina il tuo canale Whatsapp QR o acquista un canale.",
            youHaveAWhatsappBusiness: "Hai un canale Whatsapp Business.",
            deleteYourWhatsapp: "Elimina il tuo canale Whatsapp Business o acquista un canale.",
            youHaveAnInstagram: "Hai un canale Instagram.",
            deleteYourInstagram: "Elimina il tuo canale Instagram o acquista un canale.",
            youHaveAMessenger: "Hai un canale Messenger.",
            deleteYourMessenger: "Elimina il tuo canale Messenger o acquista un canale.",
            additionalPackages: "Pacchetti aggiuntivi.",
            availablePackages: "Pacchetti disponibili",
            buyNow: "Acquista ora",
            invoiceInformation: "Informazioni sulla fattura",
            invoiceAddress: "Indirizzo della fattura",
            invoiceType: "Tipo di fattura",
            review: "Recensione",
            viewDetails: "Visualizza dettagli",
            addNewAddress: "Aggiungi nuovo indirizzo",
            enterYourBillingAddress: "Inserisci il tuo indirizzo di fatturazione",
            selectPlan: "Seleziona piano",
            paymentStatus: "Stato pagamento",
            amount: "Importo",
            invoiceID: "ID Fattura",
            expected: "Previsto...",
            currentAmount: "Importo attuale",
            monthlyEstimatedAmount: "Importo mensile stimato",
            creationDate: "Data di creazione",
            invoiceStatus: "Stato della fattura",
            invoicePeriod: "Periodo di fatturazione",
            newPaymentMethod: "Nuovo metodo di pagamento",
            channelCount: "Numero di canali",
            remainingTime: "Tempo rimanente",
            chatbotLimit: "Limite chatbot",
            free: "Gratuito",
            maxChatbotSession: "Sessioni massime del chatbot",
            buyIt: "Acquista",
            renewalDate: "Data di rinnovo",
            monthly: "Mensile",
            yearly: "Annuale",
            packagePeriod: "Periodo del pacchetto",
            packageType: "Tipo di pacchetto",
            packageManagement: "Gestione pacchetti",
            invoiceManagement: "Gestione delle fatture",
            futureInvoice: "Fattura futura",
            pastInvoices: "Fatture passate",
            creditCard: "Carta di credito",
            invoice: "Fattura",
            mustBeUpgradePlanForChatBot: "Per attivare la funzione di Chatbot, è necessario passare al piano Pro!",
            cardInfo: "Informazioni sulla carta",
            billingDetails: "Dettagli di fatturazione",
            addCardIyzico:
                "Non hai una carta registrata. Per poter pagare le tue tariffe mensili, è necessario aggiungere una carta. Il sistema di pagamento è fornito da iyzico.",
            billingPlanSettings: "Impostazioni di fatturazione e metodo di pagamento",
            paymentMethod: "Metodo di pagamento",
            billingDate: "Data di fatturazione",
            isPaid: "È stato pagato?",
            markPaid: "Contrassegna come pagato",
            paymentDate: "Data di pagamento",
            pay: "Paga Fattura",
            newInvoice: "Nuova Fattura",
            updateBilling: "Modifica Indirizzo di Fatturazione",
            updateCard: "Cambia Carta di Credito",
            paymentBilling: "Metodo di pagamento e indirizzo di fatturazione",
            price: "Importo Fattura",
            billingAddress: "Indirizzo di Fatturazione",
            billingCity: "Città di Fatturazione",
            billingCountry: "Paese di Fatturazione",
            contactName: "Nome del contatto per la fatturazione",
            expireMonth: "Mese di Scadenza",
            expireYear: "Anno di Scadenza",
            cardNumber: "Numero di Carta",
            cardHolderName: "Nome del Titolare della Carta",
            cardAlias: "Alias della Carta",
            identityNumber: "Numero di Identificazione/Fiscale",
            name: "Nome",
            surname: "Cognome",
            email: "Email",
            addCard: "Aggiungi Carta",
            update: "Aggiorna",
            cancel: "Annulla",
            save: "Salva",
            saving: "Salvataggio in corso",
            noInvoiceFound: "Nessuna fattura trovata",
            year: "Anno",
            updating: "Aggiornamento in corso",
            newInvoiceForm: "Nuovo Modulo di Creazione Fattura",
            error: "Errore",
            transactions: "Transazioni",
            paymentMethodAdded: "Metodo di pagamento aggiunto con successo",
            paymentMethodAddError: "Impossibile aggiungere il metodo di pagamento, si è verificato un errore",
            creditCardChanged: "La tua carta di credito è stata cambiata",
            errorOccurred: "Si è verificato un errore, riprova.",
            billingDetailUpdated: "Le tue informazioni di fatturazione sono state aggiornate",
            invoiceCreated: "La fattura è stata creata con successo",
            paymentSuccess: "La tua fattura è stata pagata con successo, grazie",
            paymentFail: "Si è verificato un errore durante il pagamento della fattura, riprova più tardi.",
            startWith: "Carta {binNumber} che inizia con {cardFamily}",
            billingAddressChanged: "Le informazioni sull'indirizzo di fatturazione sono state aggiornate",
            hidePlan: "Nascondi Piano",
            informationShopping:
                "Le tue informazioni di pagamento, di fatturazione e di carta di credito sono controllate da Shopify.",
            trialTimeInformation:
                "Restano {dayCount} giorni al termine della versione di prova. Se non inserisci un metodo di pagamento entro questo periodo, il sistema passerà automaticamente al piano GRATUITO.",
            trialTimeInformationShort: "{dayCount} giorni rimanenti",
            currentPlanLabel: "Piano attuale: Piano {planName} ({agentCount} Agenti)",
            changeCancelPlan: "Cambia/Annulla Piano",
            oneAgent: "Agente",
            agent: "Agente",
            yourCurrentPlan: "Il tuo Piano Attuale",
            month: "Mese",
            billedMonthToMonth: "(Fatturazione mensile)",
            selectAgentCount: "Seleziona il Numero di Agenti",
            selectFreePlan: "Seleziona il Piano Gratuito",
            planDetails: "Dettagli del Piano",
            multiAgent: "(Multi-agente)",
            selectProPlan: "Seleziona il Piano Pro",
            foreverFree: "Sempre Gratis",
            websiteIntegration: "Integrazione del Sito Web",
            websiteIntegrationUnlimited: "Integrazione del Sito Web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Chiamata Video",
            multiAgentUpTo: "Multi-agente (fino a {agentCount} Agenti)",
            audioCallUnlimited: "Chiamata Audio",
            screenSharingUnlimited: "Condivisione Schermo",
            fileTransferUnlimited: "Trasferimento File",
            autoChatAssignerUnlimited: "Assegnazione Chat Automatica",
            multiLanguageTranslationUnlimited: "Traduzione Multilingue Automatica",
            detailedReporting: "Report Dettagliati",
            days30TrialsAvailable: "Versione di Prova di 30 Giorni",
            limitedArchiveLookupLastMo: "Ricerca Archivio Limitata (Ultimi {monthCount} mesi)",
            fullCustomizationUnlimited: "Personalizzazione Completa",
            planUpdated: "Il tuo piano è stato aggiornato con successo.",
            planUpdating: "Aggiornamento del piano in corso...",
            planUpdatingDescription: "Attendere durante l'aggiornamento!",
            done: "Fatto",
            freePlanUpdated: "Il tuo piano è stato aggiornato al Piano Gratuito. (Numero massimo di Agenti: 1)",
            proPlanUpdated:
                "Il tuo piano è stato aggiornato al Piano Pro. (Numero massimo di Agenti: {proPlanUpdated})",
            canNotDwnGrade:
                "Il tuo piano non può essere ridotto da {agentCountFirst} a {valNewPlnToUppr} {agentCountSecond}! I crediti degli Agenti sono in uso.",
            deleteWarning: "È necessario eliminare {valDif} Agenti.",
            warnMessage: "Il piano selezionato deve essere diverso dal piano attuale",
            add: "Aggiungi",
            cancelYourPlan: "Annulla il Tuo Piano",
            upgradeYourPlan: "Passa a un Piano Superiore",
            downgradeYourPlan: "Riduci il Tuo Piano",
            agree: "ACCETTA",
            disagree: "ANNULLA",
            invoices: "Fatture",
            priceIntervals: "Intervallo di Prezzo",
            selectSiteAlias: "Inserisci o Seleziona il Nome del Sito",
            selectPriceInterval: "Inserisci o Seleziona l'Intervallo di Prezzo",
            isRefunded: "Rimborsato",
            invoiceId: "ID Fattura",
            siteId: "ID Sito",
            createdDate: "Data di Creazione",
            failCount: "Numero di Tentativi di Pagamento Falliti",
            failDate: "Data di Pagamento Non Effettuato",
            Dashboard: "Dashboard",
            Agents: "Agenti",
            Integration: "Integrazione",
            Settings: "Impostazioni",
            Contacts: "Contatti",
            Domain: "Dominio",
            lastActivity: "Ultima Attività",
            basePrice: "Prezzo Base",
            packagePrice: "Prezzo Pacchetto",
            whatsappPrice: "Prezzo WhatsApp",
            realtimeVisitorCount: "Numero di Visitatori in Tempo Reale",
            suspend: "Sospendi",
            partner: "Partner",
            plan: "Piano",
            trialDay: "Giorno di Prova",
            mobile: "Mobile",
            webSite: "Sito Web",
            websiteOrigins: "Origini del Sito Web",
            ownerName: "Nome del Proprietario",
            ownerEmailAddress: "Indirizzo Email del Proprietario",
            discount: "Sconto",
            daysLeft: "Giorni Rimanenti",
            newTrialPopUp: "Quanti giorni dovrebbe durare la nuova prova gratuita?",
            newWpPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di WhatsApp?",
            newIGPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di Instagram?",
            newBasePricePopUp: "Quanto dovrebbe essere il nuovo prezzo di base di Supsis?",
            siteInfoUpdated: "Informazioni sul Sito Aggiornate",
            siteInfoNotUpdated: "Informazioni sul Sito Non Aggiornate",
            siteInfoNotUpdatedErr: "Errore durante l'aggiornamento delle informazioni sul sito.",
        },
        tour: {
            representativeTab: "Rappresentante Tabella",
            stats: "PANNELLO DI STATISTICHE",
            chats: "PANNELLO CHAT",
            settings: "IMPOSTAZIONI",
            status: "STATO",
            prevStep: "Passo Precedente",
            nextStep: "Passo Successivo",
            finish: "Fine",
            skip: "Salta",
            skip2: "Conosco già il sistema, non mostrare di nuovo",
            startTour: "Inizia Tour",
            firstTimeIntro:
                "Ho notato che è la tua prima volta nel sistema. Sei d'accordo se avvio un breve tour introduttivo?",
            hi: "Ciao",
            welcomeTo: "Benvenuto in Supsis Live Support",
            statsPanel: "È una barra di stato che mostra il numero di chat in attesa, totali e attive in tempo reale.",
            sidebarMenu: "Menu",
            sidebarMenuContent: "Puoi navigare tra le pagine da qui.",
            representativePrivateMessage: "Pannello Messaggi Privati Rappresentante",
            representativePrivateMessageContent: "Puoi visualizzare i messaggi privati tra i rappresentanti da qui.",
            helpMenu: "Menu di Aiuto",
            helpMenuContent: "Puoi accedere alle informazioni di aiuto sul sistema da qui.",
            settingsMenu: "Menu Impostazioni",
            settingsMenuContent:
                "Puoi impostare la lingua, la modalità notturna e il ridimensionamento dello schermo da qui.",
            startChat: "Inizia chat",
            profileMenu: "Menu Profilo",
            profileMenuContent: "Puoi modificare la tua disponibilità e le impostazioni del rappresentante da qui.",
            visitorsTab: "Visitatori",
            visitorsTabContent: "Puoi visualizzare i visitatori da qui.",
            visitorTabHistory: "Cronologia Visitatori",
            visitorTabHistoryContent: "Puoi visualizzare la cronologia dei visitatori da qui.",
            representativ_eTab: "Rappresentanti",
            representativeTabContent: "Puoi visualizzare i rappresentanti da qui.",
            liveSupport: "Supporto Live",
            liveSupportContent: "Puoi visualizzare il numero di clienti nel supporto live da qui.",
            siteVisitors: "Visitatori del Sito",
            siteVisitorsContent: "Puoi visualizzare il numero di visitatori del sito da qui.",
            tableSettings: "Impostazioni Tabella",
            tableSettingsContent: "Puoi mostrare o nascondere le colonne nella tabella da qui.",
            watchModeButton: "Pulsante Modalità Osservatore",
            watchModeContent: "Puoi partecipare come osservatore e vedere solo i messaggi inviati.",
            popoverInfo: "Dettagli Visitatore",
            popoverInfoContent: "Fornisce informazioni sul visitatore.",
            popoverButton: "Impostazioni Avanzate Chat",
            popoverButtonContent:
                "Puoi aprire la chat, inviare messaggi privati al rappresentante o bloccare il visitatore.",
            openChat: "Pulsante Apri Chat",
            openChatContent: "Puoi aprire la chat da qui.",
            pagination: "Menu di Paginazione",
            paginationContent: "Puoi aumentare il numero di pagine da qui.",
            chatwindow: {
                chatWindowSettingsButtons: "PULSANTI IMPOSTAZIONI FINESTRA DI CHAT",
                chatWindowActionButtons: "PULSANTI AZIONE GENERALE FINESTRA DI CHAT",
                chatPanelActions: "AZIONI PANNELLO DI CHAT",
                otherPanels: "ALTRI PANNELLI",
                settingsButton:
                    "Puoi bloccare la chat, instradarla, inviare messaggi privati e assegnare un rappresentante.",
                chatColorButton: "Puoi scoprire il significato dei colori delle bolle di chat da qui.",
                keyboardShortcutButton: "Puoi trovare le scorciatoie per le funzioni utili durante la scrittura.",
                hideButton: "Riduce la chat attiva in basso e rimane aperta sullo sfondo.",
                closeButton: "Termina la chat attiva e esci dalla conversazione.",
                ellipsisButton:
                    "Qui troverai altre opzioni come invio di messaggi privati, blocco del visitatore o assegnazione di un rappresentante.",
                userInfoWidget: "Fornisce informazioni dettagliate sul visitatore.",
                preparedContentWidget:
                    "Qui troverai modelli di contenuto predefiniti. Puoi aggiungerli rapidamente premendo o utilizzando la sequenza di tasti corrispondente nell'area di scrittura della chat.",
                chatHistoryWidget:
                    "Se il visitatore ha una cronologia di chat precedenti, verrà elencata qui. Puoi consultare le conversazioni passate da qui.",
                chatBarButton:
                    "Puoi bloccare la chat attiva, inviare messaggi privati al rappresentante e uscire dalla chat.",
            },
        },
        adminUser: {
            newAdminUserForm: "Nuovo Modulo Utente Admin",
            updateAdminUserForm: "Modulo di aggiornamento utente admin",
            adminUsers: "Utenti Admin",
            newAdminUser: "Nuovo Utente Admin",
            noAdminUser: "Nessun Utente Admin",
            adminUserName: "Nome Utente Admin",
        },
        report: {
            incomingMessages: "Messaggi in arrivo",
            outgoingMessages: "Messaggi in uscita",
            customerCount: "Conteggio clienti",
            mailCount: "Conteggio posta",
            answered: "Rispondere",
            unanswered: "Senza risposta",
            selectaChannel: "selezionare un canale",
            sentMails: "Correos enviados",
            sentMailCount: "Número de correos enviados",
            eventCount: "Numero di eventi",
            ticketDistribution: "Distribuzione dei biglietti",
            selectWorkflow: "Selezionare il flusso di lavoro",
            distributionOfTasks: "Distribuzione delle attività",
            mostMissioned: "La maggior parte delle missioni",
            leastTask: "Compiti minimi",
            totalNumberTasks: "Numero totale di compiti",
            erorFetchingTask: "Errore nella ricezione dei dati dell'attività:",
            pipelinePhase: "Fase della pipeline",
            status: "Stato",
            numberOfTasks: "Numero di task",
            insufficientData: "Dati non sufficienti",
            hourly: "(Orario)",
            hourlyAverage: "Media oraria",
            hourlyMax: "Massimo orario",
            hourlyMin: "Minimo orario",
            totalAmount: "Importo Totale",
            averageAmount: "Importo Medio",
            minAmount: "Importo Minimo",
            maxAmount: "Importo Massimo",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Serie temporali dei canali",
            channelPies: "Torte dei canali",
            pieView: "Grafico a torta",
            topVisitorCountry: "Paese con più visitatori",
            websiteTrafficByCountry: "Traffico del sito web per Paese",
            visitorCount: "Numero di visitatori",
            websiteVisitorTraffic: "Traffico visitatori del sito web",
            websiteTraffic: "Traffico del sito web",
            author: "Autore",
            topWorstComments: "Commenti Peggiori",
            topBestComments: "Commenti Migliori",
            topComments: "Commenti Migliori",
            noComment: "Nessun commento ancora",
            minWaitingTime: "Tempo di attesa minimo",
            maxWaitingTime: "Tempo di attesa massimo",
            averageWaitTime: "Tempo di attesa medio",
            waitTime: "Tempo di attesa (secondi)",
            agentWaitDurationTitle: "Grafico della durata di attesa dell'agente",
            incomingMessage: "Messaggio(i) in arrivo",
            outgoingMessage: "Messaggio(i) in uscita",
            totalSpent: "Totale speso",
            avgSpent: "Media spesa",
            totalPayment: "Pagamento totale",
            walletStatus: "Stato del portafoglio",
            walletBalanceStatus: "Stato del saldo del portafoglio",
            messageTraffic: "Traffico di messaggi",
            breakCount: "Conteggio delle pause",
            agentBreakTime: "Conteggi delle pause dell'agente ☕",
            agentStatusHour: "Ora dello stato dell'agente",
            agentWorkTimeCalendar: "Calendario del tempo di lavoro dell'agente",
            agentActivity: "Attività dell'agente",
            noEnoughtData: "Dati non sufficienti",
            averageFirstResponse: "Tempo medio di prima risposta",
            slowestResponser: "Più lento a rispondere",
            fastestResponder: "Più veloce a rispondere",
            firstAnswerTimeSec: "Tempo del primo messaggio (in secondi)",
            firstAnswerByAgent: "Tempo del primo messaggio da parte dell'agente",
            averageSolutionTime: "Tempo medio di soluzione",
            slowestSolver: "Risoluzione più lenta",
            fastestSolver: "Risoluzione più veloce",
            averageChat: "Chat media",
            leastChatReceiver: "Ricevitore di chat meno attivo",
            mostChatRecipients: "Il maggior numero di destinatari della chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Tempo di risoluzione (min)",
            resolveTimeByUser: "Tempo di risoluzione della chat per l'utente (in minuti)",
            chatResolveTimeByAgent: "Tempo di risoluzione della chat per gli agenti",
            chatDistByHandleType: "Distribuzione chat per handler",
            chatDistByHandDesc: "Quanti chat sono state gestite da agenti, chatbot e ibridi?",
            chatCountsByHandleType: "Numero di chat per tipo di gestione",
            missed: "Perso",
            chatDistByAnsDesc: "Quante chat sono state risposte o perse?",
            chatCountsByAns: "Conteggio chat per risposta",
            chatCountByPlatform: "Conteggio chat per piattaforma",
            chatDistByPDesc: "Quanti chat sono arrivate su quale piattaforma?",
            chatDistByPlatform: "Distribuzione della chat per piattaforma",
            ticketCountByUser: "Conteggio dei biglietti da parte degli agenti",
            ticketCountByStatus: "Conteggio dei ticket per stato di risposta",
            user: "Utente",
            saveAsImage: "Salva come immagine",
            fullScreen: "Schermo intero",
            download: "Scarica",
            tableView: "Vista tabella",
            chartView: "Vista grafico",
            chatDistByUsers: "Distribuzione delle chat per utenti",
            chatCountsByUsers: "Conteggio delle chat per utenti",
            minDuration: "Durata minima",
            maxDuration: "Durata massima",
            totalDurationByAgent: "Durata totale della sessione per agente",
            averageDurationByAgent: "Durata media della sessione per agente",
            totalDurationByCB: "Durata totale della sessione per chatbot",
            averageDurationByCB: "Durata media della sessione per chatbot",
            viewUnitAs: "Visualizza unità come",
            hybrid: "Ibrido",
            handledBy: "Gestito da",
            sessionDurationOverall: "Durata complessiva della sessione",
            allChannels: "Tutti i Canali",
            sessionsDurationOverall: "Durata complessiva delle sessioni",
            sessionsOverall: "Sessioni complessive",
            calendarEvents: "Eventi del calendario",
            reservationEvents: "Eventi di prenotazione",
            incomingMails: "Mail in arrivo",
            incomingMailCount: "Conteggio delle mail in arrivo",
            reservation: "Prenotazione",
            event: "Evento",
            reservationEventCount: "Numero di eventi di prenotazione",
            channelBreakdown: "Ripartizione dei canali",
            websiteAnalysis: "Analisi del sito web",
            customerSatisfaction: "Soddisfazione del cliente",
            teamBreakAnalysis: "Analisi delle pause del team",
            dailyAgentActivity: "Attività quotidiana dell'agente",
            agentPerformance: "Prestazioni dell'agente",
            chatDistributions: "Distribuzione delle chat",
            users: "Utenti",
            segmentTimeseries: "Serie temporale del segmento",
            segmentsOverall: "Segmenti Complessivi",
            unmatchRatio: "Rapporto di non corrispondenza",
            totalMatchCount: "Conteggio totale delle corrispondenze",
            totalUnmatchCount: "Conteggio totale delle non corrispondenze",
            matchRatio: "Rapporto di corrispondenza",
            matched: "Abbinato",
            trainingOverall: "Formazione Complessiva",
            trainingStatusTimeseries: "Serie temporale dello stato di formazione",
            duration: "Durata",
            totalSessionDuration: "Durata totale della sessione",
            averageSessionDuration: "Durata media della sessione",
            second: "secondo",
            minute: "minuto",
            hour: "ora",
            aggregateAs: "Aggrega come",
            chatbotSessionDurationOverall: "Durata complessiva della sessione del chatbot",
            ratingTimeSeries: "Serie temporale delle valutazioni",
            chatCountTimeseries: "Serie temporale del numero di chat",
            notRated: "Non valutato",
            totalRatingCount: "Numero totale di valutazioni",
            averageRating: "Valutazione media",
            weightedAverageRating: "Valutazione media ponderata",
            rate: "Valuta",
            ratingOverall: "Valutazioni dei clienti in generale",
            session: "Sessione",
            total: "Totale",
            average: "Media",
            max: "Massimo",
            min: "Minimo",
            sessionCount: "Conteggio sessioni",
            uniqueUsers: "Utenti Unici",
            viewAs: "Visualizza come:",
            overall: "Complessivo",
            detailReport: "Rapporto Dettagliato",
            dailyReports: "Rapporti Giornalieri",
            pointBasedReports: "Rapporti Basati su Punti",
            personDateBasedPointReport: "Rapporto Punti Basato su Persona e Data",
            personDateBasedReport: "Rapporto Basato su Persona e Data",
            personBasedReport: "Rapporto Basato su Persona",
            personAndDateBasedGraph: "Grafico Basato su Persona e Data",
            noReport: "Nessun Rapporto",
            reports: "Rapporti",
            totalBar: "Barra Totale",
            ticketCount: "Ticket Count",
        },
        announcements: {
            menu: "Annunci",
            newAnnouncementForm: "Nuovo Modulo di Annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento annuncio",
        },
        stats: {
            total: "Totale: È il numero di conversazioni attive nel sistema.",
            active: "Attive: È il numero di conversazioni attive che ti appartengono.",
            waiting: "In attesa: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante.",
            late: "In ritardo: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante dopo un certo periodo di tempo.",
            free: "Libere: È il numero di conversazioni in attesa di assegnazione di un nuovo rappresentante dopo che il precedente ha terminato.",
            pco: "[Personel Çalışma Oranı]: È il tasso di occupazione delle conversazioni totali che i rappresentanti online possono gestire nel sistema.",
            maxCapacity:
                "Capacità massima: È il numero massimo di conversazioni che il sistema può gestire senza mettere in attesa.",
            chatbot: "Chatbot: È il numero di conversazioni attive gestite dal chatbot.",
        },
        time: {
            lastYear: "L'anno Scorso",
            thisYear: "Quest'anno",
            last3Months: "Ultimi 3 Mesi",
            last7: "Ultimi 7 Giorni",
            today: "Oggi",
            yesterday: "Ieri",
            lastWeek: "Settimana scorsa",
            currentWeek: "Questa settimana",
            currentMonth: "Questo mese",
            lastMonth: "Mese scorso",
            last30Day: "Ultimi 30 giorni",
            allTime: "Sempre",
            custom: "Periodo personalizzato",
        },
        fastWizard: {
            generalColors: "Colori generali",
            tellUsMore: "Forniscici ulteriori informazioni per personalizzare la tua esperienza",
            moreInfo: "Impostazioni generali",
            display: "Impostazioni del tema",
            availability: "Orari di disponibilità degli operatori",
            preview: "Anteprima",
            installCode: "Installazione",
            previous: "Passaggio precedente",
            setupSupsisLiveChat: "Configurazione rapida di SUPSIS LIVE Chat",
            continue: "Passaggio successivo",
            completeInitialize: "Completa l'inizializzazione rapida",
            completedMessage: "Configurazione rapida di SUPSIS Live Chat completata con successo.",

            websiteIntegration: "Indirizzo del tuo sito web per l'integrazione di SUPSIS Live",

            customizeLiveChat: "Personalizza la chat dal vivo",
            createBrandedExperience: "Crea un'esperienza di chat personalizzata per i visitatori.",
            chatColor: "Colore della chat",
            chooseChatColor: "Scegli un colore.",
            chatBubble: "Bolla di chat",
            selectBubble: "Seleziona una bolla di chat",
            chatBubbleColor: "Colore della bolla di chat",
            selectChatBubbleColor: "Seleziona il colore della bolla di chat",
            customSelection: "Selezione personalizzata:",

            onlineSupportVisitorTime: "In quali fasce orarie fornisci assistenza ai visitatori?",
            channelAvailability: "Disponibilità del canale",
            availability724: "Servizio continuativo 24/7",
            basedOnTeam: "In base agli orari di lavoro degli operatori",
            basedOnTeamExplanation:
                "La chat sarà disponibile online quando ci sarà almeno 1 operatore online. Se non ci sono operatori online, apparirà come offline",
            customHours: "Orari di lavoro personalizzati",
            customHoursExplanation: "Imposta i tuoi orari di lavoro",
            customHoursTimezone: "Fuso orario:",
            customHoursFrom: "Da:",
            customHoursTo: "A:",
            customHoursAddHours: "+ Aggiungi ora",

            previewDesktop: "Desktop",
            previewIpad: "Tablet",

            installationAndInstructions: "Installazione e istruzioni",
            installationTrackingCode: "Carica il codice di monitoraggio sul tuo sito web",
            installationTrackingCodePlease:
                "Incolla il codice sottostante subito prima della chiusura del tag {bodyTag} su qualsiasi pagina in cui desideri attivare SUPSIS Live Chat.",
            installationInstructionsJavascript:
                "Incolla il codice di integrazione fornito sopra all'interno del tag {bodyTag}, subito prima della chiusura.",
            installationInstructionsShopify1: "1. Accedi al pannello di controllo di Shopify",
            installationInstructionsCopy: "Copia",
            installationInstructionsCoppyMessage: "Le istruzioni di integrazione sono state copiate negli appunti",
            installationInstructionsShopify2:
                "2. Vai a Online Store > Temi > Azioni, seleziona Current Theme > Modifica codice > theme.liquid",
            installationInstructionsShopify3:
                "3. Incolla il codice di integrazione fornito sopra subito prima del tag {bodyTag} alla fine dello script theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Accedi al pannello di amministrazione di IdeaSoft",
            installationInstructionsIdeaSoft2: "2. Vai su Impostazioni > SEO > Servizi per i motori di ricerca",
            installationInstructionsIdeaSoft3: '3. Seleziona l\'opzione "Convalida del sito tramite tag meta".',
            installationInstructionsIdeaSoft4:
                "4. Incolla il codice di integrazione fornito sopra nella casella aperta e salva.",
            installationInstructionsIdeaSoft5:
                '5. Vai su Impostazioni > Ottimizzazioni > "Cancella cache". L\'integrazione è completata.',
            installationInstructionsWordPress1: "1. Accedi al pannello di amministrazione di WordPress",
            installationInstructionsWordPress2: "2. Vai su Aspetto > Editor di Temi",
            installationInstructionsWordPress3:
                "3. Trova e seleziona il file del piè di pagina (footer.php) nella sezione File del tema (a destra)",
            installationInstructionsWordPress4:
                "4. Incolla il codice di integrazione fornito sopra prima del tag {bodyTag} nella parte inferiore del file.",
            installationInstructionsWordPress5: "5. Clicca su Aggiorna file per salvare le modifiche",
            installationInstructionsOpenCart1: "1. Accedi al pannello di amministrazione di OpenCart",
            installationInstructionsOpenCart2: "2. Vai su Design > Editor di Temi",
            installationInstructionsOpenCart3: "3. Seleziona la cartella 'common' e apri il file 'header.twig'",
            installationInstructionsOpenCart4:
                "4. Incolla il codice di integrazione fornito sopra prima del tag {headTag} nella parte superiore del file.",
            installationInstructionsOpenCart5: "5. Clicca su Salva",
            installationInstructionsTicimax1: "1. Accedi al pannello di amministrazione di Ticimax",
            installationInstructionsTicimax2: "2. Vai su Design > Impostazioni di design > Header/Footer Design",
            installationInstructionsTicimax3: "3. Fai clic sul pulsante 'Sorgente' nel design del logo.",
            installationInstructionsTicimax4:
                "4. Incolla il codice di integrazione fornito sopra sotto il codice HTML.",
            installationInstructionsEticaretteyim1: "1. Accedi al pannello di amministrazione di Eticaretteyim",
            installationInstructionsEticaretteyim2:
                "2. Vai su Moduli > Genera HTML > Dai un nome a SUPSIS e copia il codice.",
            installationInstructions: "Istruzioni",
            installationVerify: "Verifica l'installazione di SUPSIS sul tuo sito web",
            installationVerifyChecking: "Verifica in corso",
            installationVerifyCheck: "Verifica",
            installationVerifyCheckingStatus:
                "Controllo dello stato di integrazione di SUPSIS Live su {website} in corso",
            installationCheckingStatusMessageYes: "SUPSIS LIVE è integrato con successo su {website}.",
            installationCheckingStatusMessageNo:
                "SUPSIS non è attualmente integrato con il sito web {website}. Puoi completare il processo di integrazione ora o in seguito.",

            vtippyPreferredLanguage: "Lingua preferita:",
        },
        akinon: {
            typeOrSelectSKU: "Inserisci o seleziona l'SKU",
            akinonUserId: "ID utente Akinon",
            userEmail: "Email utente",
            userEmailDesc: "Inserisci o seleziona l'email dell'utente...",
            send: "Invia",
            selectCity: "Seleziona città",
            city: "Città",
            selectState: "Seleziona stato",
            state: "Stato",
            useMap: "Usa mappa",
            chooseAddress: "Seleziona indirizzo",
            selectCountry: "Seleziona Paese",
            country: "Paese",
            productIdDesc: "Inserisci o seleziona l'ID del prodotto...",
            productId: "ID prodotto",
            userIdDesc: "Inserisci l'ID utente Akinon...",
            productSKU: "SKU prodotto",
            latitudeDesc: "Inserisci o seleziona la latitudine della posizione di destinazione...",
            longitudeDesc: "Inserisci o seleziona la longitudine della posizione di destinazione...",
            orderNumber: "Numero d'ordine",
            orderDesc: "Inserisci il numero d'ordine...",
            longitude: "Longitudine",
            latitude: "Latitudine",
        },
        probel: {
            branchCode: "Codice filiale",
            branchCodeDesc: "Inserisci o seleziona il codice filiale...",
            hospitalBranchCode: "Codice del reparto ospedaliero",
            hospitalBranchCodeDesc: "Inserisci o seleziona il codice del reparto ospedaliero...",
            clinicCode: "Codice clinica",
            clinicCodeDesc: "Inserisci o seleziona il codice della clinica...",
            date: "Data appuntamento",
            dateDesc: "Inserisci o seleziona la data dell'appuntamento...",
            patientToken: "Token del paziente",
            patientTokenDesc: "Inserisci o seleziona il token del paziente...",
            appointmentId: "ID appuntamento",
            appointmentIdDesc: "Inserisci o seleziona l'ID dell'appuntamento...",
            identityType: "Tipo di documento d'identità",
            identityNumber: "Numero documento d'identità",
            name: "Nome del paziente",
            surname: "Cognome del paziente",
            gender: "Genere del paziente",
            birthDay: "Data di nascita del paziente",
            phoneNumber: "Numero di telefono del paziente",
            identityTypeDesc: "Inserisci o seleziona il tipo di documento d'identità...",
            identityNumberDesc: "Inserisci o seleziona il numero del documento d'identità...",
            nameDesc: "Inserisci o seleziona il nome del paziente...",
            surnameDesc: "Inserisci o seleziona il cognome del paziente...",
            genderDesc: "Inserisci o seleziona il genere del paziente...",
            birthDayDesc: "Inserisci o seleziona la data di nascita del paziente...",
            phoneNumberDesc: "Inserisci o seleziona il numero di telefono del paziente...",
        },
        headBar: {
            source: "Fonte",
            label: "Etichetta",
            completed: "Completato?",
            email: "Email",
            phone: "Telefono",
            name: "Nome",
            date: "Data",
            subject: "Oggetto",
            situation: "Situazione",
            representative: "Rappresentante",
            transactions: "Transazioni",
        },
        login: {
            loginTitle1: "Benvenuti alla",
            loginTitle2: "SUPSIS",
            email: "Indirizzo Email",
            emailPlaceholder: "Inserisci il tuo indirizzo email.",
            emailError: "Inserisci un indirizzo email valido",
            password: "Password",
            passwordLogin: "Accesso senza password",
            passwordAndLogin: "Accedi con password",
            passwordNew: "Resetta la mia password",
            loginAnd: "Oppure",
            passwordPlaceholder: "Inserisci la tua password.",
            loginMemory: "Ricorda questo dispositivo",
            passwordForget: "Ho dimenticato la password",
            passwordNewAgain: "Nuova password",
            passwordNewAgainTwo: "Conferma nuova password",
            passwordNewAgainPlaceholder: "Inserisci la tua nuova password.",
            passwordNewAgainPlaceholderTwo: "Conferma la tua nuova password.",
            login: "Accedi",
            loginFooter: "Oppure accedi tramite email",
            emailLogin: "Accedi tramite email",
        },
        settings: {
            ipAddress: "Il mio indirizzo IP",
            whiteList: "Elenco IP sicuro",
            whiteListAdd: "Aggiungi IP sicuro",
            whiteListDeletedSuccessfully: "Lista blanca eliminata correttamente",
            whiteListDeletedFailed: "Lista blanca non eliminata",
            whiteListAddedSuccessfully: "Lista blanca aggiunta correttamente",
            whiteListAddedFailed: "Lista blanca non aggiunta",
            deleteWhiteListTitle: "Sei sicuro di voler eliminare questa lista bianca?",
            talkSettings: "Impostazioni vocali",
            talkSubtitles: "Gestione delle impostazioni vocali",
            changeSettings: "Modifica delle impostazioni per l'assegnazione automatica delle chat",
            dateAndTime: "Data e ora",
            attore: "Attore",
            event: "Evento",
            accessControl: "Controllo degli accessi",
            organizationLongName: "Nome lungo dell'organizzazione",
            visitorNewDesc: "È possibile utilizzare la nuova versione del tema del visitatore",
            transactionType: "Tipo di transazione",
            priorBalance: "Saldo precedente",
            nextBalance: "Saldo successivo",
            amount: "Importo",
            phoneNumber: "Numero di telefono",
            profileInfoRemoved: "Informazioni sul profilo rimosse",
            newValueUpdated: "Nuovo valore aggiornato",
            ballanceToTransferred: "Saldo da trasferire",
            availableBalance: "Saldo disponibile",
            balanceReceived: "Saldo ricevuto",
            totalBalance: "Saldo totale",
            paymentCard: "Carta di pagamento",
            wpPhoneNumber: "Numero di telefono Whatsapp",
            wpSendingMessage: "Primo messaggio Whatsapp inviato",
            auditlogs: "Registri di controllo",
            myaccount: "Il mio account",
            notifications: "Notifiche",
            company: "Azienda",
            features: "Caratteristiche",
            general: "Generale",
            chat: "Chat",
            wallet: "portafoglio",
            timings: "Impostazioni di orario",
            language: "Lingua",
            "bubble-settings": "Impostazioni del palloncino di chat",
            "bubble-actions": "Funzionalità del palloncino di chat",
            "theme-settings": "Impostazioni del tema di chat",
            visitorLoginForm: "Modulo di accesso visitatori",
            visitorAttribute: "Informazioni sul profilo del visitatore",
            timing_settings: "Impostazioni di orario",
            auto_assign: "Auto Chat Assign",
            availability: "Orari di disponibilità dell'operatore",
            "website-integration": "Integrazione del sito web",
            General: "Generale",
            Chat: "Chat",
            Timings: "Impostazioni di orario",
            Integration: "Integrazione",
            developer: "Sviluppatore",
            ıntegration: "Integrazione",
            visitorNew: "Passaggio al nuovo design visitatori",
            companySubtitles: "Gestisci le informazioni generali dell'azienda.",
            featuresSubtitles: "Gestisci le funzionalità intelligenti di Supsis.",
            languageSubtitles: "Gestisci la lingua preferita dell'azienda.",
            bubbleSettings: "Impostazioni del palloncino di chat",
            bubbleSettingsSubtitles: "Gestisci le impostazioni del palloncino di chat.",
            bubbleActionsSubtitles:
                "Espandi le funzionalità del palloncino di chat. Puoi condividere con i visitatori le informazioni relative a WhatsApp, email e telefono della tua azienda.",
            chatThemeSettingsSubtitles: "Gestisci le impostazioni del tema di chat.",
            visitorLoginFormSubtitles: "Gestisci le impostazioni del modulo di accesso visitatori.",
            chatTimingSettingsSubtitles:
                "Impostazioni di durata della chat: controlli e opzioni di durata della conversazione.",
            webSiteIntegrationSubtitles: "Aggiungi un palloncino di chat al tuo sito web.",
            apiAccessTitle: "Accesso API",
            apiAccessSubtitles: "Puoi accedere al tuo codice token da qui.",
            youTubeActionForm: "Aggiungi il tuo canale YouTube",
            linkedinActionForm: "Aggiungi il tuo account Linkedin",
            telegramActionForm: "Aggiungi un account Telegram",
            facebookActionForm: "Aggiungi la tua pagina Facebook",
            tiwitterActionForm: "Aggiungi il tuo account Twitter",
            instagramActionForm: "Aggiungi il tuo account Instagram",
            liveSupportDescription: "Apri una chat in diretta con i tuoi clienti",
            ticketDescription: "Apri una chat in diretta con i tuoi clienti",
            whatsappDescription: "Permetti ai tuoi clienti di contattarti tramite WhatsApp",
            phoneDescription: "Permetti ai tuoi clienti di contattarti telefonicamente",
            emailDescription: "Permetti ai tuoi clienti di contattarti via email",
            facebookDescription: "Permetti ai tuoi clienti di contattarti tramite Facebook",
            twitterDescription: "Permetti ai tuoi clienti di contattarti tramite Twitter",
            instagramDescription: "Permetti ai tuoi clienti di contattarti tramite Instagram",
            youtubeDescription: "Permetti ai tuoi clienti di contattarti tramite YouTube",
            linkedinDescription: "Consenti ai tuoi clienti di raggiungerti con LinkedIn",
            telegramDescription: "Consenti ai tuoi clienti di raggiungere le dimensioni con Telegram",
            whatsappModalTitle: "Modulo di azione di WhatsApp",
            whatsappModalDescription: "Compila il seguente modulo per collegare il tuo account WhatsApp.",

            phoneModalTitle: "Modulo di azione telefonica",
            phoneModalDescription: "Compila il seguente modulo per collegare il tuo numero di telefono.",
            emailModalTitle: "Modulo di azione email",
            emailModalDescription: "Compila il seguente modulo per collegare il tuo account email.",
            facebookModalTitle: "Modulo di azione di Facebook",
            facebookModalDescription: "Compila il seguente modulo per collegare il tuo account Facebook.",
            twitterModalTitle: "Modulo di azione di Twitter",
            twitterModalDescription: "Compila il seguente modulo per collegare il tuo account Twitter.",
            instagramModalTitle: "Modulo di azione di Instagram",
            instagramModalDescription: "Compila il seguente modulo per collegare il tuo account Instagram.",
            youtubeModalTitle: "Modulo di azione di YouTube",
            youtubeModalDescription: "Compila il seguente modulo per collegare il tuo account YouTube.",
            linkedinModalTitle: "Modulo di transazione LinkeIn",
            linkedinModalDescription: "Compila il modulo sottostante per collegare il tuo account LinkedIn.",
            telegramModalTitle: "Modulo di transazione Telegram",
            telegramModalDescription:
                "Inserisci il link del tuo profilo Telegram nel modulo sottostante per collegare il tuo account Telegram",
            instagramAlertTitle: "Integrazione Instagram richiesta",
            instagramAlertDesc: "Spiacente, la pagina che hai visitato verrà attivata quando integri il tuo Instagram.",
            instagramActivateText: "Andiamo, integriamo Instagram",
            remove: "Rimuovi",
            edit: "Modifica",
            connected: "Collegato",
            add: "Aggiungi",
            themeDescription: "Impostazioni del tema di chat.",
            fontDescription: "Impostazioni del carattere di chat.",
            emailTitle: "Inserisci il tuo indirizzo email",
            emailMessage: "Messaggio di invio email iniziale",
            isFabsAsIcon: "Mostra icone di menu.",
            chatBubbleTextSetting: "Impostazione del testo della bolla di chat",
            textOnChatBubble: "Puoi regolare le impostazioni del testo che appariranno nel fumetto della chat.",
            textToAppearOnChatBubble: "Testo da visualizzare nel fumetto della chat",
            newVisitorProfileInformation: "Nuove informazioni sul profilo del visitatore",
            newVisitorProfileInformationDescription:
                "Aggiunge nuovo valore alle informazioni del profilo del visitatore",
            create: "Creare",
            newAdd: "Aggiungere nuova",
            toInform: "Informare",
            toInformDescription:
                "Puoi abbinare i valori che aggiungi in questa pagina con il modulo di accesso del visitatore.",
            showVisitor: "Mostra visitatore",
            label: "Biglietto",
            text: "Scrivere",
            email: "E-mail",
            phone: "Telefono",
            number: "Numero",
            url: "URL",
            date: "Tempo",
            dropdown: "selezionabile",
            languageTimeZone: "Lingua e regione",
            timeZoneTitle: "Regione e fuso orario",
            timeZoneDescription: "Impostazioni di regione e fuso orario",
        },
        userInfoWidget: {
            userInformation: "Informazioni utente",
            fullName: "Nome e cognome",
            newValue: "Nuovo valore",
            newProfileInfo: "Nuove informazioni sul profilo",
            affiliatedRepresentatives: "Rappresentanti",
            preferredAgents: "Agente(i) preferito(i)",
            labels: "Etichette",
            agentNotes: "Note dell'agente",
            newNote: "Nuova Nota",
            note: "Nota",
            available: "nota disponibile.",
            systemInformation: "Informazioni di sistema",
            speechID: "ID vocale",
            customerVersion: "Versione cliente",
            IPAddress: "Indirizzo IP",
            pageVisited: "Pagina visitata",
            systemAndBrowser: "Sistema operativo e browser",
            countryAndLanguage: "Paese e lingua",
            clickToEdit: "Modifica Fare clic all'interno del post",
            adsYouAreInterestedIn: "Annunci di tuo interesse",
            detail: "Dettaglio",
            adsTitle: "Titolo",
            adUrl: "URL dell'annuncio",
            sourceID: "ID fonte",
            resourceType: "Tipo di risorsa",
            adsBody: "Contenuto",
            adsCreateDate: "Data di creazione",
            adsUpdateDate: "Data di aggiornamento",
        },
        newWizartV2: {
            generalSettings: "impostazioni generali",
            themeSettings: "Impostazioni tema",
            representativeWorkingHours: "Orario di lavoro rappresentativo",
            preview: "anteprima",
            setup: "Impostare",
            formStepTitle: "Forniscici maggiori informazioni in modo che possiamo personalizzare la tua esperienza",
            supsisEntergation: "Dove userai Supsis sul tuo sito web? :",
            goToNextStep: "Fai il prossimo passo",
            readytemplate: "Usa modello di colore pronto",
            customSettings: "Impostazioni personalizzate",
            customerMessageView: "Messaggio del cliente Visualizza",
            backcgroundColor: "Colore di sfondo",
            textColor: "Colore del carattere",
            agentMessageView: "Vista messaggio agente",
            workingHours: "Con quali intervalli di tempo fornisci servizi ai tuoi visitatori?",
            continuousService: "Servizio continuo",
            continuousServiceDescription: "La bolla della chat è sempre attiva. Anche se non sei nel sistema.",
            vote: "Fate la vostra scelta",
            representativeWorking: "Temsilci Çalışma Saatleri Dahilinde",
            representativeWorkingDescription:
                "La chat appare online quando almeno 1 agente è online. Se non è presente un rappresentante online, verrà visualizzato come offline.",
            computer: "Computer",
            tablet: "Tavoletta",
            uploadTrackingCodeToYourWebsite: "Carica il codice di monitoraggio sul tuo sito web",
            password: "Imposta nuova password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Canali Whatsapp V1 (QR)",
            whatsappTitleV2: "Canali Whatsapp V2 (QR)",
            channelName: "Nome Canale",
            phoneNumber: "Numero di Telefono",
            forwardToChatbot: "Inoltra al Chatbot",
            forwardingChatbotOrLiveAgent: "Inoltro (Chatbot o Agente Live)",
            addChannel: "Aggiungi Canale",
            newWhatsappChannel: "Nuovo Canale WhatsApp",
            newWhatsappChannelDescription: "Crea un nuovo canale WhatsApp scansionando il codice QR",
            editWhatsappChannel: "Modifica Canale WhatsApp",
            editWhatsappChannelDescription: "Modifica canale WhatsApp",
            whatsappChannel: "Canale WhatsApp",
            deleteWhatsappChannelDescription: "Sei sicuro di voler eliminare questo canale?",
            whatsappIntegration: "Integrazione WhatsApp",
            deleteChannel: "Elimina Canale",
            restartChannel: "Riavvia Canale",
            wantRestartChannel: "Vuoi riavviare il canale?",
            deleteSMSChannelDescription: "Sei sicuro di voler eliminare il canale SMS?",
            smsChannel: "Canale SMS",
            maxChannelCount: "Non puoi creare più di un canale SMS!",
            smsModalText:
                "La nostra integrazione con le moderne soluzioni di comunicazione ti dà l'opportunità di inviare SMS in modo semplice ed efficace. Elimina i confini nella comunicazione, connettiti direttamente con i tuoi clienti!",
            smsModalBtn: "Fare clic per aprire il canale SMS...",
            postaCellDetail: "Dettagli canale PostaCell",
        },
        noPermission: "Non hai il permesso di eseguire questa operazione.",
        mail_integration_detail: {
            title: "Dettagli della posta",
            integration: "Integrazione",
            sender: "Email del mittente",
            signature: "Firma",
            inbox: "Posta in arrivo",
            medias: "Media",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            contacts: "Contatti",
        },
        whatsapp_business_api: {
            userVisibility: "Visibilità utente",
            userVisibilityDesc:
                "I canali a cui gli utenti possono accedere dipendono dal loro ruolo e dalle impostazioni di visibilità del canale. Gli utenti con il ruolo di amministratore completo o di root possono vedere tutti i canali. Se le impostazioni di visibilità di un canale sono vuote, il canale è pubblico. Tuttavia, se il canale è definito per utenti o reparti specifici, solo gli utenti o i membri del reparto possono vedere il canale.",
            searchTemplate: "Modello di ricerca...",
            forwardToChatbot: "Inoltro al Chatbot",
            forwarding: "Inoltro (Chatbot o Live Agent)",
            forwardLiveAgents: "Inoltro all'assistenza live",
            forwardingToDepartment: "Inoltro al reparto",
            selectDepartment: "Selezionare il reparto",
            createWbChannel:
                "Per creare un canale Whatsapp Business, è necessario acquistare un pacchetto Whatsapp Business. È possibile accedere immediatamente ai pacchetti a prezzi accessibili",
            wbCreateChannelMax: "Hai raggiunto il limite di creazione di canali Whatsapp Business. Massimo",
            wbContinue:
                "È possibile creare un canale Whatsapp Business. Per continuare, aggiornare il pacchetto o eliminare alcuni dei canali Whatsapp Business",
            chatInitiatorTemplate: "Modello di iniziatore di chat",
            selectChatInitiatorTemplate: "Selezionare il modello di iniziatore di chat",
            dailyUsageReport: "Rapporto di utilizzo giornaliero",
            freeChat: "Chat gratuita",
            paidChat: "Chat a pagamento",
            templateMessage: "Messaggio modello",
            outgoingSession: "Sessione in uscita",
            incomingSession: "Sessione in arrivo",
            totalCost: "Costo totale",
            allOptNumbers: "Tutti i numeri opt-in",
            startChat: "Inizio chat",
            lastMessageDate: "Data ultimo messaggio",
            sureDeleteTemplate: "Sei sicuro di voler cancellare questo modello?",
            manageWhoChannelChat: "Gestisci chi può vedere queste chat di canale",
            profileImageDesc: "Questo sarà uno screenshot WhatsApp della tua attività.",
            businessDescription: "Descrizione dell'azienda.",
            descOfWork: "Descrizione della tua attività in poche parole (massimo 512 caratteri).",
            accountStatus: "Stato del conto.",
            dockerStatus: "Stato di Docker.",
            phoneQuality: "Qualità del telefono.",
            customersOrDay: "CustomersDay.",
            messagingLimit: "Limite di messaggistica.",
            canSendMessage: "Il messaggio può essere inviato.",
            officialDetails: "Dettagli ufficiali.",
            officialDetailsDesc:
                "Questi indirizzi saranno sempre mostrati nella sezione del profilo agli utenti che chattano con voi su WhatsApp. Dopo averli modificati, li invieremo a WhatsApp per l'approvazione.",
            addressLine: "Indirizzo.",
            stateIfApplic: "Stato (se applicabile).",
            zipCodeOrPostCode: "Codice postale.",
            selectCountry: "Seleziona Paese.",
            selectBussVertical: "Selezionare l'area commerciale.",
            saveInfo: "Salva informazioni.",
            active: "Attivo.",
            banned: "Vietato.",
            low: "Basso.",
            medium: "Medio.",
            high: "Alto.",
            connected: "Connesso.",
            disConnected: "Disconnesso.",
            flagged: "Flagged.",
            pending: "In attesa.",
            restricted: "Limitato.",
            unknown: "Sconosciuto.",
            available: "Disponibile.",
            limited: "Limitato.",
            blocked: "Bloccato.",
            success: "Successo.",
            successDesc: "Le informazioni del profilo sono state aggiornate con successo.",
            wabaOverview: "Panoramica della salute WABA.",
            manageChannelDetail: "Gestisci le informazioni del tuo canale.",
            wpBussChannelDetail: "Dettaglio canale Whatsapp Business.",
            manageWpBussChannel: "Gestisci il tuo canale Whatsapp business.",
            channelName: "Nome del canale.",
            phoneNumberE164: "Numero di telefono (formato E164).",
            phoneNumberE164Place: "Numero di telefono (formato E164), ad esempio 908501234455.",
            channelUpdatedSucs: "Canale aggiornato con successo.",
            failedUpdateChannel: "Canale non aggiornato.",
            title: "Canali Whatsapp Business API",
            integration: "Integrazione",
            detail: "Dettaglio",
            visibility: "Visibilità",
            templates: "Tutti i Messaggi Modello",
            settings_group: "Impostazioni",
            template_message_group: "Messaggi Modello",
            chat_initiator_template: "Modello di inizio chat",
            contacts: "Contatti",
            numbers: "Numeri",
            all_contacts: "Tutti i contatti",
            new_template: "Crea nuovo Modello",
            broadcast_group: "Trasmissione",
            broadcast_requests: "Richieste di Trasmissione",
            customer_groups: "Gruppi Clienti",
            businessChannelDetail: "Dettagli del canale Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Invia SMS",
            postacellAllMessage: "Invia SMS di massa",
            message_group: "Messaggio",
            createNewTemplate: "Crea nuovo messaggio modello",
            templateName: "Nome del modello",
            templateNameDesc: "Dai un nome al tuo modello di messaggio.",
            templateInfo: "Informazioni sul modello",
            viewTemplates: "Visualizza modelli",
            templateNameRules: "Il nome del modello può includere solo lettere minuscole, numeri e trattini bassi.",
            category: "Categoria",
            categoryDesc: "Seleziona il tipo di modello che desideri creare",
            categoryUtility: "Utilità",
            categoryUtilityDesc:
                "Invia informazioni di utilità come aggiornamenti dell'account, aggiornamenti degli ordini, avvisi e altro.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Invia offerte promozionali, offerte di prodotti e altro per aumentare la consapevolezza e l'interazione.",
            categoryAuth: "Autenticazione",
            categoryAuthDesc: "Invia codici per consentire ai tuoi clienti di accedere ai loro account.",
            optional: "Opzionale",
            languageDesc: "Seleziona la lingua in cui verrà inviato il tuo messaggio di modello",
            header: "Intestazione",
            headerRules:
                "Aggiungi un'intestazione di 60 caratteri al tuo messaggio. Nell'intestazione è supportata solo una variabile.",
            headerOptionMedia: "Media",
            headerOptionText: "Testo",
            none: "Nessuno",
            headerType: "Tipo di intestazione",
            headerText: "Testo dell'intestazione",
            body: "Corpo",
            bodyRules: "Inserisci il testo nella lingua che hai scelto per il tuo messaggio",
            addVariable: "Aggiungi variabile",
            variables: "Variabili",
            variable: "Variabile",
            defaultVariableName: "Nome variabile predefinito",
            defaultVariableToolTip:
                "La tua variabile appare nel template con questo nome. <br><br> Inoltre, questo valore viene inviato come predefinito in caso di altre situazioni.",
            selectATemplate: "Seleziona un modello di messaggio",
            variableSettings: "Impostazioni variabili",
            example: "Esempio",
            footer: "Piè di pagina",
            footerDesc:
                "Aggiungi un piè di pagina di 60 caratteri al tuo messaggio. Le variabili non sono supportate nel piè di pagina.",
            buttons: "Pulsanti",
            buttonType: "Tipo di pulsante",
            buttonTypeReply: "Rispondi",
            submit: "Salva",
            submitting: "Invio in corso",
            addButton: "Aggiungi pulsante",
            rejectWhatsapp: "Respinto da Whatsapp.",
            approvedWhatsapp: "Approvato da Whatsapp.",
            pendingWhatsapp: "In attesa di approvazione",
            daily_usages: "Utilizzi giornalieri",
        },
        multi_whatsapp_api: {
            profile: "Profilo",
            integration: "Integrazione",
            detail: "Dettaglio",
            visibility: "Visibilità",
            templates: "Tutti i messaggi dei modelli",
            settings_group: "Setting",
            template_message_group: "Messaggi template",
            new_template: "Crea nuovo modello",
            broadcast_group: "Bulk Message",
            broadcast_requests: "Invio di messaggi in blocco",
            customer_groups: "Gruppi di clienti",
            chat_initiator_template: "Chat Initiator Template",
            contacts: "Contatti",
            numbers: "Numeri",
            all_contacts: "Tutti i contatti",
        },
        archive: {
            destroyedBy: {
                agent: "Agente",
                visitor: "Visitatore",
                system: "Sistema",
                chatbot: "Chatbot",
            },
        },
        upgradeMessages: {
            ticket: "Anche se sei offline, le tue richieste vengono registrate istantaneamente con l'intelligenza artificiale e il chatbot. Mantieni sempre i tuoi clienti soddisfatti!",
            tasks: "Gestisci facilmente le tue attività e i tuoi progetti. Collabora con il tuo team e consegna i progetti in tempo!",
            calendar:
                "Pianifica facilmente i tuoi appuntamenti e riunioni. Rimani sincronizzato con il tuo team e gestisci meglio il tuo tempo!",
            mail_integration:
                "Gestisci facilmente le tue e-mail. Rafforza la comunicazione con i tuoi clienti e migliora la collaborazione!",
            team_integration:
                "Comunica più velocemente ed efficacemente con il tuo team. Migliora la collaborazione e assicurati di consegnare i progetti in tempo!",
            webhook_integration:
                "Collega le tue applicazioni utilizzando l'integrazione Webhook e semplifica lo scambio di dati!",
            whatsapp_v2:
                "Migliora la comunicazione con i tuoi clienti tramite l'integrazione di WhatsApp per una comunicazione più rapida ed efficiente!",
            whatsapp:
                "Migliora la comunicazione con i tuoi clienti usando l'integrazione di WhatsApp per una comunicazione più rapida ed efficace!",
            whatsapp_business_api:
                "Sfrutta l'API WhatsApp Business per comunicare in modo più efficiente ed efficace con i tuoi clienti!",
            instagram: "Interagisci più efficacemente con i tuoi clienti utilizzando l'integrazione di Instagram!",
            messenger: "Comunica facilmente con i tuoi clienti tramite l'integrazione di Messenger!",
            sms_postacell: "Comunica rapidamente ed efficacemente con i tuoi clienti tramite l'integrazione SMS!",
            ready_contents:
                "I contenuti pronti ti aiutano a comunicare con i tuoi clienti più velocemente ed efficacemente.",
            automation:
                "Automatizza i tuoi flussi di lavoro per risparmiare tempo e gestire le attività in modo più efficiente!",
            form: "Usa il costruttore di moduli per semplificare le interazioni con i clienti, raccogliere informazioni preziose e migliorare la collaborazione!",
            customer_tables: "Crea tabelle personalizzate e gestisci le informazioni dei clienti in modo efficiente!",
            trendyol:
                "Migliora la comunicazione con i tuoi clienti tramite l'integrazione Trendyol per un'interazione senza problemi!",
            access_control:
                "Proteggi i tuoi dati e impedisci l'accesso non autorizzato con le funzionalità di controllo degli accessi!",
            upgrade: "Aggiorna il mio abbonamento",
            upgradeFeature: "Acquista pacchetto aggiuntivo",
            featureNotAvailable: "La funzione non è disponibile.",
            usageLimitExceeded: "Limite di utilizzo superato.",
            maxAgentCount: "Aggiorna il tuo piano per servire più clienti aggiungendo più agenti.",
            maxTriggerCount: "Aggiorna il tuo piano per generare più interazioni aggiungendo più trigger.",
            visitorStartChat: "Aggiorna il tuo piano per avviare chat con visitatori che non hanno ancora interagito.",
            voiceCalling:
                "Aggiorna il tuo piano per comunicare in modo più efficace con i clienti tramite chiamate vocali.",
            videoCalling:
                "Aggiorna il tuo piano per comunicare in modo più efficace con i clienti tramite videochiamate.",
            fileAndVoiceMessage: "Aggiorna il tuo piano per inviare file e messaggi vocali ai clienti.",
            autoTranslation:
                "Aggiorna il tuo piano per servire più clienti grazie alla traduzione automatica dei messaggi.",
            telegramEntegration: "Aggiorna il tuo piano per abilitare l'integrazione con Telegram.",
            chatCopilot:
                "Aggiorna il tuo piano per offrire un servizio migliore grazie all'assistente di chat basato sull'intelligenza artificiale.",
            calenderEntegration: "Aggiorna il tuo piano per sincronizzare il calendario con altre applicazioni.",
            mailEntegration:
                "Aggiorna il tuo piano per gestire meglio le email e migliorare la comunicazione con i clienti.",
            smsEntegration:
                "Aggiorna il tuo piano per raggiungere i clienti più rapidamente tramite l'integrazione SMS.",
            ticketSystem: "Aggiorna il tuo piano per gestire meglio le richieste dei clienti con il sistema di ticket.",
            taskManagementEntegration:
                "Aggiorna il tuo piano per ottimizzare il flusso di lavoro con l'integrazione della gestione delle attività.",
            webhookEntegration: "Aggiorna il tuo piano per sincronizzare le altre applicazioni tramite webhook.",
            readyContents:
                "Aggiorna il tuo piano per migliorare la comunicazione con i clienti grazie ai contenuti predefiniti.",
            automationEntegration: "Aggiorna il tuo piano per automatizzare ulteriormente il flusso di lavoro.",
            customerTablesEntegration:
                "Aggiorna il tuo piano per gestire meglio le informazioni dei clienti con le tabelle clienti.",
            formEntegration: "Aggiorna il tuo piano per gestire meglio le richieste dei clienti con i moduli.",
            maxFormLimit: "Aggiorna il tuo piano per creare più moduli e gestire meglio le richieste dei clienti.",
            maxFormFieldLimit:
                "Aggiorna il tuo piano per aggiungere più campi ai moduli e migliorare la gestione delle richieste.",
            maxCustomerTableCount: "Aggiorna il tuo piano per aggiungere più tabelle clienti.",
            maxCustomerTableFieldCount: "Aggiorna il tuo piano per aggiungere più campi nelle tabelle clienti.",
            maxCustomerTableViewCount: "Aggiorna il tuo piano per salvare più viste delle tabelle clienti.",
            maxCustomerTableRecordCount: "Aggiorna il tuo piano per aggiungere più record nelle tabelle clienti.",
            maxAutomationButton: "Aggiorna il tuo piano per aggiungere più blocchi di automazione.",
            automationTimerBase: "Aggiorna il tuo piano per utilizzare timer di automazione.",
            automationEventBase: "Aggiorna il tuo piano per utilizzare eventi di automazione.",
            automationWebhookBase: "Aggiorna il tuo piano per utilizzare webhook di automazione.",
            automationButtonBase: "Aggiorna il tuo piano per utilizzare pulsanti di automazione.",
            liveScore: "Aggiorna il tuo piano per attivare la funzione di monitoraggio in tempo reale.",
            multipleChatWindow: "Aggiorna il tuo piano per aprire più finestre di chat contemporaneamente.",
            maxTaskWorkflowLimit: "Aggiorna il tuo piano per aggiungere più flussi di attività.",
            maxTaskColumnLimit: "Aggiorna il tuo piano per aggiungere più colonne nelle attività.",
            maxTaskRowLimit: "Aggiorna il tuo piano per aggiungere più righe nelle attività.",
            maxDepartmentLimit: "Aggiorna il tuo piano per aggiungere più dipartimenti.",
            maxRoleLimit: "Aggiorna il tuo piano per aggiungere più ruoli.",
            maxReadyContentsLimit: "Aggiorna il tuo piano per aggiungere più contenuti predefiniti.",
            excelDownload: "Aggiorna il tuo piano per abilitare il download di file Excel.",
            customerGroup: "Aggiorna il tuo piano per utilizzare la funzione dei gruppi di clienti.",
            maxMailCount: "Aggiorna il tuo piano per inviare più email.",
            maxWhatsappChannel: "Aggiorna il tuo piano per aggiungere più canali WhatsApp.",
            maxBusinessWhatsappChannel: "Aggiorna il tuo piano per aggiungere più canali WhatsApp Business.",
            maxInstagramChannel: "Aggiorna il tuo piano per aggiungere più canali Instagram.",
            maxMessengerChannel: "Aggiorna il tuo piano per aggiungere più canali Messenger.",
            maxTelegramChannel: "Aggiorna il tuo piano per aggiungere più canali Telegram.",
            maxTrendyolChannel: "Aggiorna il tuo piano per aggiungere più canali Trendyol.",
            maxMetaLeadChannel: "Aggiorna il tuo piano per aggiungere più canali Meta Lead.",
        },
    },
};

export default messagesIT;
